/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  _Any: { input: any; output: any; }
  federation__FieldSet: { input: any; output: any; }
  link__Import: { input: any; output: any; }
};

export enum Applicant_Role {
  CorrespondingAuthor = 'CORRESPONDING_AUTHOR',
  FirstAuthor = 'FIRST_AUTHOR',
  Other = 'OTHER',
  SecondAuthor = 'SECOND_AUTHOR'
}

export enum Application_Status {
  ApplicationFeePending = 'APPLICATION_FEE_PENDING',
  ConditionMeetLapsed = 'CONDITION_MEET_LAPSED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  DsrcAssessed = 'DSRC_ASSESSED',
  FailedProvisioning = 'FAILED_PROVISIONING',
  FrcsbAssessed = 'FRCSB_ASSESSED',
  GsAssessed = 'GS_ASSESSED',
  InNominationPool = 'IN_NOMINATION_POOL',
  Lapsed = 'LAPSED',
  Offered = 'OFFERED',
  OfferProvisioning = 'OFFER_PROVISIONING',
  Overdue = 'OVERDUE',
  PanelNominated = 'PANEL_NOMINATED',
  PartnerNominationPending = 'PARTNER_NOMINATION_PENDING',
  Registered = 'REGISTERED',
  RegistrationFeePending = 'REGISTRATION_FEE_PENDING',
  RegistrationFeeSettled = 'REGISTRATION_FEE_SETTLED',
  Returned = 'RETURNED',
  Submitted = 'SUBMITTED',
  SupervisorNominated = 'SUPERVISOR_NOMINATED',
  UnderDorpgs = 'UNDER_DORPGS',
  UnderDsrc = 'UNDER_DSRC',
  UnderFrcsb = 'UNDER_FRCSB',
  UnderGs = 'UNDER_GS',
  UnderHodDos = 'UNDER_HOD_DOS',
  UnderInterviewPanel = 'UNDER_INTERVIEW_PANEL',
  UnderPanel = 'UNDER_PANEL',
  UnderRegistration = 'UNDER_REGISTRATION',
  UnderSupervisor = 'UNDER_SUPERVISOR',
  Unsuccessful = 'UNSUCCESSFUL',
  Withdrawn = 'WITHDRAWN'
}

export type ArQualificationPaginatedPayload = {
  __typename?: 'ARQualificationPaginatedPayload';
  data: Array<ArQualificationPayload>;
  paginator: PaginatorPayload;
};

export type ArQualificationPayload = {
  __typename?: 'ARQualificationPayload';
  applicantEmail?: Maybe<Scalars['String']['output']>;
  applicantName: Scalars['String']['output'];
  applicantNationality: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  applicationNo: Scalars['String']['output'];
  conditionFulfilled: Scalars['Boolean']['output'];
  displayStatus?: Maybe<QualificationCheckStatus>;
  duration: Scalars['Float']['output'];
  entryYear: Scalars['String']['output'];
  isFirmOffer: Scalars['Boolean']['output'];
  offerDate: Scalars['DateTime']['output'];
  programme: Programme;
  programmeCode: Scalars['String']['output'];
  programmeType: Programme_Type;
  status: QualificationCheckStatus;
};

export type ArVisaPaginatedPayload = {
  __typename?: 'ARVisaPaginatedPayload';
  data: Array<ArVisaPayload>;
  paginator: PaginatorPayload;
};

export type ArVisaPayload = {
  __typename?: 'ARVisaPayload';
  applicantEmail?: Maybe<Scalars['String']['output']>;
  applicantName: Scalars['String']['output'];
  applicantNationality: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  applicationNo: Scalars['String']['output'];
  conditionFulfilled: Scalars['Boolean']['output'];
  duration: Scalars['Float']['output'];
  entryYear: Scalars['String']['output'];
  isFirmOffer: Scalars['Boolean']['output'];
  offerDate: Scalars['DateTime']['output'];
  programme: Programme;
  programmeCode: Scalars['String']['output'];
  programmeType: Programme_Type;
  /** @deprecated Use referenceNo instead. */
  referenceId?: Maybe<Scalars['String']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  status: VisaStatus;
};

export enum Award_Classification {
  Credit = 'CREDIT',
  Distinction = 'DISTINCTION',
  FirstClassHonours = 'FIRST_CLASS_HONOURS',
  HighestHonoursSummaCumLaude = 'HIGHEST_HONOURS_SUMMA_CUM_LAUDE',
  HighHonoursMagnaCumLaude = 'HIGH_HONOURS_MAGNA_CUM_LAUDE',
  HonoursCumLaude = 'HONOURS_CUM_LAUDE',
  Merit = 'MERIT',
  Others = 'OTHERS',
  Pass = 'PASS',
  SecondUpperDivisionIiClassHonours = 'SECOND_UPPER_DIVISION_II_CLASS_HONOURS',
  SecondUpperDivisionIClassHonours = 'SECOND_UPPER_DIVISION_I_CLASS_HONOURS',
  ThirdClassHonours = 'THIRD_CLASS_HONOURS'
}

export type AcademicAssessmentType = {
  __typename?: 'AcademicAssessmentType';
  academicQualificationReferenceId?: Maybe<Scalars['String']['output']>;
  convertedGPA?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  disciplineSpecificList?: Maybe<DisciplineSpecificList>;
  isFirstHonour?: Maybe<Scalars['Boolean']['output']>;
  nationalRanking?: Maybe<NationalRanking>;
  notApplicable: Scalars['Boolean']['output'];
  officialClassRanking?: Maybe<Scalars['Int']['output']>;
  outOfRank?: Maybe<Scalars['Int']['output']>;
  selectDisciplineSpecificList: Scalars['Boolean']['output'];
  selectNationalRanking: Scalars['Boolean']['output'];
  selectWorldSubjectRanking: Scalars['Boolean']['output'];
  selectWorldUniversityRanking: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  worldSubjectRanking?: Maybe<WorldSubjectRanking>;
  worldUniversityRanking?: Maybe<WorldUniversityRanking>;
};

export type AcademicAssessmentTypeInput = {
  academicQualificationReferenceId?: InputMaybe<Scalars['String']['input']>;
  convertedGPA?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  disciplineSpecificList?: InputMaybe<DisciplineSpecificListInput>;
  isFirstHonour?: InputMaybe<Scalars['Boolean']['input']>;
  nationalRanking?: InputMaybe<NationalRankingInput>;
  notApplicable: Scalars['Boolean']['input'];
  officialClassRanking?: InputMaybe<Scalars['Int']['input']>;
  outOfRank?: InputMaybe<Scalars['Int']['input']>;
  selectDisciplineSpecificList: Scalars['Boolean']['input'];
  selectNationalRanking: Scalars['Boolean']['input'];
  selectWorldSubjectRanking: Scalars['Boolean']['input'];
  selectWorldUniversityRanking: Scalars['Boolean']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  worldSubjectRanking?: InputMaybe<WorldSubjectRankingInput>;
  worldUniversityRanking?: InputMaybe<WorldUniversityRankingInput>;
};

export type AcademicQualification = {
  __typename?: 'AcademicQualification';
  academicCredentialIndicator?: Maybe<Scalars['Boolean']['output']>;
  academicOnlineVerificationCode?: Maybe<Scalars['String']['output']>;
  awardClassification?: Maybe<Award_Classification>;
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  certificates: Array<FileType>;
  classRankProofs: Array<FileType>;
  convertGPARuleId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  currentStudyYear: Scalars['Float']['output'];
  degreeCertIndicator?: Maybe<Scalars['Boolean']['output']>;
  degreeLevel: Degree_Level;
  degreeOnlineVerificationCode?: Maybe<Scalars['String']['output']>;
  expectUpdateDate?: Maybe<Scalars['DateTime']['output']>;
  from: Scalars['DateTime']['output'];
  gpaIndicator: Scalars['Boolean']['output'];
  institution: Institution;
  instructionMedium: Scalars['String']['output'];
  markConversion?: Maybe<MarkConversion>;
  markExplanations: Array<FileType>;
  marks?: Maybe<Array<Mark>>;
  officialClassRanking?: Maybe<Scalars['Float']['output']>;
  officialMark?: Maybe<Scalars['String']['output']>;
  otherDocuments: Array<FileType>;
  otherInstructionMedium?: Maybe<Scalars['String']['output']>;
  outOfGpa?: Maybe<Scalars['Float']['output']>;
  outOfRank?: Maybe<Scalars['Float']['output']>;
  presentIndicator?: Maybe<Scalars['Boolean']['output']>;
  programmeName: Scalars['String']['output'];
  qualificationMeans: Qualification_Means;
  qualificationStatus: Qualification_Status;
  rankIndicator: Scalars['Boolean']['output'];
  studyField: Scalars['String']['output'];
  studyMode: Studu_Mode;
  to?: Maybe<Scalars['DateTime']['output']>;
  transcripts: Array<FileType>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  withdrawDate?: Maybe<Scalars['DateTime']['output']>;
};

export type AcademicQualificationArrayFilter = {
  all?: InputMaybe<Array<AcademicQualificationArrayFilter>>;
  elemMatch?: InputMaybe<AcademicQualificationFilter>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

export type AcademicQualificationFilter = {
  _id?: InputMaybe<StringFilter>;
  academicCredentialIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  academicOnlineVerificationCode?: InputMaybe<StringFilter>;
  and?: InputMaybe<Array<AcademicQualificationFilter>>;
  awardClassification?: InputMaybe<AwardClassificationFilter>;
  awardDate?: InputMaybe<DateFilter>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  currentStudyYear?: InputMaybe<NumberFilter>;
  degreeCertIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  degreeLevel?: InputMaybe<DegreeLevelFilter>;
  degreeOnlineVerificationCode?: InputMaybe<StringFilter>;
  expectedUploadDate?: InputMaybe<DateFilter>;
  from?: InputMaybe<DateFilter>;
  gpaIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  institution?: InputMaybe<InstitutionFilter>;
  instructionMedium?: InputMaybe<StringFilter>;
  markConversion?: InputMaybe<MarkConversionFilter>;
  marks?: InputMaybe<MarkArrayFilter>;
  nor?: InputMaybe<Array<AcademicQualificationFilter>>;
  not?: InputMaybe<AcademicQualificationFilter>;
  officialMark?: InputMaybe<NumberFilter>;
  or?: InputMaybe<Array<AcademicQualificationFilter>>;
  otherInstructionMedium?: InputMaybe<StringFilter>;
  presentIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  programmeName?: InputMaybe<StringFilter>;
  qualificationMeans?: InputMaybe<QualificationMeansFilter>;
  qualificationStatus?: InputMaybe<QualificationStatusFilter>;
  rankIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  studyField?: InputMaybe<StringFilter>;
  studyMode?: InputMaybe<StudyModeFilter>;
  to?: InputMaybe<DateFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
  withdrawDate?: InputMaybe<DateFilter>;
};

export type AcademicQualificationPayload = {
  __typename?: 'AcademicQualificationPayload';
  _id: Scalars['ID']['output'];
  academicCredentialIndicator?: Maybe<Scalars['Boolean']['output']>;
  academicOnlineVerificationCode?: Maybe<Scalars['String']['output']>;
  awardClassification?: Maybe<Award_Classification>;
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  certificates: Array<FileType>;
  classRankProofs: Array<FileType>;
  convertGPARuleId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  currentStudyYear: Scalars['Float']['output'];
  degreeCertIndicator?: Maybe<Scalars['Boolean']['output']>;
  degreeLevel: Degree_Level;
  degreeOnlineVerificationCode?: Maybe<Scalars['String']['output']>;
  expectUpdateDate?: Maybe<Scalars['DateTime']['output']>;
  from: Scalars['DateTime']['output'];
  gpaIndicator: Scalars['Boolean']['output'];
  institution: Institution;
  instructionMedium: Scalars['String']['output'];
  markConversion?: Maybe<MarkConversion>;
  markExplanations: Array<FileType>;
  marks?: Maybe<Array<Mark>>;
  officialClassRanking?: Maybe<Scalars['Float']['output']>;
  officialMark?: Maybe<Scalars['String']['output']>;
  otherDocuments: Array<FileType>;
  otherInstructionMedium?: Maybe<Scalars['String']['output']>;
  outOfGpa?: Maybe<Scalars['Float']['output']>;
  outOfRank?: Maybe<Scalars['Float']['output']>;
  presentIndicator?: Maybe<Scalars['Boolean']['output']>;
  programmeName: Scalars['String']['output'];
  qualificationMeans: Qualification_Means;
  qualificationStatus: Qualification_Status;
  rankIndicator: Scalars['Boolean']['output'];
  studyField: Scalars['String']['output'];
  studyMode: Studu_Mode;
  to?: Maybe<Scalars['DateTime']['output']>;
  transcripts: Array<FileType>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  withdrawDate?: Maybe<Scalars['DateTime']['output']>;
};

export type AcademicQualificationSort = {
  _id?: InputMaybe<Sorting_Order>;
  academicCredentialIndicator?: InputMaybe<Sorting_Order>;
  academicOnlineVerificationCode?: InputMaybe<Sorting_Order>;
  awardClassification?: InputMaybe<Sorting_Order>;
  awardDate?: InputMaybe<Sorting_Order>;
  certificates?: InputMaybe<Sorting_Order>;
  classRankProofs?: InputMaybe<Sorting_Order>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  currentStudyYear?: InputMaybe<Sorting_Order>;
  degreeCertIndicator?: InputMaybe<Sorting_Order>;
  degreeLevel?: InputMaybe<Sorting_Order>;
  expectUpdateDate?: InputMaybe<Sorting_Order>;
  from?: InputMaybe<Sorting_Order>;
  gpaIndicator?: InputMaybe<Sorting_Order>;
  institution?: InputMaybe<InstitutionSort>;
  instructionMedium?: InputMaybe<Sorting_Order>;
  markConversion?: InputMaybe<MarkConversionSort>;
  markExplanations?: InputMaybe<Sorting_Order>;
  marks?: InputMaybe<MarkSort>;
  officialClassRanking?: InputMaybe<Sorting_Order>;
  officialMark?: InputMaybe<Sorting_Order>;
  otherDocuments?: InputMaybe<Sorting_Order>;
  otherInstructionMedium?: InputMaybe<Sorting_Order>;
  presentIndicator?: InputMaybe<Sorting_Order>;
  programmeName?: InputMaybe<Sorting_Order>;
  qualificationMeans?: InputMaybe<Sorting_Order>;
  qualificationStatus?: InputMaybe<Sorting_Order>;
  rankIndicator?: InputMaybe<Sorting_Order>;
  studyField?: InputMaybe<Sorting_Order>;
  studyMode?: InputMaybe<Sorting_Order>;
  to?: InputMaybe<Sorting_Order>;
  transcripts?: InputMaybe<Sorting_Order>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
  withdrawDate?: InputMaybe<Sorting_Order>;
};

export type AcademicReferee = {
  __typename?: 'AcademicReferee';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  institution?: Maybe<Scalars['String']['output']>;
  name?: Maybe<RefereeName>;
  /** @deprecated Use the three parts. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberAreaCode?: Maybe<Scalars['String']['output']>;
  phoneNumberCountryCode?: Maybe<Scalars['String']['output']>;
  phoneNumberNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  referenceReport?: Maybe<FileType>;
  relationship?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Array<Scalars['String']['output']>>;
  selectedToHkpfs?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type AcademicRefereeArrayFilter = {
  all?: InputMaybe<Array<AcademicRefereeArrayFilter>>;
  elemMatch?: InputMaybe<AcademicRefereeFilter>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

export type AcademicRefereeFilter = {
  _id?: InputMaybe<StringFilter>;
  and?: InputMaybe<Array<AcademicRefereeFilter>>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  faxNumber?: InputMaybe<StringFilter>;
  institution?: InputMaybe<StringFilter>;
  name?: InputMaybe<RefereeNameFilter>;
  nor?: InputMaybe<Array<AcademicRefereeFilter>>;
  not?: InputMaybe<AcademicRefereeFilter>;
  or?: InputMaybe<Array<AcademicRefereeFilter>>;
  phoneNumber?: InputMaybe<StringFilter>;
  position?: InputMaybe<StringFilter>;
  relationship?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

export type AcademicRefereeForm = {
  __typename?: 'AcademicRefereeForm';
  academicRefereeId: Scalars['ID']['output'];
  applicationId: Scalars['ID']['output'];
  basicInformation: RefereeFormBasicInformationType;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  formQuestions: Array<FormQuestionType>;
  lastSentDate?: Maybe<Scalars['DateTime']['output']>;
  recommendation: Overall_Recommendation;
  repliedAt?: Maybe<Scalars['DateTime']['output']>;
  report: FileType;
  selectionQuestions: Array<SelectionQuestionType>;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AcademicRefereeFormDoc = {
  __typename?: 'AcademicRefereeFormDoc';
  _id: Scalars['String']['output'];
  academicRefereeId: Scalars['ID']['output'];
  applicationId: Scalars['ID']['output'];
  basicInformation: RefereeFormBasicInformationType;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  formQuestions: Array<FormQuestionType>;
  lastSentDate?: Maybe<Scalars['DateTime']['output']>;
  recommendation: Overall_Recommendation;
  repliedAt?: Maybe<Scalars['DateTime']['output']>;
  report: FileType;
  selectionQuestions: Array<SelectionQuestionType>;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum AcademicRefereeFormStatus {
  Created = 'CREATED',
  Expired = 'EXPIRED',
  Submitted = 'SUBMITTED'
}

export type AcademicRefereePayload = {
  __typename?: 'AcademicRefereePayload';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  institution?: Maybe<Scalars['String']['output']>;
  name?: Maybe<RefereeName>;
  /** @deprecated Use the three parts. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberAreaCode?: Maybe<Scalars['String']['output']>;
  phoneNumberCountryCode?: Maybe<Scalars['String']['output']>;
  phoneNumberNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  referenceReport?: Maybe<FileType>;
  relationship?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Array<Scalars['String']['output']>>;
  selectedToHkpfs?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type AcademicRefereeReportStatusPayload = {
  __typename?: 'AcademicRefereeReportStatusPayload';
  applicationId: Scalars['String']['output'];
  refereeReportStatus: Array<RefereeReportStatusPayload>;
};

export type AcademicRefereeSort = {
  _id?: InputMaybe<Sorting_Order>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  email?: InputMaybe<Sorting_Order>;
  faxNumber?: InputMaybe<Sorting_Order>;
  institution?: InputMaybe<Sorting_Order>;
  name?: InputMaybe<RefereeNameSort>;
  phoneNumber?: InputMaybe<Sorting_Order>;
  position?: InputMaybe<Sorting_Order>;
  relationship?: InputMaybe<Sorting_Order>;
  title?: InputMaybe<Sorting_Order>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
};

export type AcceptNonProposedInvitationInput = {
  applicationId: Scalars['String']['input'];
  supervisorNetId: Scalars['String']['input'];
};

export type Activity = {
  __typename?: 'Activity';
  activityType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  from: Scalars['DateTime']['output'];
  majorResponsibilities?: Maybe<Scalars['String']['output']>;
  organisationName: Scalars['String']['output'];
  position: Scalars['String']['output'];
  presentActivityIndicator: Scalars['Boolean']['output'];
  supportingDocuments: Array<FileType>;
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  volunteerMode?: Maybe<Scalars['String']['output']>;
};

export type ActivityPayload = {
  __typename?: 'ActivityPayload';
  _id: Scalars['ID']['output'];
  activityType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  from: Scalars['DateTime']['output'];
  majorResponsibilities?: Maybe<Scalars['String']['output']>;
  organisationName: Scalars['String']['output'];
  position: Scalars['String']['output'];
  presentActivityIndicator: Scalars['Boolean']['output'];
  supportingDocuments: Array<FileType>;
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  volunteerMode?: Maybe<Scalars['String']['output']>;
};

export type ActivitySort = {
  _id?: InputMaybe<Sorting_Order>;
  activityType?: InputMaybe<Sorting_Order>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  from?: InputMaybe<Sorting_Order>;
  majorResponsibilities?: InputMaybe<Sorting_Order>;
  organisationName?: InputMaybe<Sorting_Order>;
  position?: InputMaybe<Sorting_Order>;
  presentActivityIndicator?: InputMaybe<Sorting_Order>;
  to?: InputMaybe<Sorting_Order>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
};

export type AddApplicationItemInput = {
  academicQualification?: InputMaybe<CreateAcademicQualificationInput>;
  academicReferee?: InputMaybe<CreateAcademicRefereeInput>;
  activity?: InputMaybe<CreateActivityInput>;
  additionalDocument?: InputMaybe<CreateAdditionalDocumentInput>;
  declaration?: InputMaybe<CreateApplicationDeclarationInput>;
  distinctiveScholarships?: InputMaybe<CreateDistinctiveScholarshipInput>;
  employment?: InputMaybe<CreateEmploymentInput>;
  hkpfsInformation?: InputMaybe<CreateHkpfsInformationInput>;
  languageQualification?: InputMaybe<CreateLanguageQualificationInput>;
  merit?: InputMaybe<CreateMeritInput>;
  otherTest?: InputMaybe<CreateOtherTestInput>;
  professionalQualification?: InputMaybe<CreateProfessionalQualificationInput>;
  programmeChoice?: InputMaybe<CreateProgrammeChoiceInput>;
  proofDocuments?: InputMaybe<CreateApplicationProofInput>;
  publication?: InputMaybe<CreatePublicationInput>;
  researchExperience?: InputMaybe<CreateResearchExperienceInput>;
  training?: InputMaybe<CreateTrainingInput>;
};

export type AdditionalDocument = {
  __typename?: 'AdditionalDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  supportingDocuments: Array<FileType>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type AdditionalDocumentPayload = {
  __typename?: 'AdditionalDocumentPayload';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  supportingDocuments: Array<FileType>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type AdditionalDocumentSort = {
  _id?: InputMaybe<Sorting_Order>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  documentType?: InputMaybe<Sorting_Order>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
};

export type AdminQueryAcademicRefereeDto = {
  __typename?: 'AdminQueryAcademicRefereeDTO';
  applicationNo: Scalars['String']['output'];
  file?: Maybe<FileType>;
  formId: Scalars['String']['output'];
  refereeEmail: Scalars['String']['output'];
  refereeId: Scalars['String']['output'];
  refereeName: Scalars['String']['output'];
  repliedDate?: Maybe<Scalars['DateTime']['output']>;
  status: AcademicRefereeFormStatus;
};

export type AdminStudentIdentityInput = {
  /** Note this is *Applicant* ID. */
  applicantId: Scalars['String']['input'];
  identityType: Identity_Type;
  isLocal: Scalars['Boolean']['input'];
  needStudentVisa: Scalars['Boolean']['input'];
  regenerateVisa?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Admission = {
  __typename?: 'Admission';
  partnerInstitution?: Maybe<Scalars['String']['output']>;
  polyuStudyPeriod?: Maybe<Period>;
  /** the length, level, and mode of the programme */
  programme: Scalars['String']['output'];
  requirements: Requirements;
};

export type AdmissionFilter = {
  and?: InputMaybe<Array<AdmissionFilter>>;
  nor?: InputMaybe<Array<AdmissionFilter>>;
  not?: InputMaybe<AdmissionFilter>;
  or?: InputMaybe<Array<AdmissionFilter>>;
  partnerInstitution?: InputMaybe<StringFilter>;
  polyuStudyPeriod?: InputMaybe<PeriodFilter>;
  programme?: InputMaybe<StringFilter>;
  requirements?: InputMaybe<RequirementsFilter>;
};

export type AdmissionInput = {
  partnerInstitution?: InputMaybe<Scalars['String']['input']>;
  polyuStudyPeriod?: InputMaybe<PeriodInput>;
  programme: Scalars['String']['input'];
  requirements: RequirementsInput;
};

export type ApplicantFilter = {
  PIDeclaration?: InputMaybe<Scalars['Boolean']['input']>;
  _id?: InputMaybe<StringFilter>;
  and?: InputMaybe<Array<ApplicantFilter>>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  disabilitySpecial?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  gender?: InputMaybe<GenderFilter>;
  identity?: InputMaybe<IdentityFilter>;
  name?: InputMaybe<ApplicantNameFilter>;
  nationality?: InputMaybe<StringFilter>;
  nor?: InputMaybe<Array<ApplicantFilter>>;
  not?: InputMaybe<ApplicantFilter>;
  or?: InputMaybe<Array<ApplicantFilter>>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

export type ApplicantName = {
  __typename?: 'ApplicantName';
  chineseName?: Maybe<Scalars['String']['output']>;
  givenName: Scalars['String']['output'];
  surname: Scalars['String']['output'];
};

export type ApplicantNameFilter = {
  and?: InputMaybe<Array<ApplicantNameFilter>>;
  chineseName?: InputMaybe<StringFilter>;
  givenName?: InputMaybe<StringFilter>;
  nor?: InputMaybe<Array<ApplicantNameFilter>>;
  not?: InputMaybe<ApplicantNameFilter>;
  or?: InputMaybe<Array<ApplicantNameFilter>>;
  surname?: InputMaybe<StringFilter>;
};

export type ApplicantNameInput = {
  chineseName?: InputMaybe<Scalars['String']['input']>;
  givenName: Scalars['String']['input'];
  surname: Scalars['String']['input'];
};

export type ApplicantNameSort = {
  chineseName?: InputMaybe<Sorting_Order>;
  givenName?: InputMaybe<Sorting_Order>;
  surname?: InputMaybe<Sorting_Order>;
};

export type ApplicantPaginatorPayload = {
  __typename?: 'ApplicantPaginatorPayload';
  data: Array<ApplicantPayload>;
  paginator: PaginatorPayload;
};

export type ApplicantPayload = {
  __typename?: 'ApplicantPayload';
  PIDeclaration: Scalars['Boolean']['output'];
  _id: Scalars['ID']['output'];
  /** @deprecated Use three lines of address instead. */
  address: Scalars['String']['output'];
  /** The region of the address, using the key provided by SRS. Required. ADD Jun 4. */
  addressCountryRegion: Scalars['String']['output'];
  /** The first line of the address. Required. ADD Jun 4. */
  addressLine1: Scalars['String']['output'];
  /** The second line of the address. Optional. ADD Jun 4. */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** The third line of the address. Optional. ADD Jun 4. */
  addressLine3?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dateOfBirth: Scalars['DateTime']['output'];
  disabilitySpecial?: Maybe<DisabilitySpecial>;
  email: Scalars['String']['output'];
  gender: Gender;
  identity: Identity;
  mobileNumber: Scalars['String']['output'];
  name: ApplicantName;
  /** Use key provided in SRS. Required. MOD Jun 4. */
  nationality: Scalars['String']['output'];
  /** Use key provided in SRS. Required only when the applicant is from mainland. MOD Jun 4. */
  province?: Maybe<Scalars['String']['output']>;
  telephoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ApplicantSort = {
  PIDeclaration?: InputMaybe<Sorting_Order>;
  _id?: InputMaybe<Sorting_Order>;
  address?: InputMaybe<Sorting_Order>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  dateOfBirth?: InputMaybe<Sorting_Order>;
  disabilitySpecial?: InputMaybe<DisabilitySpecialSort>;
  email?: InputMaybe<Sorting_Order>;
  gender?: InputMaybe<Sorting_Order>;
  identity?: InputMaybe<IdentitySort>;
  mobileNumber?: InputMaybe<Sorting_Order>;
  name?: InputMaybe<ApplicantNameSort>;
  nationality?: InputMaybe<Sorting_Order>;
  province?: InputMaybe<Sorting_Order>;
  telephoneNumber?: InputMaybe<Sorting_Order>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
};

export type ApplicatioinViewQualificationCheckModelFilter = {
  applicationId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

export type ApplicationDeclarationType = {
  __typename?: 'ApplicationDeclarationType';
  _id: Scalars['ID']['output'];
  confirmation?: Maybe<Scalars['Boolean']['output']>;
  engagement?: Maybe<Scalars['Boolean']['output']>;
  informationAccuracy?: Maybe<Scalars['Boolean']['output']>;
  personalType?: Maybe<Personal_Info_Type>;
};

export type ApplicationDeclarationTypeInput = {
  _id: Scalars['ID']['input'];
  confirmation?: InputMaybe<Scalars['Boolean']['input']>;
  engagement?: InputMaybe<Scalars['Boolean']['input']>;
  informationAccuracy?: InputMaybe<Scalars['Boolean']['input']>;
  personalType?: InputMaybe<Personal_Info_Type>;
};

export type ApplicationDeletePayload = {
  __typename?: 'ApplicationDeletePayload';
  academicQualifications?: Maybe<Array<Scalars['String']['output']>>;
  academicRefereeForms?: Maybe<Array<Scalars['String']['output']>>;
  academicReferees?: Maybe<Array<Scalars['String']['output']>>;
  activities?: Maybe<Array<Scalars['String']['output']>>;
  additionalDocuments?: Maybe<Array<Scalars['String']['output']>>;
  application?: Maybe<Scalars['String']['output']>;
  assessment?: Maybe<Scalars['String']['output']>;
  dsrcAdmissionForm?: Maybe<Scalars['String']['output']>;
  dsrcAssessment?: Maybe<Scalars['String']['output']>;
  dsrcInterestConflictApproval?: Maybe<Scalars['String']['output']>;
  employments?: Maybe<Array<Scalars['String']['output']>>;
  frcsbAssessment?: Maybe<Scalars['String']['output']>;
  gsDecision?: Maybe<Scalars['String']['output']>;
  hoddosAssessment?: Maybe<Scalars['String']['output']>;
  languageQualifications?: Maybe<Array<Scalars['String']['output']>>;
  meetConditionCheckModel?: Maybe<Scalars['String']['output']>;
  merits?: Maybe<Array<Scalars['String']['output']>>;
  nomination?: Maybe<Scalars['String']['output']>;
  offerModel?: Maybe<Scalars['String']['output']>;
  onlineRegistrationModel?: Maybe<Scalars['String']['output']>;
  otherTests?: Maybe<Array<Scalars['String']['output']>>;
  professionalQualifications?: Maybe<Array<Scalars['String']['output']>>;
  programmeChoice?: Maybe<Scalars['String']['output']>;
  publications?: Maybe<Array<Scalars['String']['output']>>;
  qualificationCheckModel?: Maybe<Scalars['String']['output']>;
  researchExperiences?: Maybe<Array<Scalars['String']['output']>>;
  trainings?: Maybe<Array<Scalars['String']['output']>>;
  visaModel?: Maybe<Scalars['String']['output']>;
};

export type ApplicationDoc = {
  __typename?: 'ApplicationDoc';
  _id: Scalars['String']['output'];
  academicQualifications?: Maybe<Array<Scalars['ID']['output']>>;
  academicReferees?: Maybe<Array<Scalars['ID']['output']>>;
  activities?: Maybe<Array<Scalars['ID']['output']>>;
  additionalDocuments?: Maybe<Array<Scalars['ID']['output']>>;
  applicant: Scalars['ID']['output'];
  applicationNo: Scalars['String']['output'];
  /** For applicationNos that not fit the entry year, this field will store the original applicationNo before migration. */
  applicationNoPreMigration?: Maybe<Scalars['String']['output']>;
  backTo?: Maybe<Array<Application_Status>>;
  /** @deprecated Use the one in programmeChoice */
  chiefSupervisor?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  currentMPhilStudentToPhD?: Maybe<Scalars['Boolean']['output']>;
  declaration?: Maybe<ApplicationDeclarationType>;
  /** @deprecated Use the one in programmeChoice */
  department?: Maybe<Scalars['String']['output']>;
  distinctiveScholarships?: Maybe<Array<DistinctiveScholarshipType>>;
  employments?: Maybe<Array<Scalars['ID']['output']>>;
  hkpfsInformation?: Maybe<HkpfsInformation>;
  /** @deprecated Use the one in programmeChoice instead. */
  invitingSupervisorList?: Maybe<Array<Scalars['String']['output']>>;
  languageQualifications?: Maybe<Array<Scalars['ID']['output']>>;
  merits?: Maybe<Array<Scalars['ID']['output']>>;
  otherTests?: Maybe<Array<Scalars['ID']['output']>>;
  professionalQualifications?: Maybe<Array<Scalars['ID']['output']>>;
  programmeChoice?: Maybe<Scalars['ID']['output']>;
  proofDocuments?: Maybe<Array<ApplicationProofFileType>>;
  publications?: Maybe<Array<Scalars['ID']['output']>>;
  /** @deprecated Use the one in programmeChoice instead. */
  rejectedBySupervisorFirstChoice?: Maybe<Scalars['Boolean']['output']>;
  remarks?: Maybe<Array<ApplicationRemarkType>>;
  researchExperiences?: Maybe<Array<Scalars['ID']['output']>>;
  status: Application_Status;
  trainings?: Maybe<Array<Scalars['ID']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  virtualApplicationType?: Maybe<Scalars['String']['output']>;
};

export type ApplicationDuplicateLogCompoundPayload = {
  __typename?: 'ApplicationDuplicateLogCompoundPayload';
  academicQualifications?: Maybe<Array<AcademicQualificationPayload>>;
  academicRefereeForms?: Maybe<Array<AcademicRefereeFormDoc>>;
  academicReferees?: Maybe<Array<AcademicRefereePayload>>;
  activities?: Maybe<Array<ActivityPayload>>;
  additionalDocuments?: Maybe<Array<AdditionalDocumentPayload>>;
  application?: Maybe<ApplicationDoc>;
  applicationDuplicateLogs: ApplicationDuplicateLogPayload;
  assessment?: Maybe<AssessmentDoc>;
  dsrcAdmissionForm?: Maybe<DsrcAdmissionFormDoc>;
  dsrcAssessment?: Maybe<DsrcAssessmentDoc>;
  dsrcInterestConflictApproval?: Maybe<InterestConflictApprovalDoc>;
  employments?: Maybe<Array<EmploymentPayload>>;
  frcsbAssessment?: Maybe<FrcsbAssessmentDoc>;
  gsDecision?: Maybe<GsDecisionDoc>;
  hodDosAssessment?: Maybe<HodDosAssessmentDoc>;
  languageQualifications?: Maybe<Array<LanguageQualificationPayload>>;
  meetConditionCheckModel?: Maybe<MeetConditionCheckModelDoc>;
  merits?: Maybe<Array<MeritPayload>>;
  nomination?: Maybe<NominationDoc>;
  offerModel?: Maybe<OfferModelDoc>;
  onlineRegistrationModel?: Maybe<OnlineRegistrationModelDoc>;
  otherTests?: Maybe<Array<OtherTestPayload>>;
  professionalQualifications?: Maybe<Array<ProfessionalQualificationPayload>>;
  programmeChoice?: Maybe<ProgrammeChoicePayload>;
  publications?: Maybe<Array<PublicationPayload>>;
  qualificationCheckModel?: Maybe<QualificationCheckModelDoc>;
  researchExperiences?: Maybe<Array<ResearchExperiencePayload>>;
  trainings?: Maybe<Array<TrainingPayload>>;
  visaModel?: Maybe<VisaModelDoc>;
};

export type ApplicationDuplicateLogPayload = {
  __typename?: 'ApplicationDuplicateLogPayload';
  _id?: Maybe<Scalars['String']['output']>;
  academicQualifications?: Maybe<Array<DuplicateMap>>;
  academicRefereeForms?: Maybe<Array<DuplicateMap>>;
  academicReferees?: Maybe<Array<DuplicateMap>>;
  activities?: Maybe<Array<DuplicateMap>>;
  additionalDocuments?: Maybe<Array<DuplicateMap>>;
  application?: Maybe<Array<DuplicateMap>>;
  assessment?: Maybe<Array<DuplicateMap>>;
  dsrcAdmissionForm?: Maybe<Array<DuplicateMap>>;
  dsrcAssessment?: Maybe<Array<DuplicateMap>>;
  dsrcInterestConflictApproval?: Maybe<Array<DuplicateMap>>;
  employments?: Maybe<Array<DuplicateMap>>;
  frcsbAssessment?: Maybe<Array<DuplicateMap>>;
  gsDecision?: Maybe<Array<DuplicateMap>>;
  hoddosAssessment?: Maybe<Array<DuplicateMap>>;
  languageQualifications?: Maybe<Array<DuplicateMap>>;
  meetConditionCheckModel?: Maybe<Array<DuplicateMap>>;
  merits?: Maybe<Array<DuplicateMap>>;
  nomination?: Maybe<Array<DuplicateMap>>;
  offerModel?: Maybe<Array<DuplicateMap>>;
  onlineRegistrationModel?: Maybe<Array<DuplicateMap>>;
  otherTests?: Maybe<Array<DuplicateMap>>;
  professionalQualifications?: Maybe<Array<DuplicateMap>>;
  programmeChoice?: Maybe<Array<DuplicateMap>>;
  publications?: Maybe<Array<DuplicateMap>>;
  qualificationCheckModel?: Maybe<Array<DuplicateMap>>;
  researchExperiences?: Maybe<Array<DuplicateMap>>;
  trainings?: Maybe<Array<DuplicateMap>>;
  visaModel?: Maybe<Array<DuplicateMap>>;
};

export type ApplicationFeeBillingInformation = {
  __typename?: 'ApplicationFeeBillingInformation';
  admSemester: Scalars['String']['output'];
  admYear: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  applnCategory: Scalars['String']['output'];
  applnNo: Scalars['String']['output'];
  localIndicator: Scalars['String']['output'];
  operationMode: Scalars['String']['output'];
  paymentDeadline: Scalars['DateTime']['output'];
  progChoiceList: Array<ApplicationFeeProgramme>;
  progLevel: Scalars['String']['output'];
};

export type ApplicationFeeProgramme = {
  __typename?: 'ApplicationFeeProgramme';
  progCode: Scalars['String']['output'];
  progSubCode: Scalars['String']['output'];
};

export type ApplicationFilter = {
  _id?: InputMaybe<StringFilter>;
  academicQualifications?: InputMaybe<AcademicQualificationArrayFilter>;
  academicReferees?: InputMaybe<AcademicRefereeArrayFilter>;
  and?: InputMaybe<Array<ApplicationFilter>>;
  applicant?: InputMaybe<ApplicantFilter>;
  applicationNo?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  hkpfsInformation?: InputMaybe<HkpfsInformationFilter>;
  nor?: InputMaybe<Array<ApplicationFilter>>;
  not?: InputMaybe<ApplicationFilter>;
  or?: InputMaybe<Array<ApplicationFilter>>;
  programmeChoice?: InputMaybe<ProgrammeChoiceFilter>;
  status?: InputMaybe<ApplicationStatusFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

export type ApplicationLogEntry = {
  __typename?: 'ApplicationLogEntry';
  /** The method of the application log entry. */
  method: Scalars['String']['output'];
  /** The status of the application log entry. */
  status: Scalars['String']['output'];
  /** The timestamp of the application log entry. */
  timestamp: Scalars['DateTime']['output'];
  /** The user of the application log entry. */
  user: Scalars['String']['output'];
};

export type ApplicationLogPayload = {
  __typename?: 'ApplicationLogPayload';
  /** The applicationId of the application log entry. */
  applicationId: Scalars['String']['output'];
  /** The array of application log entries. */
  entryArray: Array<ApplicationLogEntry>;
  /** The array of application status changes. */
  statusChanges: Array<ApplicationStatusChange>;
};

export type ApplicationPaginatorPayload = {
  __typename?: 'ApplicationPaginatorPayload';
  data: Array<ApplicationPayload>;
  paginator: PaginatorPayload;
};

export type ApplicationPartialViewPaginatorPayload = {
  __typename?: 'ApplicationPartialViewPaginatorPayload';
  data: Array<ApplicationPartialViewPayload>;
  paginator: PaginatorPayload;
};

export type ApplicationPartialViewPayload = {
  __typename?: 'ApplicationPartialViewPayload';
  applicant: ApplicantPayload;
  applicationNo: Scalars['String']['output'];
  applicationNoPreMigration?: Maybe<Scalars['String']['output']>;
  assessment?: Maybe<Assessment>;
  backTo?: Maybe<Array<Application_Status>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  distinctiveScholarships?: Maybe<Array<DistinctiveScholarshipType>>;
  gsDecision?: Maybe<GsDecision>;
  hkpfsInformation?: Maybe<HkpfsInformation>;
  id: Scalars['String']['output'];
  meetConditionCheckModel?: Maybe<MeetConditionCheckModel>;
  nomination?: Maybe<NominationPayload>;
  offerModel?: Maybe<OfferModel>;
  onlineRegistrationModel?: Maybe<OnlineRegistrationModel>;
  paymentRecords?: Maybe<Array<PaymentRecord>>;
  programmeChoice?: Maybe<ProgrammeChoice>;
  proofDocuments?: Maybe<Array<ApplicationProofFileType>>;
  qualificationCheckModel?: Maybe<QualificationCheckModel>;
  remarks?: Maybe<Array<ApplicationRemarkType>>;
  status: Application_Status;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  visaModel?: Maybe<VisaModel>;
};

export type ApplicationPayload = {
  __typename?: 'ApplicationPayload';
  _id: Scalars['ID']['output'];
  academicQualifications?: Maybe<Array<Maybe<AcademicQualificationPayload>>>;
  academicReferees?: Maybe<Array<Maybe<AcademicRefereePayload>>>;
  activities?: Maybe<Array<Maybe<ActivityPayload>>>;
  additionalDocuments?: Maybe<Array<Maybe<AdditionalDocumentPayload>>>;
  applicant: ApplicantPayload;
  applicationNo: Scalars['String']['output'];
  /** For applicationNos that not fit the entry year, this field will store the original applicationNo before migration. */
  applicationNoPreMigration?: Maybe<Scalars['String']['output']>;
  backTo?: Maybe<Array<Application_Status>>;
  /** @deprecated Use the one in programmeChoice */
  chiefSupervisor?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  currentMPhilStudentToPhD?: Maybe<Scalars['Boolean']['output']>;
  declaration?: Maybe<ApplicationDeclarationType>;
  /** @deprecated Use the one in programmeChoice */
  department?: Maybe<Scalars['String']['output']>;
  distinctiveScholarships?: Maybe<Array<DistinctiveScholarshipType>>;
  employments?: Maybe<Array<Maybe<EmploymentPayload>>>;
  hkpfsInformation?: Maybe<HkpfsInformation>;
  /** @deprecated Use the one in programmeChoice instead. */
  invitingSupervisorList?: Maybe<Array<Scalars['String']['output']>>;
  languageQualifications?: Maybe<Array<Maybe<LanguageQualificationPayload>>>;
  merits?: Maybe<Array<Maybe<MeritPayload>>>;
  otherTests?: Maybe<Array<Maybe<OtherTestPayload>>>;
  professionalQualifications?: Maybe<Array<Maybe<ProfessionalQualificationPayload>>>;
  programmeChoice?: Maybe<ProgrammeChoicePayload>;
  proofDocuments?: Maybe<Array<ApplicationProofFileType>>;
  publications?: Maybe<Array<Maybe<PublicationPayload>>>;
  /** @deprecated Use the one in programmeChoice instead. */
  rejectedBySupervisorFirstChoice?: Maybe<Scalars['Boolean']['output']>;
  remarks?: Maybe<Array<ApplicationRemarkType>>;
  researchExperiences?: Maybe<Array<Maybe<ResearchExperiencePayload>>>;
  status: Application_Status;
  trainings?: Maybe<Array<Maybe<TrainingPayload>>>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  virtualApplicationType?: Maybe<Scalars['String']['output']>;
};

export type ApplicationProofFileType = {
  __typename?: 'ApplicationProofFileType';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentType: Proof_Document_Type;
  remark?: Maybe<Scalars['String']['output']>;
  supportingDocuments?: Maybe<Array<FileType>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ApplicationProofFileTypeInput = {
  _id: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentType: Proof_Document_Type;
  remark?: InputMaybe<Scalars['String']['input']>;
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationRemarkType = {
  __typename?: 'ApplicationRemarkType';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  fromNetId: Scalars['String']['output'];
  fromRole: UserRole;
  remark: Scalars['String']['output'];
  supportingDocuments?: Maybe<Array<FileType>>;
  toNetId?: Maybe<Scalars['String']['output']>;
  toRole: Array<UserRole>;
};

export type ApplicationSort = {
  _id?: InputMaybe<Sorting_Order>;
  academicQualifications?: InputMaybe<AcademicQualificationSort>;
  academicReferees?: InputMaybe<AcademicRefereeSort>;
  activities?: InputMaybe<ActivitySort>;
  additionalDocuments?: InputMaybe<AdditionalDocumentSort>;
  applicant?: InputMaybe<ApplicantSort>;
  chiefSupervisor?: InputMaybe<Sorting_Order>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  department?: InputMaybe<Sorting_Order>;
  employments?: InputMaybe<EmploymentSort>;
  languageQualifications?: InputMaybe<LanguageQualificationSort>;
  merits?: InputMaybe<MeritSort>;
  otherTests?: InputMaybe<OtherTestSort>;
  professionalQualifications?: InputMaybe<ProfessionalQualificationSort>;
  programmeChoices?: InputMaybe<ProgrammeChoiceSort>;
  publications?: InputMaybe<PublicationSort>;
  researchExperiences?: InputMaybe<ResearchExperienceSort>;
  status?: InputMaybe<Sorting_Order>;
  trainings?: InputMaybe<TrainingSort>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
};

export type ApplicationStatusChange = {
  __typename?: 'ApplicationStatusChange';
  /** The snapshot of ApplicationView with json serialization */
  applicationViewSnapshot?: Maybe<Scalars['String']['output']>;
  /** The user who changed the status. */
  by: Scalars['String']['output'];
  /** The status change record. */
  from: Application_Status;
  /** The timestamp of the status change. */
  timestamp: Scalars['DateTime']['output'];
  /** The status change record. */
  to: Application_Status;
};

export type ApplicationStatusFilter = {
  eq?: InputMaybe<Application_Status>;
  in?: InputMaybe<Array<Application_Status>>;
  ne?: InputMaybe<Application_Status>;
  nin?: InputMaybe<Array<Application_Status>>;
};

export type ApplicationTodoListPayload = {
  __typename?: 'ApplicationTodoListPayload';
  applicationStatus: Scalars['String']['output'];
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  /** After registration, the student will have a student number. */
  studentNumber?: Maybe<Scalars['String']['output']>;
  todoList: Array<Todo_List>;
  visibleList: Array<Todo_List>;
};

export type ApplicationView = {
  __typename?: 'ApplicationView';
  academicQualifications?: Maybe<Array<AcademicQualification>>;
  academicRefereeForms?: Maybe<Array<AcademicRefereeForm>>;
  academicReferees?: Maybe<Array<AcademicReferee>>;
  activities?: Maybe<Array<Activity>>;
  additionalDocuments?: Maybe<Array<AdditionalDocument>>;
  applicant: ApplicantPayload;
  applicationNo: Scalars['String']['output'];
  applicationNoPreMigration?: Maybe<Scalars['String']['output']>;
  assessment?: Maybe<Assessment>;
  backTo?: Maybe<Array<Application_Status>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  distinctiveScholarships?: Maybe<Array<DistinctiveScholarshipType>>;
  dsrcAdmissionForm?: Maybe<DsrcAdmissionForm>;
  dsrcAssessment?: Maybe<DsrcAssessment>;
  employments?: Maybe<Array<Employment>>;
  frcsbAssessment?: Maybe<FrcsbAssessment>;
  gsDecision?: Maybe<GsDecision>;
  hkpfsInformation?: Maybe<HkpfsInformation>;
  hoddosAssessment?: Maybe<HodDosAssessment>;
  id: Scalars['String']['output'];
  languageQualifications?: Maybe<Array<LanguageQualification>>;
  meetConditionCheckModel?: Maybe<MeetConditionCheckModel>;
  merits?: Maybe<Array<Merit>>;
  nomination?: Maybe<NominationPayload>;
  offerModel?: Maybe<OfferModel>;
  onlineRegistrationModel?: Maybe<OnlineRegistrationModel>;
  otherTests?: Maybe<Array<OtherTest>>;
  paymentRecords?: Maybe<Array<PaymentRecord>>;
  professionalQualifications?: Maybe<Array<ProfessionalQualification>>;
  programmeChoice?: Maybe<ProgrammeChoice>;
  proofDocuments?: Maybe<Array<ApplicationProofFileType>>;
  publications?: Maybe<Array<Publication>>;
  qualificationCheckModel?: Maybe<QualificationCheckModel>;
  remarks?: Maybe<Array<ApplicationRemarkType>>;
  researchExperiences?: Maybe<Array<ResearchExperience>>;
  status: Application_Status;
  trainings?: Maybe<Array<Training>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  visaModel?: Maybe<VisaModel>;
};

export type ApplicationViewApplicantFilter = {
  PIDeclaration?: InputMaybe<Scalars['Boolean']['input']>;
  _id?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  disabilitySpecial?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  identity?: InputMaybe<ApplicationViewIdentityFilter>;
  name?: InputMaybe<ApplicationViewApplicantNameFilter>;
  nationality?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

export type ApplicationViewApplicantNameFilter = {
  chineseName?: InputMaybe<StringFilter>;
  givenName?: InputMaybe<StringFilter>;
  surname?: InputMaybe<StringFilter>;
};

export type ApplicationViewAssessmentSort = {
  lastSubmissionTime?: InputMaybe<ApplicationViewAssessmentSubmissionToGsSort>;
};

export type ApplicationViewAssessmentSubmissionToGsSort = {
  at?: InputMaybe<Sorting_Order>;
};

export type ApplicationViewDistinctiveScholarshipsFilter = {
  _id?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  fundingSource?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

export type ApplicationViewFilter = {
  _id?: InputMaybe<StringFilter>;
  and?: InputMaybe<Array<ApplicationViewFilter>>;
  applicant?: InputMaybe<ApplicationViewApplicantFilter>;
  applicationNo?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  distinctiveScholarships?: InputMaybe<ApplicationViewDistinctiveScholarshipsFilter>;
  gsDecision?: InputMaybe<ApplicationViewGsDecisionFilter>;
  hkpfsInformation?: InputMaybe<ApplicationViewHkpfsInformationFilter>;
  meetConditionCheckModel?: InputMaybe<ApplicationViewMeetConditionCheckModelFilter>;
  nomination?: InputMaybe<ApplicationViewNominationFilter>;
  nor?: InputMaybe<Array<ApplicationViewFilter>>;
  not?: InputMaybe<ApplicationViewFilter>;
  offerModel?: InputMaybe<ApplicationViewOfferModelFilter>;
  or?: InputMaybe<Array<ApplicationViewFilter>>;
  programmeChoice?: InputMaybe<ApplicationViewProgrammeChoiceFilter>;
  qualificationCheckModel?: InputMaybe<ApplicatioinViewQualificationCheckModelFilter>;
  status?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
  visaModel?: InputMaybe<ApplicationViewVisaModelFilter>;
};

export type ApplicationViewFundingArrayFilter = {
  elemMatch?: InputMaybe<ApplicationViewFundingFilter>;
  indicators?: InputMaybe<StringFilter>;
  schema?: InputMaybe<StringFilter>;
  size?: InputMaybe<Scalars['Float']['input']>;
  source?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type ApplicationViewFundingFilter = {
  indicators?: InputMaybe<StringFilter>;
  schema?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type ApplicationViewGsDecisionFilter = {
  assignee?: InputMaybe<StringFilter>;
  hasReturned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicationViewHkpfsInformationFilter = {
  HKPFSReferenceNumber?: InputMaybe<StringFilter>;
  _id?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
  validHKPFSApplication?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicationViewIdentityFilter = {
  identityDocumentNumber?: InputMaybe<StringFilter>;
  identityDocumentType?: InputMaybe<StringFilter>;
  identityType?: InputMaybe<StringFilter>;
  isLocal?: InputMaybe<Scalars['Boolean']['input']>;
  needStudentVisa?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicationViewInterviewPanelFilter = {
  applicationId: StringFilter;
  externalInterviewPanel?: InputMaybe<Array<Scalars['String']['input']>>;
  interviewDate?: InputMaybe<StringFilter>;
  interviewLanguage?: InputMaybe<StringFilter>;
  interviewMode?: InputMaybe<StringFilter>;
  /** The panel has agreed that the panel chair submit the form. */
  panelAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  panelMembers?: InputMaybe<PanelMemberArrayFilter>;
};

export type ApplicationViewMeetConditionCheckModelFilter = {
  isFirmOffer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<StringFilter>;
};

export type ApplicationViewNominationFilter = {
  _id?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  fundings?: InputMaybe<ApplicationViewFundingArrayFilter>;
  interviewPanel?: InputMaybe<ApplicationViewInterviewPanelFilter>;
  scholarshipNomination?: InputMaybe<ScholarshipNominationFilter>;
  subjectClassification?: InputMaybe<StringFilter>;
  submission?: InputMaybe<ApplicationViewNominationSubmissionFilter>;
  supervisors?: InputMaybe<ApplicationViewSupervisorsArrayFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

export type ApplicationViewNominationSubmissionFilter = {
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicationViewOfferModelFilter = {
  status?: InputMaybe<StringFilter>;
};

export type ApplicationViewPartnerFilter = {
  university?: InputMaybe<StringFilter>;
  universityCategory?: InputMaybe<StringFilter>;
};

export type ApplicationViewProgrammeChoiceFilter = {
  _id?: InputMaybe<StringFilter>;
  acceptNoResearchIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  department?: InputMaybe<StringFilter>;
  entryYear?: InputMaybe<StringFilter>;
  partner?: InputMaybe<ApplicationViewPartnerFilter>;
  programme?: InputMaybe<StringFilter>;
  programmeType?: InputMaybe<StringFilter>;
  proposedChiefSupervisor?: InputMaybe<StringFilter>;
  proposedChiefSupervisorBackup?: InputMaybe<StringFilter>;
  rejectedByFirstChoice?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

export type ApplicationViewSort = {
  _id?: InputMaybe<Sorting_Order>;
  assessment?: InputMaybe<ApplicationViewAssessmentSort>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  status?: InputMaybe<Sorting_Order>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
};

export type ApplicationViewSupervisorsArrayFilter = {
  confirmedAsCoSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  elemMatch?: InputMaybe<ApplicationViewSupervisorsFilter>;
  netId?: InputMaybe<StringFilter>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<StringFilter>;
};

export type ApplicationViewSupervisorsFilter = {
  confirmedAsCoSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  netId?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type ApplicationViewVisaModelFilter = {
  applicationNo?: InputMaybe<StringFilter>;
  referenceNo?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

export type Assessment = {
  __typename?: 'Assessment';
  applicationId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dsrcAdmissionForm?: Maybe<Scalars['String']['output']>;
  dsrcAssessment?: Maybe<Scalars['String']['output']>;
  dsrcInterestConflictApproval?: Maybe<Scalars['String']['output']>;
  frcsbAssessment?: Maybe<Scalars['String']['output']>;
  hodDosAssessment?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AssessmentStatus>;
  submissionTime?: Maybe<Array<SubmissionToGs>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AssessmentDoc = {
  __typename?: 'AssessmentDoc';
  _id: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dsrcAdmissionForm?: Maybe<Scalars['String']['output']>;
  dsrcAssessment?: Maybe<Scalars['String']['output']>;
  dsrcInterestConflictApproval?: Maybe<Scalars['String']['output']>;
  frcsbAssessment?: Maybe<Scalars['String']['output']>;
  hodDosAssessment?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AssessmentStatus>;
  submissionTime?: Maybe<Array<SubmissionToGs>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AssessmentFilter = {
  applicationId: Scalars['String']['input'];
};

export type AssessmentPayload = {
  __typename?: 'AssessmentPayload';
  _id?: Maybe<Scalars['ID']['output']>;
  applicationId: Scalars['String']['output'];
  dsrcAdmissionForm?: Maybe<DsrcAdmissionFormPayload>;
  dsrcAssessment?: Maybe<DsrcAssessmentPayload>;
  /** This list returns A to F, indicating the steps that have been edited by the user. The last updated time is Apr. 8th. */
  dsrcAssessmentHasEdited?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dsrcInterestConflictApproval?: Maybe<DsrcInterestConflictApprovalPayload>;
  frcsbAssessment?: Maybe<FrcsbAssessmentPayload>;
  hodDosAssessment?: Maybe<HodDosAssessmentPayload>;
  status: AssessmentStatus;
};

export enum AssessmentStatus {
  AcceptedByCandidate = 'ACCEPTED_BY_CANDIDATE',
  Approved = 'APPROVED',
  ApprovedByDorpgs = 'APPROVED_BY_DORPGS',
  ApprovedByDsrc = 'APPROVED_BY_DSRC',
  ApprovedByFrcsb = 'APPROVED_BY_FRCSB',
  ApprovedByGs = 'APPROVED_BY_GS',
  ApprovedByHodDos = 'APPROVED_BY_HOD_DOS',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Failed = 'FAILED',
  Invalid = 'INVALID',
  Overdue = 'OVERDUE',
  Pending = 'PENDING',
  RejectedByDorpgs = 'REJECTED_BY_DORPGS',
  RejectedByDsrc = 'REJECTED_BY_DSRC',
  RejectedByFrcsb = 'REJECTED_BY_FRCSB',
  RejectedByGs = 'REJECTED_BY_GS',
  RejectedByHodDos = 'REJECTED_BY_HOD_DOS'
}

export type AssignGsDecisionInput = {
  applicationId: Scalars['String']['input'];
  assignee?: InputMaybe<Scalars['String']['input']>;
};

export type AssignPanelEntry = {
  applicationId: Scalars['String']['input'];
  netIds: Array<Scalars['String']['input']>;
};

export type AssignPanelInput = {
  /** If no entries are provided, all applications will be assigned to the panel. */
  entries?: InputMaybe<Array<AssignPanelEntry>>;
  panelId: Scalars['String']['input'];
};

export type AverageMarkPayload = {
  __typename?: 'AverageMarkPayload';
  averageMark?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use averageMark instead. */
  convertedGPA?: Maybe<Scalars['Float']['output']>;
};

export type AwardClassificationFilter = {
  eq?: InputMaybe<Award_Classification>;
  in?: InputMaybe<Array<Award_Classification>>;
  ne?: InputMaybe<Award_Classification>;
  nin?: InputMaybe<Array<Award_Classification>>;
};

export enum Bonus_Type {
  BestPaper = 'BEST_PAPER',
  CommunityService = 'COMMUNITY_SERVICE',
  ExhibitionsAndPerformances = 'EXHIBITIONS_AND_PERFORMANCES',
  MasterMphilDegree = 'MASTER_MPHIL_DEGREE',
  WorkExperience = 'WORK_EXPERIENCE'
}

export type BaseHoDApproval = {
  __typename?: 'BaseHoDApproval';
  accountCode?: Maybe<Scalars['String']['output']>;
  confirmation?: Maybe<Scalars['Boolean']['output']>;
  /** If this field is required for HoD/DoS to fill in. */
  required: Scalars['Boolean']['output'];
};

export type BaseHoDApprovalInput = {
  accountCode?: InputMaybe<Scalars['String']['input']>;
  confirmation?: InputMaybe<Scalars['Boolean']['input']>;
  /** If this field is required for HoD/DoS to fill in. */
  required: Scalars['Boolean']['input'];
};

export type Bonus = {
  __typename?: 'Bonus';
  justification: Scalars['String']['output'];
  name: Scalars['String']['output'];
  supportingDocuments: Array<FileType>;
};

export type BonusAssessmentInput = {
  bonusType: Scalars['String']['input'];
  confirmed: Scalars['Boolean']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type BonusAssessmentType = {
  __typename?: 'BonusAssessmentType';
  bonusType: Scalars['String']['output'];
  confirmed: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type BonusInput = {
  justification: Scalars['String']['input'];
  name: Bonus_Type;
  supportingDocuments: Array<FileTypeInput>;
};

export type CheckDetail = {
  __typename?: 'CheckDetail';
  item: PreliminaryCheckItem;
  result: PreliminaryCheckResult;
};

export type CoSupervisorFormPayload = {
  __typename?: 'CoSupervisorFormPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
  applicationId: Scalars['String']['output'];
  emailAddress: Scalars['String']['output'];
  netId?: Maybe<Scalars['String']['output']>;
  nominationId: Scalars['String']['output'];
};

export type ConditionDetail = {
  __typename?: 'ConditionDetail';
  detail?: Maybe<Scalars['String']['output']>;
  requirement: EntranceRequirement;
};

export type ConditionDetailInput = {
  detail?: InputMaybe<Scalars['String']['input']>;
  requirement: EntranceRequirement;
};

export type ConfigurationInput = {
  key: Scalars['String']['input'];
  subKey: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ConfigurationPayload = {
  __typename?: 'ConfigurationPayload';
  _id: Scalars['ID']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  key: Scalars['String']['output'];
  subKey: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ConvertGpaInput = {
  courses: Array<MarkInput>;
  digitToLetterRule?: InputMaybe<Scalars['String']['input']>;
  letterToGPARule?: InputMaybe<Scalars['String']['input']>;
};

/** Convert GPA input expanded. */
export type ConvertGpaInputV2 = {
  originalGPA?: InputMaybe<Scalars['Float']['input']>;
  originalGPAOutOf?: InputMaybe<Scalars['Float']['input']>;
  originalGPAOutOfString?: InputMaybe<Scalars['String']['input']>;
  originalGPAString?: InputMaybe<Scalars['String']['input']>;
  ruleId: Scalars['ID']['input'];
};

export type ConvertGpaPayloadV2 = {
  __typename?: 'ConvertGPAPayloadV2';
  convertedGPA: Scalars['Float']['output'];
};

export type ConvertGpaRuleInput = {
  /** The country/region of the institution. Use the label rather than the value of the master data, i.e. China rather than CHN. Cannot use with ruleId. */
  countryRegion?: InputMaybe<Scalars['String']['input']>;
  /** The name of the institution. Need to be exactly the same as the institution name in the rule. Cannot use with ruleId. */
  institutionName?: InputMaybe<Scalars['String']['input']>;
  /** ID of the rule. Cannot use with institutionName or countryRegion. */
  ruleId?: InputMaybe<Scalars['String']['input']>;
};

export type ConvertGpaRulePayload = {
  __typename?: 'ConvertGPARulePayload';
  defaultRule: InterpolatingGpaRulePayload;
  matchedRules: Array<InterpolatingGpaRulePayload>;
  /** @deprecated Will not provide the options to the frontend. */
  providedRules: Array<InterpolatingGpaRulePayload>;
};

export type CreateAcademicQualificationAssessmentInput = {
  academicQualificationAssessmentInputs?: InputMaybe<Array<AcademicAssessmentTypeInput>>;
  applicationId: Scalars['String']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAcademicQualificationInput = {
  academicCredentialIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  academicOnlineVerificationCode?: InputMaybe<Scalars['String']['input']>;
  awardClassification?: InputMaybe<Award_Classification>;
  awardDate?: InputMaybe<Scalars['DateTime']['input']>;
  certificates?: InputMaybe<Array<FileTypeInput>>;
  classRankProofs?: InputMaybe<Array<FileTypeInput>>;
  convertGPARuleId?: InputMaybe<Scalars['String']['input']>;
  currentStudyYear: Scalars['Float']['input'];
  degreeCertIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  degreeLevel: Degree_Level;
  degreeOnlineVerificationCode?: InputMaybe<Scalars['String']['input']>;
  expectUpdateDate?: InputMaybe<Scalars['DateTime']['input']>;
  from: Scalars['DateTime']['input'];
  gpaIndicator: Scalars['Boolean']['input'];
  institution: InstitutionInput;
  instructionMedium: Scalars['String']['input'];
  markConversion?: InputMaybe<MarkConversionInput>;
  markExplanations?: InputMaybe<Array<FileTypeInput>>;
  marks?: InputMaybe<Array<MarkInput>>;
  officialClassRanking?: InputMaybe<Scalars['Float']['input']>;
  officialMark?: InputMaybe<Scalars['String']['input']>;
  otherDocuments?: InputMaybe<Array<FileTypeInput>>;
  otherInstructionMedium?: InputMaybe<Scalars['String']['input']>;
  outOfGpa?: InputMaybe<Scalars['Float']['input']>;
  outOfRank?: InputMaybe<Scalars['Float']['input']>;
  presentIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  programmeName: Scalars['String']['input'];
  qualificationMeans: Qualification_Means;
  qualificationStatus: Qualification_Status;
  rankIndicator: Scalars['Boolean']['input'];
  studyField: Scalars['String']['input'];
  studyMode: Studu_Mode;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  transcripts?: InputMaybe<Array<FileTypeInput>>;
  withdrawDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateAcademicRefereeInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  institution?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<NameInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberAreaCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumberCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumberNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateActivityInput = {
  activityType: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  majorResponsibilities?: InputMaybe<Scalars['String']['input']>;
  organisationName: Scalars['String']['input'];
  position: Scalars['String']['input'];
  presentActivityIndicator: Scalars['Boolean']['input'];
  supportingDocuments: Array<FileTypeInput>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  volunteerMode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdditionalDocumentInput = {
  documentType: Scalars['String']['input'];
  supportingDocuments: Array<FileTypeInput>;
};

export type CreateApplicantInput = {
  PIDeclaration: Scalars['Boolean']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  /** The city of the address. Required. ADD Jun 4. */
  addressCountryRegion: Scalars['String']['input'];
  /** The first line of the address. Required. ADD Jun 4. */
  addressLine1: Scalars['String']['input'];
  /** The second line of the address. Optional. ADD Jun 4. */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The third line of the address. Optional. ADD Jun 4. */
  addressLine3?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth: Scalars['DateTime']['input'];
  disabilitySpecial?: InputMaybe<DisabilitySpecialInput>;
  email: Scalars['String']['input'];
  gender: Gender;
  identity: IdentityInput;
  mobileNumber: Scalars['String']['input'];
  name: ApplicantNameInput;
  nationality: Scalars['String']['input'];
  province?: InputMaybe<Scalars['String']['input']>;
  telephoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicationDeclarationInput = {
  applicationId: Scalars['ID']['input'];
  confirmation?: InputMaybe<Scalars['Boolean']['input']>;
  engagement?: InputMaybe<Scalars['Boolean']['input']>;
  informationAccuracy?: InputMaybe<Scalars['Boolean']['input']>;
  personalType?: InputMaybe<Personal_Info_Type>;
};

export type CreateApplicationInput = {
  applicant: Scalars['ID']['input'];
  /** ID of the programme choice. */
  programmeChoice?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicationProofInput = {
  applicationId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  documentType: Proof_Document_Type;
  remark?: InputMaybe<Scalars['String']['input']>;
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
};

export type CreateBonusAssessmentInput = {
  applicationId: Scalars['String']['input'];
  bonusAssessments?: InputMaybe<Array<BonusAssessmentInput>>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDsrcAdmissionInput = {
  applicationId: Scalars['ID']['input'];
  conditionDetails?: InputMaybe<Array<ConditionDetailInput>>;
  conditionFulfillingDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  conditions?: InputMaybe<Array<EntranceRequirement>>;
  confirmationChairInTeam?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationDoRPgSInTeam?: InputMaybe<Scalars['Boolean']['input']>;
  contactDepartmentPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactDepartmentPersonName?: InputMaybe<Scalars['String']['input']>;
  contactDepartmentPersonPhone?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  departmentAccountCode?: InputMaybe<Scalars['String']['input']>;
  dsrcDecision?: InputMaybe<Dsrc_Decision_Type>;
  entranceRequirement?: InputMaybe<EntranceRequirement>;
  entranceRequirementOthers?: InputMaybe<Scalars['String']['input']>;
  entranceRequirementWaive?: InputMaybe<Scalars['Boolean']['input']>;
  isFirmOffer?: InputMaybe<Scalars['Boolean']['input']>;
  monthsToProvide?: InputMaybe<Scalars['Int']['input']>;
  offerApproval?: InputMaybe<Scalars['Boolean']['input']>;
  plagiarismCheck?: InputMaybe<Scalars['Boolean']['input']>;
  plagiarismFound?: InputMaybe<Scalars['Boolean']['input']>;
  rejectionRemarks?: InputMaybe<Scalars['String']['input']>;
  /** Use remarks instead. */
  remarkUponReturn?: InputMaybe<Scalars['String']['input']>;
  /** The reason for the decision. */
  remarks?: InputMaybe<Scalars['String']['input']>;
  stipendApproval?: InputMaybe<Scalars['Boolean']['input']>;
  tuitionAssistantship?: InputMaybe<Scalars['Boolean']['input']>;
  tuitionAssistantshipType?: InputMaybe<TuitionAssistantship>;
  tuitionFeeAccountCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDsrcDeclarationInput = {
  PIofGRF?: InputMaybe<Scalars['Boolean']['input']>;
  PIofStem?: InputMaybe<Scalars['Boolean']['input']>;
  accuracy?: InputMaybe<Scalars['Boolean']['input']>;
  applicationId: Scalars['String']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  departmentStipend?: InputMaybe<Scalars['Boolean']['input']>;
  proof?: InputMaybe<Scalars['Boolean']['input']>;
  recommendThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  stipendBudgetReserved?: InputMaybe<Scalars['Boolean']['input']>;
  support?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateDepartmentInputInput = {
  applicationId: Scalars['ID']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  departmentInputs?: InputMaybe<DepartmentInputAssessmentInput>;
};

export type CreateDistinctiveScholarshipInput = {
  applicationId: Scalars['String']['input'];
  distinctiveScholarships?: InputMaybe<Array<DistinctiveScholarshipTypeInput>>;
};

export type CreateDsrcInterestConflictApprovalInput = {
  applicationId: Scalars['String']['input'];
  approveDoRPgSInTeam?: InputMaybe<Dsrc_Interest_Conflict_Decision>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEmploymentInput = {
  employmentField?: InputMaybe<Scalars['String']['input']>;
  employmentMode?: InputMaybe<EmploymentMode>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  majorResponsibilities?: InputMaybe<Scalars['String']['input']>;
  organisationName?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  presentEmploymentIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateFrcsbAssessmentInput = {
  applicationId: Scalars['String']['input'];
  approveDsrcChairInTeam?: InputMaybe<FrcsbDecision>;
  approveWaivingEntranceRequirements?: InputMaybe<FrcsbDecision>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  remarkToDSRC?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGsDecisionInput = {
  allItemChecked?: InputMaybe<Scalars['Boolean']['input']>;
  applicationId: Scalars['String']['input'];
};

export type CreateHkpfsInformationInput = {
  HKPFSReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  applicationId: Scalars['String']['input'];
  isHKPFSApplicant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateInterviewPanelInput = {
  applicationId: Scalars['String']['input'];
  externalInterviewPanel?: InputMaybe<Array<Scalars['String']['input']>>;
  interviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  interviewLanguage?: InputMaybe<Interview_Panel_Language>;
  interviewMode?: InputMaybe<Interview_Panel_Mode>;
  /** The panel has agreed that the panel chair submit the form. */
  panelAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  panelMembers?: InputMaybe<Array<PanelMemberInput>>;
};

export type CreateLanguageQualificationInput = {
  expectedResultUpdateDate?: InputMaybe<Scalars['DateTime']['input']>;
  needEnglishTest?: InputMaybe<Scalars['Boolean']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<LanguageQualificationResultInput>;
  resultAnnouncedIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
  testDate?: InputMaybe<Scalars['DateTime']['input']>;
  testType?: InputMaybe<Language_Qualification_Test_Type>;
};

export type CreateMeritAssessmentInput = {
  applicationId: Scalars['String']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  meritAssessments?: InputMaybe<Array<MeritAssessmentInput>>;
};

export type CreateMeritInput = {
  attainmentMeans?: InputMaybe<Scalars['String']['input']>;
  awardBodyName?: InputMaybe<Scalars['String']['input']>;
  awardDate?: InputMaybe<Scalars['DateTime']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  meritName?: InputMaybe<Scalars['String']['input']>;
  supportingDocuments?: InputMaybe<Array<InputMaybe<FileTypeInput>>>;
};

export type CreateNominationInput = {
  admission?: InputMaybe<AdmissionInput>;
  applicant: Scalars['ID']['input'];
  application: Scalars['ID']['input'];
  declarations?: InputMaybe<Array<DeclarationInput>>;
  funding?: InputMaybe<FundingInput>;
  fundings?: InputMaybe<Array<FundingInput>>;
  remarks?: InputMaybe<Array<Scalars['String']['input']>>;
  submission?: InputMaybe<SubmissionInput>;
  supervisors?: InputMaybe<Array<SupervisorsInput>>;
};

export type CreateOtherTestInput = {
  expectedResultUpdateDate?: InputMaybe<Scalars['DateTime']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<OtherTestResultInput>;
  resultAnnouncedIndicator: Scalars['Boolean']['input'];
  supportingDocuments: Array<FileTypeInput>;
  testDate?: InputMaybe<Scalars['DateTime']['input']>;
  testType: Other_Test_Test_Type;
};

export type CreatePanelInput = {
  endDate: Scalars['DateTime']['input'];
  entryYear?: InputMaybe<Scalars['String']['input']>;
  fundingSource: Funding_Source;
  /** Net ID of the GS Helper */
  gsHelper: Scalars['String']['input'];
  /** Net ID of the Chair */
  panelChair?: InputMaybe<PanelMemberInput>;
  /** Net IDs of the Panel Members */
  panelMembers: Array<PanelMemberInput>;
  panelRound?: InputMaybe<Scalars['Float']['input']>;
  panelType: Funding_Panel;
  resultOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate: Scalars['DateTime']['input'];
  status?: PanelStatus;
  tagOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalRound?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateProfessionalQualificationInput = {
  attainmentMeans?: InputMaybe<Scalars['String']['input']>;
  awardBodyName?: InputMaybe<Scalars['String']['input']>;
  awardDate?: InputMaybe<Scalars['DateTime']['input']>;
  awardName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  otherAwardBodyName?: InputMaybe<Scalars['String']['input']>;
  professionField?: InputMaybe<Scalars['String']['input']>;
  professionalQualification?: InputMaybe<Scalars['String']['input']>;
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
};

export type CreateProgrammeChoiceInput = {
  acceptNoResearchIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  applicantId?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  entryYear?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<PartnerInput>;
  programme?: InputMaybe<Programme>;
  programmeType?: InputMaybe<Programme_Type>;
  proposedChiefSupervisor?: InputMaybe<Scalars['String']['input']>;
  proposedChiefSupervisorBackup?: InputMaybe<Scalars['String']['input']>;
  researchArea?: InputMaybe<Scalars['String']['input']>;
  researchAreaBackup?: InputMaybe<Scalars['String']['input']>;
  studyMode?: InputMaybe<Programme_Choice_Study_Mode>;
};

export type CreatePublicationAssessmentInput = {
  applicationId: Scalars['String']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  publicationAssessments?: InputMaybe<Array<PublicationAssessmentInput>>;
};

export type CreatePublicationInput = {
  applicantRole?: InputMaybe<Applicant_Role>;
  citationInfo?: InputMaybe<Scalars['String']['input']>;
  issuePageArticelNo?: InputMaybe<Scalars['String']['input']>;
  peerReviewedIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  publicationAuthors?: InputMaybe<Scalars['String']['input']>;
  publicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  publicationName?: InputMaybe<Scalars['String']['input']>;
  publicationStatus?: InputMaybe<PublicationStatus>;
  publicationTitle?: InputMaybe<Scalars['String']['input']>;
  publicationType?: InputMaybe<Scalars['String']['input']>;
  publicationUrl?: InputMaybe<Scalars['String']['input']>;
  specificRole?: InputMaybe<Scalars['String']['input']>;
  supportingDocuments?: InputMaybe<Array<InputMaybe<FileTypeInput>>>;
};

export type CreateResearchExperienceInput = {
  expectedContribution?: InputMaybe<Scalars['String']['input']>;
  longTermCareerPlan?: InputMaybe<Scalars['String']['input']>;
  others?: InputMaybe<Scalars['String']['input']>;
  pastResearchExperience?: InputMaybe<Scalars['String']['input']>;
  proposedResearchPlan?: InputMaybe<Scalars['String']['input']>;
  proposedResearchTopic?: InputMaybe<Scalars['String']['input']>;
  reasons?: InputMaybe<Scalars['String']['input']>;
  researchProposal?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStudentRecordInput = {
  applicationId: Scalars['ID']['input'];
  /** The base64 encoded photo. */
  photoBase64: Scalars['String']['input'];
  /** The file uploaded to OSS. Backend will take the record only. */
  photoFile: FileTypeInput;
};

export type CreateTrainingInput = {
  country: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  organisationName: Scalars['String']['input'];
  presentTrainingIndicator: Scalars['Boolean']['input'];
  programmeName: Scalars['String']['input'];
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateUserInputV2 = {
  password: Scalars['String']['input'];
  submissionCode?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export enum Degree_Level {
  BachelorDegree = 'BACHELOR_DEGREE',
  BachelorDegreeMinor = 'BACHELOR_DEGREE_MINOR',
  DoctorateDegree = 'DOCTORATE_DEGREE',
  MasterDegree = 'MASTER_DEGREE',
  Others = 'OTHERS'
}

export type DsrcAdmissionForm = {
  __typename?: 'DSRCAdmissionForm';
  applicationId: Scalars['ID']['output'];
  conditionDetails?: Maybe<Array<ConditionDetail>>;
  conditionFulfillingDeadline?: Maybe<Scalars['DateTime']['output']>;
  conditions?: Maybe<Array<EntranceRequirement>>;
  confirmationChairInTeam: Scalars['Boolean']['output'];
  /** ADD Sep 11. Confirmation of the DoRPgS in the team. All previous data will be regarded as NO. */
  confirmationDoRPgSInTeam: Scalars['Boolean']['output'];
  contactDepartmentPersonEmail?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonName?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  departmentAccountCode?: Maybe<Scalars['String']['output']>;
  dsrcDecision?: Maybe<Dsrc_Decision_Type>;
  /** @deprecated Use array form. */
  entranceRequirement?: Maybe<EntranceRequirement>;
  entranceRequirementOthers?: Maybe<Scalars['String']['output']>;
  entranceRequirementWaive?: Maybe<Scalars['Boolean']['output']>;
  isFirmOffer?: Maybe<Scalars['Boolean']['output']>;
  monthsToProvide?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Will need to specify the offer approval status. */
  offerApproval?: Maybe<Scalars['Boolean']['output']>;
  plagiarismCheck?: Maybe<Scalars['Boolean']['output']>;
  plagiarismFound?: Maybe<Scalars['Boolean']['output']>;
  rejectionRemarks?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use remarks instead. */
  remarkUponReturn?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  stipendApproval: Scalars['Boolean']['output'];
  supervisorAccountCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use type directly. */
  tuitionAssistantship?: Maybe<Scalars['Boolean']['output']>;
  tuitionAssistantshipType?: Maybe<TuitionAssistantship>;
  tuitionFeeAccountCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type DsrcAdmissionFormDoc = {
  __typename?: 'DSRCAdmissionFormDoc';
  _id: Scalars['String']['output'];
  applicationId: Scalars['ID']['output'];
  conditionDetails?: Maybe<Array<ConditionDetail>>;
  conditionFulfillingDeadline?: Maybe<Scalars['DateTime']['output']>;
  conditions?: Maybe<Array<EntranceRequirement>>;
  confirmationChairInTeam: Scalars['Boolean']['output'];
  /** ADD Sep 11. Confirmation of the DoRPgS in the team. All previous data will be regarded as NO. */
  confirmationDoRPgSInTeam: Scalars['Boolean']['output'];
  contactDepartmentPersonEmail?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonName?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  departmentAccountCode?: Maybe<Scalars['String']['output']>;
  dsrcDecision?: Maybe<Dsrc_Decision_Type>;
  /** @deprecated Use array form. */
  entranceRequirement?: Maybe<EntranceRequirement>;
  entranceRequirementOthers?: Maybe<Scalars['String']['output']>;
  entranceRequirementWaive?: Maybe<Scalars['Boolean']['output']>;
  isFirmOffer?: Maybe<Scalars['Boolean']['output']>;
  monthsToProvide?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Will need to specify the offer approval status. */
  offerApproval?: Maybe<Scalars['Boolean']['output']>;
  plagiarismCheck?: Maybe<Scalars['Boolean']['output']>;
  plagiarismFound?: Maybe<Scalars['Boolean']['output']>;
  rejectionRemarks?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use remarks instead. */
  remarkUponReturn?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  stipendApproval: Scalars['Boolean']['output'];
  supervisorAccountCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use type directly. */
  tuitionAssistantship?: Maybe<Scalars['Boolean']['output']>;
  tuitionAssistantshipType?: Maybe<TuitionAssistantship>;
  tuitionFeeAccountCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type DsrcAdmissionFormPayload = {
  __typename?: 'DSRCAdmissionFormPayload';
  _id?: Maybe<Scalars['ID']['output']>;
  applicationId?: Maybe<Scalars['ID']['output']>;
  conditionDetails?: Maybe<Array<ConditionDetail>>;
  conditionFulfillingDeadline?: Maybe<Scalars['DateTime']['output']>;
  conditions?: Maybe<Array<EntranceRequirement>>;
  confirmationChairInTeam?: Maybe<Scalars['Boolean']['output']>;
  /** ADD Sep 11. Confirmation of the DoRPgS in the team. All previous data will be regarded as NO. */
  confirmationDoRPgSInTeam?: Maybe<Scalars['Boolean']['output']>;
  contactDepartmentPersonEmail?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonName?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  departmentAccountCode?: Maybe<Scalars['String']['output']>;
  dsrcDecision?: Maybe<Dsrc_Decision_Type>;
  /** @deprecated Use array form. */
  entranceRequirement?: Maybe<EntranceRequirement>;
  entranceRequirementOthers?: Maybe<Scalars['String']['output']>;
  entranceRequirementWaive?: Maybe<Scalars['Boolean']['output']>;
  isFirmOffer?: Maybe<Scalars['Boolean']['output']>;
  monthsToProvide?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Will need to specify the offer approval status. */
  offerApproval?: Maybe<Scalars['Boolean']['output']>;
  plagiarismCheck?: Maybe<Scalars['Boolean']['output']>;
  plagiarismFound?: Maybe<Scalars['Boolean']['output']>;
  rejectionRemarks?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use remarks instead. */
  remarkUponReturn?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  stipendApproval?: Maybe<Scalars['Boolean']['output']>;
  supervisorAccountCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use type directly. */
  tuitionAssistantship?: Maybe<Scalars['Boolean']['output']>;
  tuitionAssistantshipType?: Maybe<TuitionAssistantship>;
  tuitionFeeAccountCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type DsrcAdmissionPayload = {
  __typename?: 'DSRCAdmissionPayload';
  _id: Scalars['ID']['output'];
  applicationId?: Maybe<Scalars['ID']['output']>;
  conditionDetails?: Maybe<Array<ConditionDetail>>;
  conditionFulfillingDeadline?: Maybe<Scalars['DateTime']['output']>;
  conditions?: Maybe<Array<EntranceRequirement>>;
  confirmationChairInTeam?: Maybe<Scalars['Boolean']['output']>;
  /** ADD Sep 11. Confirmation of the DoRPgS in the team. All previous data will be regarded as NO. */
  confirmationDoRPgSInTeam?: Maybe<Scalars['Boolean']['output']>;
  contactDepartmentPersonEmail?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonName?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  departmentAccountCode?: Maybe<Scalars['String']['output']>;
  dsrcDecision?: Maybe<Dsrc_Decision_Type>;
  /** @deprecated Use array form. */
  entranceRequirement?: Maybe<EntranceRequirement>;
  entranceRequirementOthers?: Maybe<Scalars['String']['output']>;
  entranceRequirementWaive?: Maybe<Scalars['Boolean']['output']>;
  isFirmOffer?: Maybe<Scalars['Boolean']['output']>;
  monthsToProvide?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Will need to specify the offer approval status. */
  offerApproval?: Maybe<Scalars['Boolean']['output']>;
  plagiarismCheck?: Maybe<Scalars['Boolean']['output']>;
  plagiarismFound?: Maybe<Scalars['Boolean']['output']>;
  rejectionRemarks?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use remarks instead. */
  remarkUponReturn?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  stipendApproval?: Maybe<Scalars['Boolean']['output']>;
  supervisorAccountCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use type directly. */
  tuitionAssistantship?: Maybe<Scalars['Boolean']['output']>;
  tuitionAssistantshipType?: Maybe<TuitionAssistantship>;
  tuitionFeeAccountCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type DsrcAssessment = {
  __typename?: 'DSRCAssessment';
  academicAssessments?: Maybe<Array<Maybe<AcademicAssessmentType>>>;
  applicationId: Scalars['ID']['output'];
  bonusAssessments?: Maybe<Array<Maybe<BonusAssessmentType>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  departmentInputs?: Maybe<DepartmentInputAssessmentType>;
  dsrcDeclaration?: Maybe<DsrcDeclarationType>;
  dsrcGrading?: Maybe<DsrcGrading>;
  meritAssessments?: Maybe<Array<Maybe<MeritAssessmentType>>>;
  publicationAssessments?: Maybe<Array<Maybe<PublicationAssessmentType>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type DsrcAssessmentDoc = {
  __typename?: 'DSRCAssessmentDoc';
  _id: Scalars['String']['output'];
  academicAssessments?: Maybe<Array<Maybe<AcademicAssessmentType>>>;
  applicationId: Scalars['ID']['output'];
  bonusAssessments?: Maybe<Array<Maybe<BonusAssessmentType>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  departmentInputs?: Maybe<DepartmentInputAssessmentType>;
  dsrcDeclaration?: Maybe<DsrcDeclarationType>;
  dsrcGrading?: Maybe<DsrcGrading>;
  meritAssessments?: Maybe<Array<Maybe<MeritAssessmentType>>>;
  publicationAssessments?: Maybe<Array<Maybe<PublicationAssessmentType>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type DsrcAssessmentPayload = {
  __typename?: 'DSRCAssessmentPayload';
  _id?: Maybe<Scalars['ID']['output']>;
  academicAssessments?: Maybe<Array<AcademicAssessmentType>>;
  applicationId?: Maybe<Scalars['ID']['output']>;
  bonusAssessments?: Maybe<Array<BonusAssessmentType>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  departmentInputs?: Maybe<DepartmentInputAssessmentType>;
  dsrcDeclaration?: Maybe<DsrcDeclarationType>;
  dsrcGrading?: Maybe<DsrcGrading>;
  meritAssessments?: Maybe<Array<MeritAssessmentType>>;
  publicationAssessments?: Maybe<Array<PublicationAssessmentType>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type DsrcDeclarationType = {
  __typename?: 'DSRCDeclarationType';
  PIofGRF?: Maybe<Scalars['Boolean']['output']>;
  PIofStem?: Maybe<Scalars['Boolean']['output']>;
  accuracy?: Maybe<Scalars['Boolean']['output']>;
  proof?: Maybe<Scalars['Boolean']['output']>;
  recommendThreshold?: Maybe<Scalars['Boolean']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  stipendBudgetReserved?: Maybe<Scalars['Boolean']['output']>;
  support?: Maybe<Scalars['Boolean']['output']>;
};

export type DsrcGrading = {
  __typename?: 'DSRCGrading';
  RL1Count: Scalars['Int']['output'];
  RL1MeritCount: Scalars['Int']['output'];
  RL1PublicationCount: Scalars['Int']['output'];
  RL2Count: Scalars['Int']['output'];
  RL2MeritCount: Scalars['Int']['output'];
  RL2PublicationCount: Scalars['Int']['output'];
  applicationId: Scalars['String']['output'];
  bonus: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  departmentInput: Scalars['Float']['output'];
  firstDegreeAL: Scalars['Int']['output'];
  firstDegreeGPAOrClassRanking: Scalars['Float']['output'];
  firstDegreeUL: Scalars['Int']['output'];
  firstDegreeUniversityRanking: Scalars['Float']['output'];
  otherPublicationCount: Scalars['Int']['output'];
  publicationAndMerit: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DsrcInterestConflictApprovalPayload = {
  __typename?: 'DSRCInterestConflictApprovalPayload';
  _id: Scalars['ID']['output'];
  applicationId: Scalars['String']['output'];
  approveDoRPgSInTeam?: Maybe<Dsrc_Interest_Conflict_Decision>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** DSRC Decision Type */
export enum Dsrc_Decision_Type {
  Na = 'NA',
  OfferApproved = 'OFFER_APPROVED',
  Reject = 'REJECT',
  ReturnToApplicant = 'RETURN_TO_APPLICANT',
  ReturnToSupervisor = 'RETURN_TO_SUPERVISOR'
}

/** The decision for the D/SRC to approve that the DoRPgS is in the team. */
export enum Dsrc_Interest_Conflict_Decision {
  Accept = 'ACCEPT',
  Na = 'NA',
  Reject = 'REJECT',
  Return = 'RETURN'
}

export type DateFilter = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type Declaration = {
  __typename?: 'Declaration';
  confirmed: Scalars['Boolean']['output'];
  content?: Maybe<Nomination_Declaration_Type>;
  /** Free declaration text. */
  declaration?: Maybe<Scalars['String']['output']>;
  /** @deprecated No one use this. Backward compatibility. */
  justification?: Maybe<Scalars['String']['output']>;
};

export type DeclarationInput = {
  confirmed: Scalars['Boolean']['input'];
  content?: InputMaybe<Nomination_Declaration_Type>;
  /** Free declaration text. */
  declaration?: InputMaybe<Scalars['String']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
};

export type DeferOfferType = {
  __typename?: 'DeferOfferType';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  originalEntryYear: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  targetEntryYear: Scalars['String']['output'];
  targetRegistrationFeeDeadline: Scalars['DateTime']['output'];
};

export type DepartmentFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DepartmentInfo = {
  __typename?: 'DepartmentInfo';
  abbr: Scalars['String']['output'];
  name: Scalars['String']['output'];
  plan: ProgrammePlan;
};

export type DepartmentInputAssessmentInput = {
  confirmed: Scalars['Boolean']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  departmentInputs: Array<DepartmentInputDeclarationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type DepartmentInputAssessmentType = {
  __typename?: 'DepartmentInputAssessmentType';
  confirmed: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  departmentInputs: Array<DepartmentInputDeclarationType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DepartmentInputDeclarationInput = {
  content: DepartmentInputType;
  level: DepartmentInputLevel;
};

export type DepartmentInputDeclarationType = {
  __typename?: 'DepartmentInputDeclarationType';
  content: DepartmentInputType;
  level: DepartmentInputLevel;
};

export enum DepartmentInputLevel {
  Moderate = 'MODERATE',
  Na = 'NA',
  Strong = 'STRONG',
  VeryStrong = 'VERY_STRONG',
  VeryWeak = 'VERY_WEAK',
  Weak = 'WEAK'
}

export enum DepartmentInputType {
  ChiefSupervisorRecord = 'CHIEF_SUPERVISOR_RECORD',
  DepartmentalImpact = 'DEPARTMENTAL_IMPACT',
  HighQualityResearch = 'HIGH_QUALITY_RESEARCH',
  ReferenceLetters = 'REFERENCE_LETTERS'
}

export type DepartmentType = {
  __typename?: 'DepartmentType';
  label: Scalars['String']['output'];
  proposedChiefSupervisors?: Maybe<Array<Scalars['String']['output']>>;
  researchAreas?: Maybe<Array<Scalars['String']['output']>>;
  value: Scalars['String']['output'];
};

export type DisabilitySpecial = {
  __typename?: 'DisabilitySpecial';
  disabilitySpecialDetail?: Maybe<Scalars['String']['output']>;
  /** The type of disability special educational needs. Removed the enum. MOD Jun 4. */
  disabilitySpecialType?: Maybe<Scalars['String']['output']>;
};

export type DisabilitySpecialInput = {
  disabilitySpecialDetail?: InputMaybe<Scalars['String']['input']>;
  /** The type of disability special educational needs. Removed the enum. MOD Jun 4. */
  disabilitySpecialType?: InputMaybe<Scalars['String']['input']>;
};

export type DisabilitySpecialSort = {
  disabilitySpecialDetail?: InputMaybe<Sorting_Order>;
  disabilitySpecialType?: InputMaybe<Sorting_Order>;
};

export enum DisciplineRankingSystemType {
  Ul1 = 'UL1',
  Ul2 = 'UL2',
  Ul3 = 'UL3',
  Ul4 = 'UL4',
  Ul5 = 'UL5'
}

export type DisciplineSpecificList = {
  __typename?: 'DisciplineSpecificList';
  discipline: Scalars['String']['output'];
  ranking: DisciplineRankingSystemType;
  score: Scalars['Int']['output'];
  universityLevel: Scalars['Int']['output'];
};

export type DisciplineSpecificListInput = {
  discipline: Scalars['String']['input'];
  ranking: DisciplineRankingSystemType;
  score: Scalars['Int']['input'];
  universityLevel: Scalars['Int']['input'];
};

export type DistinctiveScholarshipType = {
  __typename?: 'DistinctiveScholarshipType';
  files?: Maybe<Array<FileType>>;
  fundingSource: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type DistinctiveScholarshipTypeInput = {
  files?: InputMaybe<Array<FileTypeInput>>;
  fundingSource: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type DrcApplicationPaginatedPayload = {
  __typename?: 'DrcApplicationPaginatedPayload';
  data: Array<DrcApplicationPayload>;
  paginator: PaginatorPayload;
};

export type DrcApplicationPayload = {
  __typename?: 'DrcApplicationPayload';
  applicantEmail?: Maybe<Scalars['String']['output']>;
  applicantName: Scalars['String']['output'];
  applicantNationality: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  applicationNo: Scalars['String']['output'];
  conditionFulfilled: Scalars['Boolean']['output'];
  department: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  entryYear: Scalars['String']['output'];
  isFirmOffer: Scalars['Boolean']['output'];
  meetConditionDeadline?: Maybe<Scalars['DateTime']['output']>;
  meetConditionStatus: MeetConditionStatus;
  meetConditionUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  offerDate: Scalars['DateTime']['output'];
  programme: Programme;
  programmeCode: Scalars['String']['output'];
  programmeType: Programme_Type;
};

export type DuplicateMap = {
  __typename?: 'DuplicateMap';
  after: Scalars['String']['output'];
  before: Scalars['String']['output'];
};

export type Eligibility = {
  __typename?: 'Eligibility';
  checked: Scalars['Boolean']['output'];
  funding: Funding_Source;
};

export type EligibilityCheckArrayFilter = {
  all?: InputMaybe<Array<EligibilityCheckArrayFilter>>;
  elemMatch?: InputMaybe<EligibilityCheckFilter>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

export type EligibilityCheckFilter = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  funding?: InputMaybe<StringFilter>;
};

export type EligibilityCheckInput = {
  eligibility?: InputMaybe<Array<EligibilityInput>>;
  /** Can currently use this. Will remove when UPAF on. */
  endorsement?: InputMaybe<Scalars['Boolean']['input']>;
  recommendation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EligibilityInput = {
  checked: Scalars['Boolean']['input'];
  funding: Funding_Source;
};

export type EmailTemplateType = {
  __typename?: 'EmailTemplateType';
  content: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  placeholder: Array<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  templateId: Scalars['String']['output'];
};

export type Employment = {
  __typename?: 'Employment';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  employmentField?: Maybe<Scalars['String']['output']>;
  employmentMode?: Maybe<EmploymentMode>;
  from?: Maybe<Scalars['DateTime']['output']>;
  majorResponsibilities?: Maybe<Scalars['String']['output']>;
  organisationName?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  presentEmploymentIndicator?: Maybe<Scalars['Boolean']['output']>;
  supportingDocuments?: Maybe<Array<FileType>>;
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum EmploymentMode {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME'
}

export type EmploymentPayload = {
  __typename?: 'EmploymentPayload';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  employmentField?: Maybe<Scalars['String']['output']>;
  employmentMode?: Maybe<EmploymentMode>;
  from?: Maybe<Scalars['DateTime']['output']>;
  majorResponsibilities?: Maybe<Scalars['String']['output']>;
  organisationName?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  presentEmploymentIndicator?: Maybe<Scalars['Boolean']['output']>;
  supportingDocuments?: Maybe<Array<FileType>>;
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type EmploymentSort = {
  _id?: InputMaybe<Sorting_Order>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  employmentField?: InputMaybe<Sorting_Order>;
  employmentMode?: InputMaybe<Sorting_Order>;
  from?: InputMaybe<Sorting_Order>;
  majorResponsibilities?: InputMaybe<Sorting_Order>;
  organisationName?: InputMaybe<Sorting_Order>;
  position?: InputMaybe<Sorting_Order>;
  presentEmploymentIndicator?: InputMaybe<Sorting_Order>;
  to?: InputMaybe<Sorting_Order>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
};

export type EnglishLanguageRequirement = {
  __typename?: 'EnglishLanguageRequirement';
  fulfilled?: Maybe<Scalars['Boolean']['output']>;
  justification?: Maybe<Scalars['String']['output']>;
  requirements: Scalars['String']['output'];
};

export type EnglishLanguageRequirementArrayFilter = {
  all?: InputMaybe<Array<EnglishLanguageRequirementFilter>>;
  elemMatch?: InputMaybe<EnglishLanguageRequirementFilter>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

export type EnglishLanguageRequirementFilter = {
  and?: InputMaybe<Array<EnglishLanguageRequirementFilter>>;
  fulfilled?: InputMaybe<Scalars['Boolean']['input']>;
  justification?: InputMaybe<StringFilter>;
  nor?: InputMaybe<Array<EnglishLanguageRequirementFilter>>;
  not?: InputMaybe<EnglishLanguageRequirementFilter>;
  or?: InputMaybe<Array<EnglishLanguageRequirementFilter>>;
  requirements?: InputMaybe<StringFilter>;
};

export type EnglishLanguageRequirementInput = {
  fulfilled?: InputMaybe<Scalars['Boolean']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  requirements: Scalars['String']['input'];
};

/** The entrance requirement for the offer */
export enum EntranceRequirement {
  ConditionalAdditional = 'CONDITIONAL_ADDITIONAL',
  ConditionalEnglish = 'CONDITIONAL_ENGLISH',
  ConditionalGeneral = 'CONDITIONAL_GENERAL',
  ConditionalGeneralAndEnglish = 'CONDITIONAL_GENERAL_AND_ENGLISH',
  ConditionalOthers = 'CONDITIONAL_OTHERS',
  Firm = 'FIRM',
  Na = 'NA'
}

export type EntryYearInfoPayload = {
  __typename?: 'EntryYearInfoPayload';
  label: Scalars['String']['output'];
  shouldShow: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type EntryYearPayload = {
  __typename?: 'EntryYearPayload';
  applicationDeadline?: Maybe<Scalars['DateTime']['output']>;
  applicationFeeHalt?: Maybe<Scalars['Boolean']['output']>;
  applicationStart?: Maybe<Scalars['DateTime']['output']>;
  archived: Scalars['Boolean']['output'];
  displayText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  notification?: Maybe<Scalars['String']['output']>;
  registrationDeadline: Scalars['DateTime']['output'];
  tuitionFeePaymentDeadline: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
  welcomeLetter?: Maybe<Scalars['String']['output']>;
};

export type FrcsbAssessment = {
  __typename?: 'FRCSBAssessment';
  applicationId: Scalars['String']['output'];
  approveDsrcChairInTeam?: Maybe<FrcsbDecision>;
  approveWaivingEntranceRequirements?: Maybe<FrcsbDecision>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** @deprecated Use remarks instead. */
  remarkToDSRC?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FrcsbAssessmentDoc = {
  __typename?: 'FRCSBAssessmentDoc';
  _id: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  approveDsrcChairInTeam?: Maybe<FrcsbDecision>;
  approveWaivingEntranceRequirements?: Maybe<FrcsbDecision>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** @deprecated Use remarks instead. */
  remarkToDSRC?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export enum Funding_Panel {
  HumanitiesSocialSciencesBusinessStudies = 'HUMANITIES_SOCIAL_SCIENCES_BUSINESS_STUDIES',
  Mixed = 'MIXED',
  SciencesMedicineEngineeringTechnology = 'SCIENCES_MEDICINE_ENGINEERING_TECHNOLOGY'
}

export enum Funding_Round {
  First = 'FIRST',
  Second = 'SECOND'
}

export enum Funding_Schema {
  Competitive = 'COMPETITIVE',
  Incentive = 'INCENTIVE',
  NonCompetitive = 'NON_COMPETITIVE',
  Other = 'OTHER'
}

export enum Funding_Source {
  AllocaionPhdForMajorRenownedFundingAndRio = 'ALLOCAION_PHD_FOR_MAJOR_RENOWNED_FUNDING_AND_RIO',
  CollaborativePhdTrainingProgramme = 'COLLABORATIVE_PHD_TRAINING_PROGRAMME',
  Competitive_3Plus_1MatchingFundAndPppfs = 'COMPETITIVE_3_PLUS_1_MATCHING_FUND_AND_PPPFS',
  DepartmentalEarningsAccount = 'DEPARTMENTAL_EARNINGS_ACCOUNT',
  DualPhdDegreeProgramme = 'DUAL_PHD_DEGREE_PROGRAMME',
  ExternalGrantsFunds = 'EXTERNAL_GRANTS_FUNDS',
  GlobalStemProfessorshipScheme = 'GLOBAL_STEM_PROFESSORSHIP_SCHEME',
  HongkongPhdFellowshipScheme = 'HONGKONG_PHD_FELLOWSHIP_SCHEME',
  IncentiveDualPhdDegreeProgramme = 'INCENTIVE_DUAL_PHD_DEGREE_PROGRAMME',
  IncentiveGrfEcs_3Plus_1MatchingFund = 'INCENTIVE_GRF_ECS_3_PLUS_1_MATCHING_FUND',
  IncentiveHkpfs = 'INCENTIVE_HKPFS',
  InternationalPhdFellowshipScheme = 'INTERNATIONAL_PHD_FELLOWSHIP_SCHEME',
  NonStemNonShsNewRecruits = 'NON_STEM_NON_SHS_NEW_RECRUITS',
  PolyuCompetitivePhdFellowshipScheme = 'POLYU_COMPETITIVE_PHD_FELLOWSHIP_SCHEME',
  PolyuPresidentialPhdFellowshipScheme = 'POLYU_PRESIDENTIAL_PHD_FELLOWSHIP_SCHEME',
  ResearchUnit = 'RESEARCH_UNIT',
  SelfFinanced = 'SELF_FINANCED',
  StrategicHiringScheme = 'STRATEGIC_HIRING_SCHEME'
}

export enum Funding_Status {
  Application = 'APPLICATION',
  CsToDorpgs = 'CS_TO_DORPGS',
  DorpgsToGs = 'DORPGS_TO_GS',
  FailedList = 'FAILED_LIST',
  GsToRgc = 'GS_TO_RGC',
  RgcFailedList = 'RGC_FAILED_LIST',
  RgcSuccessfulList = 'RGC_SUCCESSFUL_LIST',
  RgcTopUpList = 'RGC_TOP_UP_LIST',
  RgcWaitingList = 'RGC_WAITING_LIST',
  SuccessfulExceptionallyGoodList = 'SUCCESSFUL_EXCEPTIONALLY_GOOD_LIST',
  SuccessfulGoodList = 'SUCCESSFUL_GOOD_LIST',
  SuccessfulList = 'SUCCESSFUL_LIST',
  SuccessfulOutstandingList = 'SUCCESSFUL_OUTSTANDING_LIST',
  SuccessfulVeryGoodList = 'SUCCESSFUL_VERY_GOOD_LIST'
}

export type FailedApplicationListFilter = {
  _id?: InputMaybe<StringFilter>;
  academicQualifications?: InputMaybe<AcademicQualificationArrayFilter>;
  academicReferees?: InputMaybe<AcademicRefereeArrayFilter>;
  and?: InputMaybe<Array<ApplicationFilter>>;
  applicant?: InputMaybe<ApplicantFilter>;
  applicationNo?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  hkpfsInformation?: InputMaybe<HkpfsInformationFilter>;
  nor?: InputMaybe<Array<ApplicationFilter>>;
  not?: InputMaybe<ApplicationFilter>;
  or?: InputMaybe<Array<ApplicationFilter>>;
  programmeChoice?: InputMaybe<ProgrammeChoiceFilter>;
  released?: InputMaybe<Scalars['Boolean']['input']>;
  revoked?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ApplicationStatusFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

export type FailedApplicationPaginatedPayload = {
  __typename?: 'FailedApplicationPaginatedPayload';
  data: Array<FailedApplicationPayload>;
  paginator: PaginatorPayload;
};

export type FailedApplicationPayload = {
  __typename?: 'FailedApplicationPayload';
  _id: Scalars['ID']['output'];
  academicQualifications?: Maybe<Array<Scalars['ID']['output']>>;
  academicReferees?: Maybe<Array<Scalars['ID']['output']>>;
  activities?: Maybe<Array<Scalars['ID']['output']>>;
  additionalDocuments?: Maybe<Array<Scalars['ID']['output']>>;
  applicant: ApplicantPayload;
  applicationNo: Scalars['String']['output'];
  /** For applicationNos that not fit the entry year, this field will store the original applicationNo before migration. */
  applicationNoPreMigration?: Maybe<Scalars['String']['output']>;
  backTo?: Maybe<Array<Application_Status>>;
  /** @deprecated Use the one in programmeChoice */
  chiefSupervisor?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  currentMPhilStudentToPhD?: Maybe<Scalars['Boolean']['output']>;
  declaration?: Maybe<ApplicationDeclarationType>;
  /** @deprecated Use the one in programmeChoice */
  department?: Maybe<Scalars['String']['output']>;
  distinctiveScholarships?: Maybe<Array<DistinctiveScholarshipType>>;
  employments?: Maybe<Array<Scalars['ID']['output']>>;
  hkpfsInformation?: Maybe<HkpfsInformation>;
  /** @deprecated Use the one in programmeChoice instead. */
  invitingSupervisorList?: Maybe<Array<Scalars['String']['output']>>;
  languageQualifications?: Maybe<Array<Scalars['ID']['output']>>;
  merits?: Maybe<Array<Scalars['ID']['output']>>;
  otherTests?: Maybe<Array<Scalars['ID']['output']>>;
  professionalQualifications?: Maybe<Array<Scalars['ID']['output']>>;
  programmeChoice: ProgrammeChoicePayload;
  proofDocuments?: Maybe<Array<ApplicationProofFileType>>;
  publications?: Maybe<Array<Scalars['ID']['output']>>;
  /** @deprecated Use the one in programmeChoice instead. */
  rejectedBySupervisorFirstChoice?: Maybe<Scalars['Boolean']['output']>;
  releaseDate?: Maybe<Scalars['DateTime']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  remarks?: Maybe<Array<ApplicationRemarkType>>;
  researchExperiences?: Maybe<Array<Scalars['ID']['output']>>;
  revoked?: Maybe<Scalars['Boolean']['output']>;
  status: Application_Status;
  trainings?: Maybe<Array<Scalars['ID']['output']>>;
  unsuccessfulRemark?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  virtualApplicationType?: Maybe<Scalars['String']['output']>;
};

export type FileCheck = {
  __typename?: 'FileCheck';
  checked: Scalars['Boolean']['output'];
  /** The file is generated and controlled in back-end. Not mutable, only as reference for items to be checked. */
  file: FileType;
};

export type FileCheckInput = {
  checked?: Scalars['Boolean']['input'];
  /** The file is generated and controlled in back-end. Not mutable, only as reference for items to be checked. */
  file: FileTypeInput;
};

export type FileType = {
  __typename?: 'FileType';
  id: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FileTypeInput = {
  id: Scalars['String']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FirstDegreeAssessmentType = {
  __typename?: 'FirstDegreeAssessmentType';
  awardClassification?: Maybe<Award_Classification>;
  candidateUniversityLevel?: Maybe<Scalars['Float']['output']>;
  classRanking?: Maybe<Scalars['Float']['output']>;
  classRankingOutOf?: Maybe<Scalars['Float']['output']>;
  currentStudy?: Maybe<Scalars['Boolean']['output']>;
  degreeLevel?: Maybe<Degree_Level>;
  displayRanking?: Maybe<Scalars['String']['output']>;
  gpa?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  originalGPA?: Maybe<Scalars['Float']['output']>;
  originalGPAOutOf?: Maybe<Scalars['Float']['output']>;
  rankings: Array<UniversityRanking>;
  referenceId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  universityLevel?: Maybe<Scalars['Float']['output']>;
};

export type FormQuestionType = {
  __typename?: 'FormQuestionType';
  answer: Scalars['String']['output'];
  number: Scalars['Float']['output'];
  question: Scalars['String']['output'];
};

export type FormQuestionTypeInput = {
  answer: Scalars['String']['input'];
  number: Scalars['Float']['input'];
  question: Scalars['String']['input'];
};

export type FrcsbAssessmentPayload = {
  __typename?: 'FrcsbAssessmentPayload';
  _id: Scalars['ID']['output'];
  applicationId?: Maybe<Scalars['String']['output']>;
  approveDsrcChairInTeam?: Maybe<FrcsbDecision>;
  approveWaivingEntranceRequirements?: Maybe<FrcsbDecision>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use remarks instead. */
  remarkToDSRC?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

/** The decision for the FRCSB */
export enum FrcsbDecision {
  Accept = 'ACCEPT',
  Na = 'NA',
  Reject = 'REJECT',
  Return = 'RETURN'
}

export type Funding = {
  __typename?: 'Funding';
  /** confirm accuracy of submitted account information when making up account code after panel */
  accountInfoAccurateConfirm?: Maybe<Scalars['Boolean']['output']>;
  /** [Added 10/24] Mark this funding failed in the previous round. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  bonus?: Maybe<Array<Bonus>>;
  checked?: Maybe<Scalars['Boolean']['output']>;
  /** [Added 10/24] Declaration of the funding. */
  declaration?: Maybe<Array<Declaration>>;
  endorsed: Array<UserRole>;
  /** confirm external grant or departmental approval when making up account code after panel */
  externalGrantsConfirm?: Maybe<Scalars['Boolean']['output']>;
  /** For front-end to track if the form is finished and submitted. */
  formFinished?: Maybe<Scalars['Boolean']['output']>;
  fundingPlan?: Maybe<Array<FundingPlan>>;
  giveUp?: Maybe<Scalars['Boolean']['output']>;
  /** [Added 10/24] Indicators of the funding. */
  indicators?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Will track the type in the scholarship nomination procedure. */
  panel?: Maybe<Funding_Panel>;
  panelRemark?: Maybe<Scalars['String']['output']>;
  projectInformation?: Maybe<ProjectInformation>;
  proofOfScheme?: Maybe<Array<FileType>>;
  /** @deprecated Will indicate by whether to select the HKPFS funding source directly. */
  recommendForHKPFS: Scalars['Boolean']['output'];
  /** @deprecated This comment will be merged into UPAF comment. */
  recommendation?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  requiredDocuments?: Maybe<Array<FileType>>;
  /** @deprecated Will track panel round in other fields, which may contain more information. */
  round?: Maybe<Scalars['String']['output']>;
  schema: Funding_Schema;
  /** [Added 10/24] Key to the funding source */
  source?: Maybe<Funding_Source>;
  /** @deprecated Will copy the whole section to the new schema. */
  sources?: Maybe<Array<Funding_Source>>;
  status?: Maybe<Funding_Status>;
  /** confirm stipend budget reservation when making up account code after panel */
  stipendBudgetCreationConfirm?: Maybe<Scalars['Boolean']['output']>;
  sufficientFundingConfirm?: Maybe<Scalars['Boolean']['output']>;
  /** The number of years that the funding can support for. Will be input by universty panel. */
  supportYears?: Maybe<Scalars['Float']['output']>;
};

export type FundingFilter = {
  and?: InputMaybe<Array<FundingFilter>>;
  indicators?: InputMaybe<StringFilter>;
  nor?: InputMaybe<Array<FundingFilter>>;
  not?: InputMaybe<FundingFilter>;
  or?: InputMaybe<Array<FundingFilter>>;
  recommendForHKPFS?: InputMaybe<Scalars['Boolean']['input']>;
  schema?: InputMaybe<FundingSchemaFilter>;
  source?: InputMaybe<FundingSourceFilter>;
  sufficientFundingConfirm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FundingInput = {
  /** confirm accuracy of submitted account information when making up account code after panel */
  accountInfoAccurateConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  bonus?: InputMaybe<Array<InputMaybe<BonusInput>>>;
  /** [Added 10/24] Provide the information for each funding now. */
  declaration?: InputMaybe<Array<DeclarationInput>>;
  /** confirm external grant or departmental approval when making up account code after panel */
  externalGrantsConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  formFinished?: InputMaybe<Scalars['Boolean']['input']>;
  fundingPlan?: InputMaybe<Array<InputMaybe<FundingPlanInput>>>;
  panel?: InputMaybe<Funding_Panel>;
  projectInformation?: InputMaybe<ProjectInformationInput>;
  proofOfScheme?: InputMaybe<Array<FileTypeInput>>;
  recommendForHKPFS?: Scalars['Boolean']['input'];
  recommendation?: InputMaybe<Scalars['String']['input']>;
  requiredDocuments?: InputMaybe<Array<FileTypeInput>>;
  round?: InputMaybe<Scalars['String']['input']>;
  schema: Funding_Schema;
  source?: InputMaybe<Funding_Source>;
  sources?: InputMaybe<Array<Funding_Source>>;
  /** confirm stipend budget reservation when making up account code after panel */
  stipendBudgetCreationConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  sufficientFundingConfirm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FundingOrderEntry = {
  __typename?: 'FundingOrderEntry';
  applicationId: Scalars['String']['output'];
  applicationNo?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
};

export type FundingOrderEntryInput = {
  applicationId: Scalars['String']['input'];
  applicationNo?: InputMaybe<Scalars['String']['input']>;
  order?: Scalars['Int']['input'];
};

export type FundingOrderUniqueKey = {
  academicYear?: InputMaybe<Scalars['String']['input']>;
  classification?: InputMaybe<Funding_Panel>;
  funding: Funding_Source;
  fundingOrderLevel?: InputMaybe<Scalars['Float']['input']>;
  round?: InputMaybe<Funding_Round>;
  unitName?: InputMaybe<Scalars['String']['input']>;
};

export type FundingOrderingModel = {
  __typename?: 'FundingOrderingModel';
  academicYear?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<Funding_Panel>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  funding: Funding_Source;
  fundingOrder?: Maybe<Array<FundingOrderEntry>>;
  fundingOrderLevel: Scalars['Float']['output'];
  round?: Maybe<Funding_Round>;
  submitted?: Maybe<Scalars['Boolean']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  unitName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type FundingPanelFilter = {
  eq?: InputMaybe<Funding_Panel>;
  in?: InputMaybe<Array<Funding_Panel>>;
  ne?: InputMaybe<Funding_Panel>;
  nin?: InputMaybe<Array<Funding_Panel>>;
};

export type FundingPlan = {
  __typename?: 'FundingPlan';
  accountCode?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Period>;
};

export type FundingPlanInput = {
  accountCode?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<PeriodInput>;
};

export type FundingPriorityOutput = {
  __typename?: 'FundingPriorityOutput';
  applications?: Maybe<Array<ApplicationPartialViewPayload>>;
  order?: Maybe<FundingOrderingModel>;
};

export type FundingSchemaFilter = {
  eq?: InputMaybe<Funding_Schema>;
  in?: InputMaybe<Array<Funding_Schema>>;
  ne?: InputMaybe<Funding_Schema>;
  nin?: InputMaybe<Array<Funding_Schema>>;
};

export type FundingSchemePayload = {
  __typename?: 'FundingSchemePayload';
  fundingIndicators: Scalars['JSONObject']['output'];
  mapping: Scalars['JSONObject']['output'];
  validTags: Array<Scalars['String']['output']>;
};

export type FundingSourceFilter = {
  eq?: InputMaybe<Funding_Source>;
  in?: InputMaybe<Array<Funding_Source>>;
  ne?: InputMaybe<Funding_Source>;
  nin?: InputMaybe<Array<Funding_Source>>;
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

/** GPA convert type */
export enum GpaConvertType {
  Institutional = 'INSTITUTIONAL',
  Regional = 'REGIONAL'
}

export type GsAssignee = {
  __typename?: 'GSAssignee';
  displayName: Scalars['String']['output'];
  netId: Scalars['String']['output'];
};

export type GsAssigneePayload = {
  __typename?: 'GSAssigneePayload';
  assigneeList: Array<GsAssignee>;
};

export type GsDecision = {
  __typename?: 'GSDecision';
  allItemChecked?: Maybe<Scalars['Boolean']['output']>;
  applicationId: Scalars['String']['output'];
  assignee?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<GsDecisionResult>;
  /** The email check for the offer. */
  emailCheck?: Maybe<OfferEmailCheck>;
  /** The file checks for the application. */
  fileChecks?: Maybe<Array<FileCheck>>;
  /** The file checks for the application. */
  filesHistory?: Maybe<Array<FileCheck>>;
  firstCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  firstCheckedBy?: Maybe<Scalars['String']['output']>;
  panelResults?: Maybe<Array<PanelResult>>;
  remarks?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use remarks instead */
  remarksToSupervisor?: Maybe<Scalars['String']['output']>;
  secondCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  secondCheckedBy?: Maybe<Scalars['String']['output']>;
  supersedeInput?: Maybe<PreviewOfferLetterPayload>;
  /** Save a superseded NoO that is generated but not yet released to applicant */
  supersededFile?: Maybe<FileCheck>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type GsDecisionDoc = {
  __typename?: 'GSDecisionDoc';
  _id: Scalars['String']['output'];
  allItemChecked?: Maybe<Scalars['Boolean']['output']>;
  applicationId: Scalars['String']['output'];
  assignee?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<GsDecisionResult>;
  /** The email check for the offer. */
  emailCheck?: Maybe<OfferEmailCheck>;
  /** The file checks for the application. */
  fileChecks?: Maybe<Array<FileCheck>>;
  /** The file checks for the application. */
  filesHistory?: Maybe<Array<FileCheck>>;
  firstCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  firstCheckedBy?: Maybe<Scalars['String']['output']>;
  panelResults?: Maybe<Array<PanelResult>>;
  remarks?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use remarks instead */
  remarksToSupervisor?: Maybe<Scalars['String']['output']>;
  secondCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  secondCheckedBy?: Maybe<Scalars['String']['output']>;
  supersedeInput?: Maybe<PreviewOfferLetterPayload>;
  /** Save a superseded NoO that is generated but not yet released to applicant */
  supersededFile?: Maybe<FileCheck>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** GS Decision */
export enum GsDecisionResult {
  Accept = 'ACCEPT',
  Created = 'CREATED',
  OfferProvisioned = 'OFFER_PROVISIONED',
  Reject = 'REJECT',
  ReturnToApplicant = 'RETURN_TO_APPLICANT',
  ReturnToDorpgs = 'RETURN_TO_DORPGS',
  ReturnToDsrc = 'RETURN_TO_DSRC',
  ReturnToFrcsb = 'RETURN_TO_FRCSB',
  ReturnToSupervisor = 'RETURN_TO_SUPERVISOR',
  TransferToOtherPanel = 'TRANSFER_TO_OTHER_PANEL'
}

export type GenderFilter = {
  eq?: InputMaybe<Gender>;
  in?: InputMaybe<Array<Gender>>;
  ne?: InputMaybe<Gender>;
  nin?: InputMaybe<Array<Gender>>;
};

export type GeneralEntranceRequirement = {
  __typename?: 'GeneralEntranceRequirement';
  fulfilled?: Maybe<Scalars['Boolean']['output']>;
  justification?: Maybe<Scalars['String']['output']>;
  requirements: Scalars['String']['output'];
};

export type GeneralEntranceRequirementArrayFilter = {
  all?: InputMaybe<Array<GeneralEntranceRequirementFilter>>;
  elemMatch?: InputMaybe<GeneralEntranceRequirementFilter>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

export type GeneralEntranceRequirementFilter = {
  and?: InputMaybe<Array<GeneralEntranceRequirementFilter>>;
  fulfilled?: InputMaybe<Scalars['Boolean']['input']>;
  justification?: InputMaybe<StringFilter>;
  nor?: InputMaybe<Array<GeneralEntranceRequirementFilter>>;
  not?: InputMaybe<GeneralEntranceRequirementFilter>;
  or?: InputMaybe<Array<GeneralEntranceRequirementFilter>>;
  requirements?: InputMaybe<StringFilter>;
};

export type GeneralEntranceRequirementInput = {
  fulfilled?: InputMaybe<Scalars['Boolean']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  requirements: Scalars['String']['input'];
};

export type GsDecisionFilter = {
  applicantName?: InputMaybe<StringFilter>;
  applicantNationality?: InputMaybe<StringFilter>;
  applicationId?: InputMaybe<StringFilter>;
  applicationNo?: InputMaybe<StringFilter>;
  assignee?: InputMaybe<StringFilter>;
  conditionFulfilled?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  entryYear?: InputMaybe<StringFilter>;
  hasReturned?: InputMaybe<Scalars['Boolean']['input']>;
  identityDocumentNumber?: InputMaybe<StringFilter>;
  isFirmOffer?: InputMaybe<Scalars['Boolean']['input']>;
  isLocal?: InputMaybe<Scalars['Boolean']['input']>;
  needStudentVisa?: InputMaybe<Scalars['Boolean']['input']>;
  offeredDate?: InputMaybe<Scalars['DateTime']['input']>;
  programme?: InputMaybe<ProgrammeFilter>;
  programmeType?: InputMaybe<ProgrammeTypeFilter>;
  status?: InputMaybe<ApplicationStatusFilter>;
};

export type HkpfsInformation = {
  __typename?: 'HKPFSInformation';
  HKPFSReferenceNumber?: Maybe<Scalars['String']['output']>;
  isHKPFSApplicant?: Maybe<Scalars['Boolean']['output']>;
  validHKPFSApplication?: Maybe<Scalars['Boolean']['output']>;
};

export type HkpfsInformationFilter = {
  HKPFSReferenceNumber?: InputMaybe<StringFilter>;
  _id?: InputMaybe<StringFilter>;
  and?: InputMaybe<Array<HkpfsInformationFilter>>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  nor?: InputMaybe<Array<HkpfsInformationFilter>>;
  not?: InputMaybe<HkpfsInformationFilter>;
  or?: InputMaybe<Array<HkpfsInformationFilter>>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
  validHKPFSApplication?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The decision made by HoD/DoS */
export enum Hod_Dos_Decision {
  Approve = 'APPROVE',
  Na = 'NA',
  Reject = 'REJECT',
  Return = 'RETURN'
}

export type HealthCheckPayload = {
  __typename?: 'HealthCheckPayload';
  ok: Scalars['Boolean']['output'];
};

export type HodDosAssessment = {
  __typename?: 'HodDosAssessment';
  applicationId: Scalars['String']['output'];
  competitiveFund?: Maybe<BaseHoDApproval>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<Hod_Dos_Decision>;
  dualPhD?: Maybe<BaseHoDApproval>;
  externalGrantOrDEA?: Maybe<BaseHoDApproval>;
  nonSTEMOrNonSHS?: Maybe<NonStemOrNonShs>;
  /** @deprecated Use `remarks` instead. */
  rejectRemark?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `remarks` instead. */
  returnRemark?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type HodDosAssessmentDoc = {
  __typename?: 'HodDosAssessmentDoc';
  _id: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  competitiveFund?: Maybe<BaseHoDApproval>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<Hod_Dos_Decision>;
  dualPhD?: Maybe<BaseHoDApproval>;
  externalGrantOrDEA?: Maybe<BaseHoDApproval>;
  nonSTEMOrNonSHS?: Maybe<NonStemOrNonShs>;
  /** @deprecated Use `remarks` instead. */
  rejectRemark?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `remarks` instead. */
  returnRemark?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type HodDosAssessmentPayload = {
  __typename?: 'HodDosAssessmentPayload';
  _id: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  competitiveFund?: Maybe<BaseHoDApproval>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<Hod_Dos_Decision>;
  dualPhD?: Maybe<BaseHoDApproval>;
  externalGrantOrDEA?: Maybe<BaseHoDApproval>;
  nonSTEMOrNonSHS?: Maybe<NonStemOrNonShs>;
  /** @deprecated Use `remarks` instead. */
  rejectRemark?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `remarks` instead. */
  returnRemark?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export enum Identity_Document_Type {
  HkId = 'HK_ID',
  MainlandId = 'MAINLAND_ID',
  Passport = 'PASSPORT'
}

export enum Identity_Type {
  DependantVisaAbove_18 = 'DEPENDANT_VISA_ABOVE_18',
  DependantVisaUnder_18 = 'DEPENDANT_VISA_UNDER_18',
  HkidPerm = 'HKID_PERM',
  HkidRightToLand = 'HKID_RIGHT_TO_LAND',
  Iang = 'IANG',
  Others = 'OTHERS',
  OtherVisa = 'OTHER_VISA',
  StudentVisa = 'STUDENT_VISA',
  Ttps = 'TTPS',
  WorkVisa = 'WORK_VISA'
}

export enum Interview_Panel_Language {
  ChineseCantonese = 'CHINESE_CANTONESE',
  ChineseMandarin = 'CHINESE_MANDARIN',
  English = 'ENGLISH',
  Others = 'OTHERS'
}

export enum Interview_Panel_Mode {
  InPerson = 'IN_PERSON',
  Telephone = 'TELEPHONE',
  Video = 'VIDEO'
}

export type Identity = {
  __typename?: 'Identity';
  identityDocumentNumber: Scalars['String']['output'];
  identityDocumentType: Identity_Document_Type;
  identityType: Scalars['String']['output'];
  isLocal: Scalars['Boolean']['output'];
  needStudentVisa: Scalars['Boolean']['output'];
};

export type IdentityFilter = {
  and?: InputMaybe<Array<IdentityFilter>>;
  identityDocumentNumber?: InputMaybe<StringFilter>;
  identityDocumentType?: InputMaybe<IdentityDocumentTypeFilter>;
  identityType?: InputMaybe<StringFilter>;
  isLocal?: InputMaybe<Scalars['Boolean']['input']>;
  needStudentVisa?: InputMaybe<Scalars['Boolean']['input']>;
  nor?: InputMaybe<Array<IdentityFilter>>;
  not?: InputMaybe<IdentityFilter>;
  or?: InputMaybe<Array<IdentityFilter>>;
};

export type IdentityInput = {
  identityDocumentNumber: Scalars['String']['input'];
  identityDocumentType?: InputMaybe<Identity_Document_Type>;
  identityType: Scalars['String']['input'];
  isLocal?: InputMaybe<Scalars['Boolean']['input']>;
  needStudentVisa?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdentitySort = {
  identityDocumentNumber?: InputMaybe<Sorting_Order>;
  identityDocumentType?: InputMaybe<Sorting_Order>;
  identityType?: InputMaybe<Sorting_Order>;
  isLocal?: InputMaybe<Sorting_Order>;
  needStudentVisa?: InputMaybe<Sorting_Order>;
};

export type InCreateApplicationFee = {
  admSemester: Scalars['String']['input'];
  admYear: Scalars['String']['input'];
  applicationId: Scalars['String']['input'];
  applnCategory: Scalars['String']['input'];
  applnNo: Scalars['String']['input'];
  localIndicator: Scalars['String']['input'];
  operationMode: Scalars['String']['input'];
  paymentDeadline: Scalars['DateTime']['input'];
  progChoiceList: Array<InCreateApplicationFeeProgramme>;
  progLevel: Scalars['String']['input'];
};

export type InCreateApplicationFeeProgramme = {
  progCode: Scalars['String']['input'];
  progSubCode: Scalars['String']['input'];
};

export type InDisplayPaymentInfo = {
  applicantName: Scalars['String']['input'];
  applnNo: Scalars['String']['input'];
  language: Scalars['String']['input'];
  paymentInfo: Scalars['String']['input'];
  progCode?: InputMaybe<Scalars['String']['input']>;
  progSubCode?: InputMaybe<Scalars['String']['input']>;
  refNo?: InputMaybe<Scalars['String']['input']>;
  returnURL: Scalars['String']['input'];
};

export type InMaintainRegistrationAndTuitionFee = {
  admSemester: Scalars['String']['input'];
  admYear: Scalars['String']['input'];
  applicationId: Scalars['String']['input'];
  applnCategory: Scalars['String']['input'];
  applnNo: Scalars['String']['input'];
  awardLevel: Scalars['String']['input'];
  fundType: Scalars['String']['input'];
  localIndicator: Scalars['String']['input'];
  operationMode: Scalars['String']['input'];
  paymentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  progCode: Scalars['String']['input'];
  progSubCode: Scalars['String']['input'];
  schdRegDate: Scalars['DateTime']['input'];
  studentFundType: Scalars['String']['input'];
  studyMode: Scalars['String']['input'];
};

export type InRetrieveApplnFeePayment = {
  applnNoList: Scalars['String']['input'];
};

export type Institution = {
  __typename?: 'Institution';
  country: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InstitutionFilter = {
  and?: InputMaybe<Array<InstitutionFilter>>;
  country?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  nor?: InputMaybe<Array<InstitutionFilter>>;
  not?: InputMaybe<InstitutionFilter>;
  or?: InputMaybe<Array<InstitutionFilter>>;
};

export type InstitutionInput = {
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InstitutionSort = {
  country?: InputMaybe<Sorting_Order>;
  name?: InputMaybe<Sorting_Order>;
};

export type InterestConflictApprovalDoc = {
  __typename?: 'InterestConflictApprovalDoc';
  _id: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  approveDoRPgSInTeam?: Maybe<Dsrc_Interest_Conflict_Decision>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type InterpolatingGpaRulePayload = {
  __typename?: 'InterpolatingGPARulePayload';
  _id?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  defaultRule?: Maybe<Scalars['Boolean']['output']>;
  increasingGPAScale?: Maybe<Scalars['Boolean']['output']>;
  mapping: Scalars['JSONObject']['output'];
  maxGPARange?: Maybe<Scalars['Float']['output']>;
  minGPARange?: Maybe<Scalars['Float']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  ruleName: Scalars['String']['output'];
  type: GpaConvertType;
  useOverallGPA?: Maybe<Scalars['Boolean']['output']>;
};

export type InterpolatingGpaRulePayloadInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  mapping: Scalars['JSONObject']['input'];
  maxGPARange?: InputMaybe<Scalars['Float']['input']>;
  minGPARange?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  ruleName: Scalars['String']['input'];
  type: GpaConvertType;
};

export type InterviewPanel = {
  __typename?: 'InterviewPanel';
  externalInterviewPanel?: Maybe<Array<Scalars['String']['output']>>;
  interviewDate?: Maybe<Scalars['DateTime']['output']>;
  interviewLanguage?: Maybe<Interview_Panel_Language>;
  interviewMode?: Maybe<Interview_Panel_Mode>;
  /** @deprecated Use an object type to store the data. */
  interviewPanel?: Maybe<Array<Scalars['String']['output']>>;
  /** The panel has agreed that the panel chair submit the form. */
  panelAgreement?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use an object type to store the data. */
  panelChairPost?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use an object type to store the data. */
  panelChairRank?: Maybe<Scalars['String']['output']>;
  panelMembers?: Maybe<Array<PanelMember>>;
  scholarshipInterviewSubmission?: Maybe<Scalars['Boolean']['output']>;
};

export type InterviewPanelFilter = {
  _id?: InputMaybe<StringFilter>;
  admission?: InputMaybe<AdmissionFilter>;
  and?: InputMaybe<Array<NominationFilter>>;
  application?: InputMaybe<ApplicationFilter>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  eligibleFunding?: InputMaybe<FundingSourceFilter>;
  externalInterviewPanel?: InputMaybe<StringFilter>;
  funding?: InputMaybe<FundingFilter>;
  /** Currently do not support array filter */
  fundings?: InputMaybe<FundingFilter>;
  nor?: InputMaybe<Array<NominationFilter>>;
  not?: InputMaybe<NominationFilter>;
  or?: InputMaybe<Array<NominationFilter>>;
  scholarshipInterviewSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  subjectClassification?: InputMaybe<FundingPanelFilter>;
  submission?: InputMaybe<SubmissionFilter>;
  supervisors?: InputMaybe<SupervisorsArrayFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

export type KvPair = {
  __typename?: 'KVPair';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum Language_Qualification_Test_Type {
  Ielts = 'IELTS',
  Toefl = 'TOEFL'
}

export type LanguageQualification = {
  __typename?: 'LanguageQualification';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  expectedResultUpdateDate?: Maybe<Scalars['DateTime']['output']>;
  needEnglishTest?: Maybe<Scalars['Boolean']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  result?: Maybe<LanguageQualificationResult>;
  resultAnnouncedIndicator?: Maybe<Scalars['Boolean']['output']>;
  supportingDocuments?: Maybe<Array<FileType>>;
  testDate?: Maybe<Scalars['DateTime']['output']>;
  testType?: Maybe<Language_Qualification_Test_Type>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type LanguageQualificationPayload = {
  __typename?: 'LanguageQualificationPayload';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  expectedResultUpdateDate?: Maybe<Scalars['DateTime']['output']>;
  needEnglishTest?: Maybe<Scalars['Boolean']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  result?: Maybe<LanguageQualificationResult>;
  resultAnnouncedIndicator?: Maybe<Scalars['Boolean']['output']>;
  supportingDocuments?: Maybe<Array<FileType>>;
  testDate?: Maybe<Scalars['DateTime']['output']>;
  testType?: Maybe<Language_Qualification_Test_Type>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type LanguageQualificationResult = {
  __typename?: 'LanguageQualificationResult';
  listening: Scalars['Float']['output'];
  overall: Scalars['Float']['output'];
  reading: Scalars['Float']['output'];
  resultReceiptDate?: Maybe<Scalars['DateTime']['output']>;
  speaking: Scalars['Float']['output'];
  writing: Scalars['Float']['output'];
};

export type LanguageQualificationResultInput = {
  listening: Scalars['Float']['input'];
  overall: Scalars['Float']['input'];
  reading: Scalars['Float']['input'];
  resultReceiptDate?: InputMaybe<Scalars['DateTime']['input']>;
  speaking: Scalars['Float']['input'];
  writing: Scalars['Float']['input'];
};

export type LanguageQualificationResultSort = {
  listening?: InputMaybe<Sorting_Order>;
  overall?: InputMaybe<Sorting_Order>;
  reading?: InputMaybe<Sorting_Order>;
  speaking?: InputMaybe<Sorting_Order>;
  writing?: InputMaybe<Sorting_Order>;
};

export type LanguageQualificationResultV1Input = {
  listening: Scalars['Float']['input'];
  overall: Scalars['Float']['input'];
  reading: Scalars['Float']['input'];
  resultReceiptDate?: InputMaybe<Scalars['DateTime']['input']>;
  speaking: Scalars['Float']['input'];
  writing: Scalars['Float']['input'];
};

export type LanguageQualificationSort = {
  _id?: InputMaybe<Sorting_Order>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  expectedResultUpdateDate?: InputMaybe<Sorting_Order>;
  referenceNo?: InputMaybe<Sorting_Order>;
  result?: InputMaybe<LanguageQualificationResultSort>;
  resultAnnouncedIndicator?: InputMaybe<Sorting_Order>;
  testDate?: InputMaybe<Sorting_Order>;
  testType?: InputMaybe<Sorting_Order>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
};

export type LapsedApplicationFilter = {
  _id?: InputMaybe<StringFilter>;
  applicantName?: InputMaybe<StringFilter>;
  applicationId?: InputMaybe<StringFilter>;
  applicationNo?: InputMaybe<StringFilter>;
  /** Application Status. ADD Jul 5 */
  applicationStatus?: InputMaybe<ApplicationStatusFilter>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  department?: InputMaybe<StringFilter>;
  /** Entry Year. ADD Jul 5 */
  entryYear?: InputMaybe<StringFilter>;
  isLocal?: InputMaybe<Scalars['Boolean']['input']>;
  programme?: InputMaybe<ProgrammeFilter>;
  qualificationCheckDisplayStatus?: InputMaybe<StringFilter>;
  releaseDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<StringFilter>;
  studyMode?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

export type LapsedApplicationPaginatedPayload = {
  __typename?: 'LapsedApplicationPaginatedPayload';
  data: Array<LapsedApplicationPayload>;
  paginator: PaginatorPayload;
};

export type LapsedApplicationPayload = {
  __typename?: 'LapsedApplicationPayload';
  applicantName: Scalars['String']['output'];
  applicantNationality: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  applicationNo: Scalars['String']['output'];
  department: Scalars['String']['output'];
  entryYear: Scalars['String']['output'];
  programme: Programme;
  programmeType: Programme_Type;
  releasingStatus: Scalars['String']['output'];
  researchArea: Scalars['String']['output'];
  studyMode: Programme_Choice_Study_Mode;
};

export type Mark = {
  __typename?: 'Mark';
  course: Scalars['String']['output'];
  credit?: Maybe<Scalars['Float']['output']>;
  result: Scalars['String']['output'];
};

export type MarkArrayFilter = {
  all?: InputMaybe<Array<MarkArrayFilter>>;
  elemMatch?: InputMaybe<MarkFilter>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

export type MarkConversion = {
  __typename?: 'MarkConversion';
  convertedMark: Scalars['String']['output'];
  /** @deprecated This field is deprecated and will be migrated soon */
  digitToLetterRule?: Maybe<MarkStub>;
  /** @deprecated This field is deprecated and will be migrated soon */
  letterToGPARule?: Maybe<MarkStub>;
};

export type MarkConversionFilter = {
  and?: InputMaybe<Array<MarkConversionFilter>>;
  convertedMark?: InputMaybe<StringFilter>;
  nor?: InputMaybe<Array<MarkConversionFilter>>;
  not?: InputMaybe<MarkConversionFilter>;
  or?: InputMaybe<Array<MarkConversionFilter>>;
};

export type MarkConversionInput = {
  convertedMark: Scalars['String']['input'];
  digitToLetterRule?: InputMaybe<MarkStubInput>;
  letterToGPARule?: InputMaybe<MarkStubInput>;
};

export type MarkConversionSort = {
  convertedMark?: InputMaybe<Sorting_Order>;
};

export type MarkConversionV1Input = {
  convertedMark: Scalars['String']['input'];
  digitToLetterRule?: InputMaybe<MarkStubInput>;
  letterToGPARule?: InputMaybe<MarkStubInput>;
};

export type MarkFilter = {
  and?: InputMaybe<Array<MarkFilter>>;
  course?: InputMaybe<StringFilter>;
  credit?: InputMaybe<NumberFilter>;
  nor?: InputMaybe<Array<MarkFilter>>;
  not?: InputMaybe<MarkFilter>;
  or?: InputMaybe<Array<MarkFilter>>;
  result?: InputMaybe<StringFilter>;
};

export type MarkInput = {
  course: Scalars['String']['input'];
  credit?: InputMaybe<Scalars['Float']['input']>;
  result: Scalars['String']['input'];
};

export type MarkSort = {
  course?: InputMaybe<Sorting_Order>;
  credit?: InputMaybe<Sorting_Order>;
  result?: InputMaybe<Sorting_Order>;
};

export type MarkStub = {
  __typename?: 'MarkStub';
  name?: Maybe<Scalars['String']['output']>;
};

export type MarkStubInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MeetConditionCheckInput = {
  applicationId: Scalars['String']['input'];
  condition: Array<OfferConditionInput>;
  conditionFulfillingDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  contactDepartmentPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactDepartmentPersonName?: InputMaybe<Scalars['String']['input']>;
  contactDepartmentPersonPhone?: InputMaybe<Scalars['String']['input']>;
};

export type MeetConditionCheckModel = {
  __typename?: 'MeetConditionCheckModel';
  applicationId: Scalars['ID']['output'];
  conditionFulfillingDeadline?: Maybe<Scalars['DateTime']['output']>;
  conditions: Array<OfferCondition>;
  contactDepartmentPersonEmail?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonName?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  isFirmOffer: Scalars['Boolean']['output'];
  /** Can be regarded as overall remarks if needed. */
  remarks?: Maybe<Array<MeetConditionRemarks>>;
  status: MeetConditionStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MeetConditionCheckModelDoc = {
  __typename?: 'MeetConditionCheckModelDoc';
  _id: Scalars['String']['output'];
  applicationId: Scalars['ID']['output'];
  conditionFulfillingDeadline?: Maybe<Scalars['DateTime']['output']>;
  conditions: Array<OfferCondition>;
  contactDepartmentPersonEmail?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonName?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  isFirmOffer: Scalars['Boolean']['output'];
  /** Can be regarded as overall remarks if needed. */
  remarks?: Maybe<Array<MeetConditionRemarks>>;
  status: MeetConditionStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MeetConditionPayload = {
  __typename?: 'MeetConditionPayload';
  applicationId: Scalars['String']['output'];
  conditionFulfillingDeadline?: Maybe<Scalars['DateTime']['output']>;
  conditions?: Maybe<Array<OfferCondition>>;
  contactDepartmentPersonEmail?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonName?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonPhone?: Maybe<Scalars['String']['output']>;
  isFirmOffer: Scalars['Boolean']['output'];
  remarks?: Maybe<Array<MeetConditionRemarks>>;
  status: MeetConditionStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MeetConditionRemarks = {
  __typename?: 'MeetConditionRemarks';
  at?: Maybe<Scalars['DateTime']['output']>;
  by?: Maybe<Scalars['String']['output']>;
  remark: Scalars['String']['output'];
};

export type MeetConditionRemarksInput = {
  at?: InputMaybe<Scalars['DateTime']['input']>;
  by?: InputMaybe<Scalars['String']['input']>;
  remark: Scalars['String']['input'];
};

export type MeetConditionRequestInput = {
  applicationId: Scalars['ID']['input'];
  conditions: Array<OfferConditionInput>;
};

export enum MeetConditionStatus {
  Approved = 'APPROVED',
  Created = 'CREATED',
  ModificationRequired = 'MODIFICATION_REQUIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type Merit = {
  __typename?: 'Merit';
  attainmentMeans?: Maybe<Scalars['String']['output']>;
  awardBodyName?: Maybe<Scalars['String']['output']>;
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  meritName?: Maybe<Scalars['String']['output']>;
  supportingDocuments?: Maybe<Array<FileType>>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type MeritAssessmentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  meritReferenceId: Scalars['String']['input'];
  meritType?: MeritType;
  researchLevel?: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type MeritAssessmentType = {
  __typename?: 'MeritAssessmentType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  meritReferenceId: Scalars['String']['output'];
  meritType: MeritType;
  researchLevel: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MeritPayload = {
  __typename?: 'MeritPayload';
  _id: Scalars['ID']['output'];
  attainmentMeans?: Maybe<Scalars['String']['output']>;
  awardBodyName?: Maybe<Scalars['String']['output']>;
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  meritName?: Maybe<Scalars['String']['output']>;
  supportingDocuments?: Maybe<Array<FileType>>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type MeritSort = {
  _id?: InputMaybe<Sorting_Order>;
  attainmentMeans?: InputMaybe<Sorting_Order>;
  awardBodyName?: InputMaybe<Sorting_Order>;
  awardDate?: InputMaybe<Sorting_Order>;
  country?: InputMaybe<Sorting_Order>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  meritName?: InputMaybe<Sorting_Order>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
};

export enum MeritType {
  Na = 'NA',
  Other = 'OTHER',
  Prestigious = 'PRESTIGIOUS'
}

export type ModifyPanelApplicationInput = {
  applicationId: Array<Scalars['String']['input']>;
  panelId: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptNonProposedInvitation: ApplicationPayload;
  acceptOffer: Scalars['Boolean']['output'];
  addApplicationItem: ApplicationPayload;
  addApplicationsToPanel: PanelModel;
  addConfig: ConfigurationPayload;
  adminAddRule: Scalars['Boolean']['output'];
  adminChangeApplicationFeeDeadline: Scalars['Boolean']['output'];
  adminCreateApplicationFee: Scalars['Boolean']['output'];
  adminCreateVirtualApplication: Scalars['Boolean']['output'];
  adminDeleteVisa: Scalars['JSONObject']['output'];
  adminDryRun: Scalars['Float']['output'];
  /** Refresh partial information and publish to the consumer queue. */
  adminRefreshComment?: Maybe<Scalars['JSONObject']['output']>;
  adminRegenerateRefereeReports: Scalars['Boolean']['output'];
  adminRegenerateVisa: Scalars['JSONObject']['output'];
  adminUploadRefereeReports: Scalars['Boolean']['output'];
  announcePanelResult: Scalars['Boolean']['output'];
  approveRenomination: Scalars['Boolean']['output'];
  /** Batch confirm the commencement of study for the given applications. */
  batchConfirmCommencementOfStudy: Scalars['Boolean']['output'];
  batchUpdateApplicationFeeDeadline: Scalars['Int']['output'];
  batchUploadReferenceId: Scalars['Boolean']['output'];
  calculateAverageMark: AverageMarkPayload;
  /** For applicants, remove the time slot information for student card collection. */
  cancelCollectionTimeslot: Scalars['Boolean']['output'];
  confirmCoSupervisorDeclaration: Scalars['Boolean']['output'];
  /** For applicants, add the time slot information for student card collection. */
  confirmCollectionTimeslot: Scalars['Boolean']['output'];
  /** Confirm the commencement of study for the given application. */
  confirmCommencementOfStudy: OnlineRegistrationModel;
  confirmRSFSubmission: RsfConfirmationPayload;
  /** @deprecated Use calculateAverageMark instead. */
  convertGPA: AverageMarkPayload;
  convertGPARule: ConvertGpaRulePayload;
  convertGPAV2: ConvertGpaPayloadV2;
  createAcademicQualificationAssessment: Array<AcademicAssessmentType>;
  createAcademicRefereeForm: Scalars['String']['output'];
  /** Create an account and an applicant particular at the same time. */
  createApplicant: ApplicantPayload;
  createApplication: ApplicationPayload;
  createApplicationFee: Array<OutCreateApplicationFee>;
  createApplicationFeeFromIds: Scalars['JSONObject']['output'];
  createAssessment: Assessment;
  createBonusAssessment: Array<BonusAssessmentType>;
  createDSRCAdmission: DsrcAdmissionPayload;
  createDSRCAssessment: DsrcAssessment;
  createDSRCDeclaration: DsrcDeclarationType;
  createDSRCInterestConflictApproval: DsrcInterestConflictApprovalPayload;
  createDepartmentInput: DepartmentInputAssessmentType;
  createFRCSBAssessment: FrcsbAssessmentPayload;
  /** Create a new GS decision when the application goes to GS. */
  createGSDecision: GsDecision;
  createHodDosAssessment: HodDosAssessment;
  createMeritAssessment: Array<MeritAssessmentType>;
  /** Developer Usage Only. */
  createMockEmail: Scalars['JSONObject']['output'];
  createNomination?: Maybe<NominationPayload>;
  /** Endpoint for internally creating OVTSTask for an application. */
  createOVTSTask: Scalars['Boolean']['output'];
  createPanel: PanelModel;
  createPublicationAssessment: Array<PublicationAssessmentType>;
  createRefereeAfterSubmission: Scalars['Boolean']['output'];
  createScholarshipInterviewPanel: NominationPayload;
  /** Create a student record from external system. */
  createStudentRecord: OnlineRegistrationModel;
  declineNominationRequest: Scalars['Boolean']['output'];
  deleteApplicationByApplicationNo: ApplicationDeletePayload;
  deletePanel: PanelModel;
  /** Delete superseded the offer for the given application. Will throw error if no superseded offer found. */
  deleteSupersedeOffer: Scalars['Boolean']['output'];
  directEmailWithTemplate?: Maybe<Scalars['JSONObject']['output']>;
  directorEligibilityCheck: Scalars['Boolean']['output'];
  directorRefereeReportCheck: Scalars['Boolean']['output'];
  duplicateAllFromApplicationNo: ApplicationDuplicateLogCompoundPayload;
  generateAssessmentOneOffFiles: Scalars['JSONObject']['output'];
  /** Generate offer files for the application. Trigger this API will override any data save in the application.Also notice that, the API can be time consuming. May use polling query endpoint for information. */
  generateOfferFiles: Array<FileCheck>;
  generateOneOffFiles: Scalars['JSONObject']['output'];
  /**
   * Generate preliminary check result by applicationId, will return the generated result.
   * @deprecated Always use query to generate one.
   */
  generatePreCheckResult: PreliminaryCheckModel;
  inviteNonProposedStudent: Scalars['Boolean']['output'];
  maintainRegistrationAndTuitionFee: Array<OutMaintainRegistrationAndTuitionFee>;
  manualReleaseOfferResult: Scalars['Boolean']['output'];
  meetConditionNotification: Scalars['Boolean']['output'];
  modifyApplicationFeeDeadline: Scalars['Boolean']['output'];
  modifyPaymentProgSubCode: Scalars['Boolean']['output'];
  modifyRegistrationFeeDeadline: Scalars['Boolean']['output'];
  /** This method will update the whole section with additional information. */
  overwriteScholarshipDimensionScore: Scalars['Boolean']['output'];
  panelFilterLock: Scalars['Boolean']['output'];
  panelFilterUnlock: Scalars['Boolean']['output'];
  polishComments: Scalars['Boolean']['output'];
  proceedAfterPayment: Scalars['JSONObject']['output'];
  recomputeDSRCGrading?: Maybe<DsrcGrading>;
  refreshConfigurations?: Maybe<Scalars['JSONObject']['output']>;
  /** For GS, refetch, save and resend email to applicant who received invalid QR code. */
  regenerateAndResendQrCode: Scalars['Boolean']['output'];
  regenerateReferenceReport: FileType;
  /** When a student is not accepted by any supervisor, the student can be rejected to join the application pool. */
  rejectNonProposedApplication: Scalars['Boolean']['output'];
  rejectOffer: Scalars['Boolean']['output'];
  /** For GS to release the failed application result. */
  releaseFailedApplicationResult: Scalars['Boolean']['output'];
  /** For GS to prepare the releasing of offer. Wait for a given period to notify the students. */
  releaseOfferResult: Scalars['Boolean']['output'];
  releasePanelApplicationAllocation: Scalars['Boolean']['output'];
  /** Release superseded offer for the given application. */
  releaseSupersededOffer: Scalars['Boolean']['output'];
  remarkOnApplication: PanelModel;
  removeApplicationItem: ApplicationPayload;
  /** Remove the offer file. */
  removeOfferFiles: Scalars['Boolean']['output'];
  resendRefereeEmail: Scalars['Boolean']['output'];
  /** For GS to revoke the released failed application result. */
  revokeReleasedFailedApplicationResult: Scalars['Boolean']['output'];
  /** For GS to revoke the releasing of offer. */
  revokeReleasedOfferResult: Scalars['Boolean']['output'];
  scholarshipNominationTotalCalculation: Scalars['Boolean']['output'];
  sendExistingEmail: Scalars['JSONObject']['output'];
  submitApplication: Application_Status;
  /** Let Department/School admin to update the conditional offer status. */
  submitCheckMeetCondition: MeetConditionPayload;
  submitDSRCAssessment: Scalars['Boolean']['output'];
  submitDSRCInterestConflictApproval: Scalars['Boolean']['output'];
  submitFRCSBAssessment: Scalars['Boolean']['output'];
  /** @deprecated Frontend should not use this mutation. Backend will utilize submitDSRCAssessment to judge. */
  submitForScholarshipInterview: Scalars['Boolean']['output'];
  submitHodDosAssessment: HodDosAssessment;
  submitMeetConditionCheckRequest: MeetConditionPayload;
  /** For GS to create an offer entity, pending submission to RSF. */
  submitOfferChecklist: GsDecision;
  submitQualificationCheck: QualificationCheckModel;
  submitScholarshipInterviewResult: Scalars['Boolean']['output'];
  submitScholarshipOrdering: Scalars['Boolean']['output'];
  /** Supersede the offer for the given application. */
  supersedeOffer: FileCheck;
  /** This will force create the form for this academic referee and send the email currently. */
  syncAcademicRefereeStatusAndResendEmail: Scalars['Boolean']['output'];
  updateAcademicQualification: AcademicQualificationPayload;
  updateAcademicQualificationAssessment: Array<AcademicAssessmentType>;
  /** @deprecated Use updateApplicationItem instead. Will deprecate after front-end removes. */
  updateAcademicReferee: AcademicRefereePayload;
  /** @deprecated Should not use anymore. Will remove after front-end deprecation. */
  updateActivity: ActivityPayload;
  updateAdditionalDocument: AdditionalDocumentPayload;
  updateApplicant: ApplicantPayload;
  updateApplicantIdentityType: Scalars['JSONObject']['output'];
  updateApplicationFeeDeadline: Scalars['Int']['output'];
  updateApplicationItem: ApplicationPayload;
  updateApplicationReview: PanelModel;
  updateBonusAssessment: Array<BonusAssessmentType>;
  /** For AR, flag the student who have collected student card. */
  updateCardCollectionStatus: Scalars['Boolean']['output'];
  updateConfig: ConfigurationPayload;
  updateDSRCAdmission: DsrcAdmissionPayload;
  updateDSRCDeclaration: DsrcDeclarationType;
  updateDSRCInterestConflictApproval: DsrcInterestConflictApprovalPayload;
  updateDepartmentInput: DepartmentInputAssessmentType;
  updateEmployment: EmploymentPayload;
  updateFRCSBAssessment: FrcsbAssessmentPayload;
  /** For GS to update the GS decision. */
  updateGSAssignee: GsDecision;
  updateHodDosAssessment: HodDosAssessment;
  updateInterviewPanel: NominationPayload;
  updateLanguageQualification: LanguageQualificationPayload;
  updateMerit: MeritPayload;
  updateMeritAssessment: Array<MeritAssessmentType>;
  /** Update a nomination by its id. */
  updateNomination: NominationPayload;
  /** Update the submission status of a nomination. Submit the nomination or reject it. */
  updateNominationSubmissionStatus: NominationSubmissionStatusPayload;
  /** GS will always need to check the supersede flag in the case of re-offer */
  updateOfferParameters: PreviewOfferLetterPayload;
  updatePanel: PanelModel;
  updatePanelApplicationAllocation: PanelModel;
  updatePanelApplicationItem: PanelModel;
  updateProfessionalQualification: ProfessionalQualificationPayload;
  updatePublication: PublicationPayload;
  updatePublicationAssessment: Array<PublicationAssessmentType>;
  updateQualificationCheck: QualificationCheckModel;
  updateRefForm: Scalars['ID']['output'];
  updateRefereeEmail: Scalars['Boolean']['output'];
  updateRegistrationDeadline: Scalars['Boolean']['output'];
  updateResearchAssessment: Scalars['Boolean']['output'];
  updateResearchExperience: ResearchExperiencePayload;
  updateScholarshipAcademicProgramme: NominationPayload;
  /** This method will partially update the scores for this question. */
  updateScholarshipNominationQuestion: Scalars['Boolean']['output'];
  updateScholarshipOrdering: Scalars['Boolean']['output'];
  updateScholarshipSubjectClassification: NominationPayload;
  updateTraining: TrainingPayload;
  updateVisaApplication: VisaModel;
  /** Withdraw the application by applicant. */
  withdrawApplication: ApplicationPayload;
};


export type MutationAcceptNonProposedInvitationArgs = {
  input: AcceptNonProposedInvitationInput;
};


export type MutationAcceptOfferArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationAddApplicationItemArgs = {
  id: Scalars['String']['input'];
  input: AddApplicationItemInput;
};


export type MutationAddApplicationsToPanelArgs = {
  input: ModifyPanelApplicationInput;
};


export type MutationAddConfigArgs = {
  input: ConfigurationInput;
};


export type MutationAdminAddRuleArgs = {
  rule: InterpolatingGpaRulePayloadInput;
};


export type MutationAdminChangeApplicationFeeDeadlineArgs = {
  applicationNo: Scalars['String']['input'];
  deadline: Scalars['DateTime']['input'];
};


export type MutationAdminCreateApplicationFeeArgs = {
  applicationNo: Scalars['String']['input'];
};


export type MutationAdminCreateVirtualApplicationArgs = {
  applicationId: Scalars['String']['input'];
  type: VirtualApplicationType;
};


export type MutationAdminDeleteVisaArgs = {
  applicantId: Scalars['String']['input'];
};


export type MutationAdminDryRunArgs = {
  input: ConvertGpaInputV2;
  rule: InterpolatingGpaRulePayloadInput;
};


export type MutationAdminRefreshCommentArgs = {
  applicationId: Scalars['String']['input'];
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationAdminRegenerateRefereeReportsArgs = {
  formId: Scalars['String']['input'];
};


export type MutationAdminRegenerateVisaArgs = {
  applicantId: Scalars['String']['input'];
};


export type MutationAdminUploadRefereeReportsArgs = {
  file: FileTypeInput;
  refereeId: Scalars['String']['input'];
};


export type MutationAnnouncePanelResultArgs = {
  panelId: Scalars['ID']['input'];
};


export type MutationApproveRenominationArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationBatchConfirmCommencementOfStudyArgs = {
  applicationIds: Array<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationBatchUpdateApplicationFeeDeadlineArgs = {
  applicationIds: Array<Scalars['String']['input']>;
  newDeadline: Scalars['DateTime']['input'];
};


export type MutationBatchUploadReferenceIdArgs = {
  input: VisaBatchUploadInput;
};


export type MutationCalculateAverageMarkArgs = {
  input: ConvertGpaInput;
};


export type MutationCancelCollectionTimeslotArgs = {
  applicationId: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
};


export type MutationConfirmCoSupervisorDeclarationArgs = {
  coSupervisorDeclarationRemark?: InputMaybe<Scalars['String']['input']>;
  confirmed: Scalars['Boolean']['input'];
  emailAddress: Scalars['String']['input'];
  netId?: InputMaybe<Scalars['String']['input']>;
  nominationId: Scalars['String']['input'];
};


export type MutationConfirmCollectionTimeslotArgs = {
  applicationId: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
};


export type MutationConfirmCommencementOfStudyArgs = {
  applicationId: Scalars['String']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationConfirmRsfSubmissionArgs = {
  input: RsfConfirmInput;
};


export type MutationConvertGpaArgs = {
  input: ConvertGpaInput;
};


export type MutationConvertGpaRuleArgs = {
  input: ConvertGpaRuleInput;
};


export type MutationConvertGpav2Args = {
  input: ConvertGpaInputV2;
};


export type MutationCreateAcademicQualificationAssessmentArgs = {
  input: CreateAcademicQualificationAssessmentInput;
};


export type MutationCreateAcademicRefereeFormArgs = {
  academicRefereeId: Scalars['String']['input'];
  applicationId: Scalars['String']['input'];
};


export type MutationCreateApplicantArgs = {
  input: CreateApplicantInput;
  user?: InputMaybe<CreateUserInputV2>;
};


export type MutationCreateApplicationArgs = {
  input: CreateApplicationInput;
};


export type MutationCreateApplicationFeeArgs = {
  input: Array<InCreateApplicationFee>;
};


export type MutationCreateApplicationFeeFromIdsArgs = {
  applicationIds: Array<Scalars['String']['input']>;
};


export type MutationCreateAssessmentArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationCreateBonusAssessmentArgs = {
  input: CreateBonusAssessmentInput;
};


export type MutationCreateDsrcAdmissionArgs = {
  input: CreateDsrcAdmissionInput;
};


export type MutationCreateDsrcAssessmentArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationCreateDsrcDeclarationArgs = {
  input: CreateDsrcDeclarationInput;
};


export type MutationCreateDsrcInterestConflictApprovalArgs = {
  input: CreateDsrcInterestConflictApprovalInput;
};


export type MutationCreateDepartmentInputArgs = {
  input: CreateDepartmentInputInput;
};


export type MutationCreateFrcsbAssessmentArgs = {
  input: CreateFrcsbAssessmentInput;
};


export type MutationCreateGsDecisionArgs = {
  input: CreateGsDecisionInput;
};


export type MutationCreateHodDosAssessmentArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationCreateMeritAssessmentArgs = {
  input: CreateMeritAssessmentInput;
};


export type MutationCreateMockEmailArgs = {
  needAggregation?: InputMaybe<Scalars['Boolean']['input']>;
  templateData: Scalars['JSONObject']['input'];
  templateId: Scalars['String']['input'];
};


export type MutationCreateNominationArgs = {
  input: CreateNominationInput;
};


export type MutationCreateOvtsTaskArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationCreatePanelArgs = {
  input: CreatePanelInput;
};


export type MutationCreatePublicationAssessmentArgs = {
  input: CreatePublicationAssessmentInput;
};


export type MutationCreateRefereeAfterSubmissionArgs = {
  applicationId: Scalars['ID']['input'];
  input: CreateAcademicRefereeInput;
};


export type MutationCreateScholarshipInterviewPanelArgs = {
  input: CreateInterviewPanelInput;
};


export type MutationCreateStudentRecordArgs = {
  input: CreateStudentRecordInput;
};


export type MutationDeclineNominationRequestArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationDeleteApplicationByApplicationNoArgs = {
  applicationNo: Scalars['String']['input'];
  execute: Scalars['Boolean']['input'];
};


export type MutationDeletePanelArgs = {
  input: UpdatePanelInput;
};


export type MutationDeleteSupersedeOfferArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationDirectEmailWithTemplateArgs = {
  dryRunEmailAddress?: InputMaybe<Array<Scalars['String']['input']>>;
  input: Scalars['JSONObject']['input'];
  templateId: Scalars['String']['input'];
};


export type MutationDirectorEligibilityCheckArgs = {
  applicationId: Scalars['String']['input'];
  eligibilityCheckInput?: InputMaybe<EligibilityCheckInput>;
};


export type MutationDirectorRefereeReportCheckArgs = {
  applicationId: Scalars['String']['input'];
  input: Array<RefereeCheckInput>;
};


export type MutationDuplicateAllFromApplicationNoArgs = {
  applicationNo: Scalars['String']['input'];
  execute: Scalars['Boolean']['input'];
  toEntryYear: Scalars['String']['input'];
};


export type MutationGenerateAssessmentOneOffFilesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateOfferFilesArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationGenerateOneOffFilesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGeneratePreCheckResultArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationInviteNonProposedStudentArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationMaintainRegistrationAndTuitionFeeArgs = {
  input: Array<InMaintainRegistrationAndTuitionFee>;
};


export type MutationModifyApplicationFeeDeadlineArgs = {
  applicationId: Scalars['String']['input'];
  paymentDeadline: Scalars['DateTime']['input'];
};


export type MutationModifyPaymentProgSubCodeArgs = {
  applicationId: Scalars['String']['input'];
  newProgSubCode: Scalars['String']['input'];
  originalProgSubCode: Scalars['String']['input'];
};


export type MutationModifyRegistrationFeeDeadlineArgs = {
  applicationId: Scalars['String']['input'];
  paymentDeadline: Scalars['DateTime']['input'];
};


export type MutationOverwriteScholarshipDimensionScoreArgs = {
  applicationId: Scalars['String']['input'];
  input: UpdateScholarshipDimensionInput;
};


export type MutationPanelFilterLockArgs = {
  filter: PanelApplicationFilter;
  panelId: Scalars['ID']['input'];
};


export type MutationPanelFilterUnlockArgs = {
  panelId: Scalars['ID']['input'];
};


export type MutationPolishCommentsArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationProceedAfterPaymentArgs = {
  id: Scalars['String']['input'];
};


export type MutationRecomputeDsrcGradingArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationRegenerateAndResendQrCodeArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationRegenerateReferenceReportArgs = {
  formId: Scalars['String']['input'];
};


export type MutationRejectNonProposedApplicationArgs = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  applicationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationRejectOfferArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationReleaseFailedApplicationResultArgs = {
  input: ReleaseResultInput;
};


export type MutationReleaseOfferResultArgs = {
  input: ReleaseResultInput;
};


export type MutationReleasePanelApplicationAllocationArgs = {
  id: Scalars['String']['input'];
};


export type MutationReleaseSupersededOfferArgs = {
  input: ReleaseSupersedeOfferInput;
};


export type MutationRemarkOnApplicationArgs = {
  input: PanelRemarkInput;
};


export type MutationRemoveApplicationItemArgs = {
  id: Scalars['String']['input'];
  input: RemoveApplicationItemInput;
};


export type MutationRemoveOfferFilesArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationResendRefereeEmailArgs = {
  academicRefereeId?: InputMaybe<Scalars['String']['input']>;
  applicationId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRevokeReleasedFailedApplicationResultArgs = {
  input: RevokeResultInput;
};


export type MutationRevokeReleasedOfferResultArgs = {
  input: RevokeResultInput;
};


export type MutationScholarshipNominationTotalCalculationArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationSubmitApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitCheckMeetConditionArgs = {
  input: MeetConditionCheckInput;
};


export type MutationSubmitDsrcAssessmentArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationSubmitDsrcInterestConflictApprovalArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationSubmitFrcsbAssessmentArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationSubmitForScholarshipInterviewArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationSubmitHodDosAssessmentArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationSubmitMeetConditionCheckRequestArgs = {
  input: MeetConditionRequestInput;
};


export type MutationSubmitOfferChecklistArgs = {
  input: UpdateGsDecisionInput;
};


export type MutationSubmitQualificationCheckArgs = {
  input: UpdateQualificationCheckInput;
};


export type MutationSubmitScholarshipInterviewResultArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationSubmitScholarshipOrderingArgs = {
  input: SubmitFundingOrderInput;
};


export type MutationSupersedeOfferArgs = {
  input: SupersedeOfferInput;
};


export type MutationSyncAcademicRefereeStatusAndResendEmailArgs = {
  academicRefereeId: Scalars['ID']['input'];
  applicationId: Scalars['ID']['input'];
};


export type MutationUpdateAcademicQualificationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAcademicQualificationInput;
};


export type MutationUpdateAcademicQualificationAssessmentArgs = {
  input: UpdateAcademicQualificationAssessmentInput;
};


export type MutationUpdateAcademicRefereeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAcademicRefereeInput;
};


export type MutationUpdateActivityArgs = {
  id: Scalars['ID']['input'];
  input: UpdateActivityInput;
};


export type MutationUpdateAdditionalDocumentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAdditionalDocumentInput;
};


export type MutationUpdateApplicantArgs = {
  id: Scalars['ID']['input'];
  input: UpdateApplicantInput;
};


export type MutationUpdateApplicantIdentityTypeArgs = {
  input: AdminStudentIdentityInput;
};


export type MutationUpdateApplicationFeeDeadlineArgs = {
  applicationId: Scalars['String']['input'];
  newDeadline: Scalars['DateTime']['input'];
};


export type MutationUpdateApplicationItemArgs = {
  id: Scalars['String']['input'];
  input: UpdateApplicationItemInput;
  updateId: Scalars['String']['input'];
};


export type MutationUpdateApplicationReviewArgs = {
  input: PanelReviewInput;
};


export type MutationUpdateBonusAssessmentArgs = {
  input: UpdateBonusAssessmentInput;
};


export type MutationUpdateCardCollectionStatusArgs = {
  applicationId: Scalars['String']['input'];
  collected: Scalars['Boolean']['input'];
};


export type MutationUpdateConfigArgs = {
  input: ConfigurationInput;
};


export type MutationUpdateDsrcAdmissionArgs = {
  input: UpdateDsrcAdmissionInput;
};


export type MutationUpdateDsrcDeclarationArgs = {
  input: UpdateDsrcDeclarationInput;
};


export type MutationUpdateDsrcInterestConflictApprovalArgs = {
  input: UpdateDsrcInterestConflictApprovalInput;
};


export type MutationUpdateDepartmentInputArgs = {
  input: UpdateDepartmentInputInput;
};


export type MutationUpdateEmploymentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmploymentInput;
};


export type MutationUpdateFrcsbAssessmentArgs = {
  input: UpdateFrcsbAssessmentInput;
};


export type MutationUpdateGsAssigneeArgs = {
  input: AssignGsDecisionInput;
};


export type MutationUpdateHodDosAssessmentArgs = {
  input: UpdateHodDosAssessmentInput;
};


export type MutationUpdateInterviewPanelArgs = {
  input: UpdateInterviewPanelInput;
};


export type MutationUpdateLanguageQualificationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLanguageQualificationInput;
};


export type MutationUpdateMeritArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMeritInput;
};


export type MutationUpdateMeritAssessmentArgs = {
  input: UpdateMeritAssessmentInput;
};


export type MutationUpdateNominationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNominationInput;
};


export type MutationUpdateNominationSubmissionStatusArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNominationSubmissionStatusInput;
};


export type MutationUpdateOfferParametersArgs = {
  input: OverrideOfferDetailInput;
};


export type MutationUpdatePanelArgs = {
  input: UpdatePanelInput;
};


export type MutationUpdatePanelApplicationAllocationArgs = {
  input: AssignPanelInput;
};


export type MutationUpdatePanelApplicationItemArgs = {
  input: UpdatePanelApplicationItemInput;
};


export type MutationUpdateProfessionalQualificationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProfessionalQualificationInput;
};


export type MutationUpdatePublicationArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePublicationInput;
};


export type MutationUpdatePublicationAssessmentArgs = {
  input: UpdatePublicationAssessmentInput;
};


export type MutationUpdateQualificationCheckArgs = {
  input: UpdateQualificationCheckInput;
};


export type MutationUpdateRefFormArgs = {
  input: UpdateRefFormInput;
};


export type MutationUpdateRefereeEmailArgs = {
  input: UpdateAcademicRefereeForReportInput;
};


export type MutationUpdateRegistrationDeadlineArgs = {
  input: UpdateRegistrationDeadlineInput;
};


export type MutationUpdateResearchAssessmentArgs = {
  input: UpdateResearchAssessmentInput;
};


export type MutationUpdateResearchExperienceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateResearchExperienceInput;
};


export type MutationUpdateScholarshipAcademicProgrammeArgs = {
  academicProgramme: Scalars['String']['input'];
  applicationId: Scalars['String']['input'];
};


export type MutationUpdateScholarshipNominationQuestionArgs = {
  input: UpdateScholarshipQuestionInput;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateScholarshipOrderingArgs = {
  input: UpdateFundingOrderEntryInput;
};


export type MutationUpdateScholarshipSubjectClassificationArgs = {
  applicationId: Scalars['String']['input'];
  competitiveStudentship?: InputMaybe<Scalars['Float']['input']>;
  subjectClassification: Funding_Panel;
};


export type MutationUpdateTrainingArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTrainingInput;
};


export type MutationUpdateVisaApplicationArgs = {
  input: UpdateVisaApplicationInput;
};


export type MutationWithdrawApplicationArgs = {
  id: Scalars['ID']['input'];
};

export enum Nomination_Declaration_Type {
  AdmissionUsingExternalOrDea = 'ADMISSION_USING_EXTERNAL_OR_DEA',
  ApplicantMeetHkpfsThreshold = 'APPLICANT_MEET_HKPFS_THRESHOLD',
  InformationTrue = 'INFORMATION_TRUE',
  NotRegisterHigherDegree = 'NOT_REGISTER_HIGHER_DEGREE',
  NoInterestConflict = 'NO_INTEREST_CONFLICT',
  NoResearchCollaborationWithPartnerChiefSupervisor = 'NO_RESEARCH_COLLABORATION_WITH_PARTNER_CHIEF_SUPERVISOR'
}

export type NameInput = {
  givenName?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type NationalRanking = {
  __typename?: 'NationalRanking';
  proof?: Maybe<FileType>;
  ranking: NationalRankingSystemType;
  score: Scalars['Int']['output'];
  universityLevel: Scalars['Int']['output'];
};

export type NationalRankingInput = {
  proof?: InputMaybe<FileTypeInput>;
  ranking: NationalRankingSystemType;
  score: Scalars['Int']['input'];
  universityLevel: Scalars['Int']['input'];
};

export enum NationalRankingSystemType {
  FirstTier = 'FIRST_TIER',
  SecondTier = 'SECOND_TIER'
}

export type Nomination = {
  __typename?: 'Nomination';
  admission?: Maybe<Admission>;
  applicant?: Maybe<Scalars['ID']['output']>;
  application?: Maybe<Scalars['ID']['output']>;
  archivedFundings?: Maybe<Array<Funding>>;
  canRenominate?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  declarations?: Maybe<Array<Declaration>>;
  /** @deprecated Use `fundings` object to support multiple funding types. */
  funding?: Maybe<Funding>;
  fundings?: Maybe<Array<Funding>>;
  interviewPanel?: Maybe<InterviewPanel>;
  remarks?: Maybe<Array<Scalars['String']['output']>>;
  scholarshipNomination?: Maybe<ScholarshipNomination>;
  /** Upon funding update, this field will change value. */
  shouldScholarshipNominationPerformed?: Maybe<Scalars['Boolean']['output']>;
  submission?: Maybe<Submission>;
  supervisors: Array<Supervisors>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type NominationDoc = {
  __typename?: 'NominationDoc';
  _id: Scalars['String']['output'];
  admission?: Maybe<Admission>;
  applicant?: Maybe<Scalars['ID']['output']>;
  application?: Maybe<Scalars['ID']['output']>;
  archivedFundings?: Maybe<Array<Funding>>;
  canRenominate?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  declarations?: Maybe<Array<Declaration>>;
  /** @deprecated Use `fundings` object to support multiple funding types. */
  funding?: Maybe<Funding>;
  fundings?: Maybe<Array<Funding>>;
  interviewPanel?: Maybe<InterviewPanel>;
  remarks?: Maybe<Array<Scalars['String']['output']>>;
  scholarshipNomination?: Maybe<ScholarshipNomination>;
  /** Upon funding update, this field will change value. */
  shouldScholarshipNominationPerformed?: Maybe<Scalars['Boolean']['output']>;
  submission?: Maybe<Submission>;
  supervisors: Array<Supervisors>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type NominationFilter = {
  _id?: InputMaybe<StringFilter>;
  admission?: InputMaybe<AdmissionFilter>;
  and?: InputMaybe<Array<NominationFilter>>;
  application?: InputMaybe<ApplicationFilter>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  eligibleFunding?: InputMaybe<FundingSourceFilter>;
  funding?: InputMaybe<FundingFilter>;
  /** Currently do not support array filter */
  fundings?: InputMaybe<FundingFilter>;
  nor?: InputMaybe<Array<NominationFilter>>;
  not?: InputMaybe<NominationFilter>;
  or?: InputMaybe<Array<NominationFilter>>;
  subjectClassification?: InputMaybe<FundingPanelFilter>;
  submission?: InputMaybe<SubmissionFilter>;
  supervisors?: InputMaybe<SupervisorsArrayFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

export type NominationPaginatorPayload = {
  __typename?: 'NominationPaginatorPayload';
  data: Array<NominationPayload>;
  paginator: PaginatorPayload;
};

export type NominationPayload = {
  __typename?: 'NominationPayload';
  _id: Scalars['ID']['output'];
  admission?: Maybe<Admission>;
  applicant?: Maybe<Scalars['ID']['output']>;
  application: ApplicationPayload;
  archivedFundings?: Maybe<Array<Funding>>;
  canRenominate?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  declarations?: Maybe<Array<Declaration>>;
  /** @deprecated Use `fundings` object to support multiple funding types. */
  funding?: Maybe<Funding>;
  fundings?: Maybe<Array<Funding>>;
  interviewPanel?: Maybe<InterviewPanel>;
  remarks?: Maybe<Array<Scalars['String']['output']>>;
  scholarshipNomination?: Maybe<ScholarshipNomination>;
  /** Upon funding update, this field will change value. */
  shouldScholarshipNominationPerformed?: Maybe<Scalars['Boolean']['output']>;
  submission?: Maybe<Submission>;
  supervisors: Array<Supervisors>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type NominationSort = {
  _id?: InputMaybe<Sorting_Order>;
  application?: InputMaybe<ApplicationSort>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  supervisors?: InputMaybe<SupervisorsSort>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
};

export type NominationSubmissionStatusPayload = {
  __typename?: 'NominationSubmissionStatusPayload';
  _id: Scalars['ID']['output'];
  /** The status should be redirected to HoD/DoS assessment if needed */
  backTo?: Maybe<Application_Status>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  lastSubmissionTime?: Maybe<Scalars['DateTime']['output']>;
  submissionCount: Scalars['Float']['output'];
  submitted: Scalars['Boolean']['output'];
  upafSubmissionIndicator?: Maybe<Upaf_Submission_Indicator>;
};

export type NonStemOrNonShs = {
  __typename?: 'NonSTEMOrNonSHS';
  accountCode?: Maybe<Scalars['String']['output']>;
  assumptionDate?: Maybe<Scalars['DateTime']['output']>;
  confirmation?: Maybe<Scalars['Boolean']['output']>;
  /** If this field is required for HoD/DoS to fill in. */
  required: Scalars['Boolean']['output'];
};

export type NonStemOrNonShsInput = {
  accountCode?: InputMaybe<Scalars['String']['input']>;
  assumptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  confirmation?: InputMaybe<Scalars['Boolean']['input']>;
  /** If this field is required for HoD/DoS to fill in. */
  required: Scalars['Boolean']['input'];
};

export type NotificationInboxPayload = {
  __typename?: 'NotificationInboxPayload';
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  hasRead: Scalars['Boolean']['output'];
  isHTML: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
  userRoles: Array<UserRole>;
};

export type NumberFilter = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export enum Other_Test_Test_Type {
  Gmat = 'GMAT',
  GmatFocus = 'GMAT_FOCUS',
  GmatOnline = 'GMAT_ONLINE',
  Gre = 'GRE'
}

/** Overall recommendation type */
export enum Overall_Recommendation {
  HighlyRecommended = 'HIGHLY_RECOMMENDED',
  NotRecommended = 'NOT_RECOMMENDED',
  Recommended = 'RECOMMENDED',
  VeryHighlyRecommended = 'VERY_HIGHLY_RECOMMENDED'
}

/** The completion status of the OVTS tasks for a student. */
export enum Ovts_Completion_Status {
  Completed = 'COMPLETED',
  Exempted = 'EXEMPTED',
  Incomplete = 'INCOMPLETE',
  NotCreated = 'NOT_CREATED'
}

export type ObjectIdFilter = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  options?: InputMaybe<Scalars['String']['input']>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type OfferCondition = {
  __typename?: 'OfferCondition';
  checkedAt?: Maybe<Scalars['DateTime']['output']>;
  checkedBy?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  /** @deprecated No file should be solely updated for the current logic. */
  file?: Maybe<Array<FileType>>;
  item: Scalars['String']['output'];
  passed?: Maybe<Scalars['Boolean']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  /** The display title for this page. In order to avoid new types of requirement creation. */
  title?: Maybe<Scalars['String']['output']>;
  waived?: Maybe<Scalars['Boolean']['output']>;
};

export type OfferConditionInput = {
  checkedAt?: InputMaybe<Scalars['DateTime']['input']>;
  checkedBy?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Array<FileTypeInput>>;
  item: Scalars['String']['input'];
  passed?: InputMaybe<Scalars['Boolean']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  /** The display title for this page. In order to avoid new types of requirement creation. */
  title?: InputMaybe<Scalars['String']['input']>;
  waived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OfferDetailPaginatedPayload = {
  __typename?: 'OfferDetailPaginatedPayload';
  data: Array<OfferDetailPayload>;
  paginator: PaginatorPayload;
};

export type OfferDetailPayload = {
  __typename?: 'OfferDetailPayload';
  _id: Scalars['ID']['output'];
  acceptDeadline?: Maybe<Scalars['DateTime']['output']>;
  applicantChineseName?: Maybe<Scalars['String']['output']>;
  applicantName: Scalars['String']['output'];
  applicantNationality: Scalars['String']['output'];
  applicationId: Scalars['ID']['output'];
  applicationNo: Scalars['String']['output'];
  applicationStatus: Scalars['String']['output'];
  assignee?: Maybe<Scalars['String']['output']>;
  conditionFulfilled: Scalars['Boolean']['output'];
  conditionFulfillingDeadline?: Maybe<Scalars['DateTime']['output']>;
  conditions: Array<OfferCondition>;
  contactDepartmentPersonEmail?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonName?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonPhone?: Maybe<Scalars['String']['output']>;
  department: Scalars['String']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  entryYear: Scalars['String']['output'];
  /** @deprecated To be removed after UPAF is on. */
  funding?: Maybe<Funding>;
  fundingSource: Scalars['String']['output'];
  fundingStatus: Scalars['String']['output'];
  fundings?: Maybe<Array<Funding>>;
  hasAssistantship: Scalars['Boolean']['output'];
  hasStipend: Scalars['Boolean']['output'];
  /** Only display the first submission time. */
  initialSubmissionTime?: Maybe<SubmissionToGs>;
  isFirmOffer: Scalars['Boolean']['output'];
  isLocal: Scalars['Boolean']['output'];
  isPolyUHome: Scalars['Boolean']['output'];
  meetConditionNotified: Scalars['Boolean']['output'];
  offerDate: Scalars['DateTime']['output'];
  partner?: Maybe<Partner>;
  partnerUniversity: Scalars['String']['output'];
  partnerUniversitySupervisor?: Maybe<Scalars['String']['output']>;
  programme: Programme;
  programmeCode: Scalars['String']['output'];
  programmeSubcode: Scalars['String']['output'];
  programmeType: Programme_Type;
  programmeWithDuration?: Maybe<Scalars['String']['output']>;
  proposedChiefSupervisor?: Maybe<Scalars['String']['output']>;
  refNo: Scalars['String']['output'];
  releaseDate?: Maybe<Scalars['DateTime']['output']>;
  researchArea: Scalars['String']['output'];
  scheduledRegistrationDate: Scalars['DateTime']['output'];
  status?: Maybe<OfferStatus>;
  studyMode: Studu_Mode;
  /** Only display the last submission time. */
  submissionTime?: Maybe<SubmissionToGs>;
  supervisor: Scalars['String']['output'];
  tuitionAssistantshipType: Scalars['String']['output'];
};

export type OfferDetailSorter = {
  acceptDeadline?: InputMaybe<Sorting_Order>;
  applicantNationality?: InputMaybe<Sorting_Order>;
  applicationNo?: InputMaybe<Sorting_Order>;
  department?: InputMaybe<Sorting_Order>;
  entryYear?: InputMaybe<Sorting_Order>;
  programme?: InputMaybe<Sorting_Order>;
  programmeType?: InputMaybe<Sorting_Order>;
  refNo?: InputMaybe<Sorting_Order>;
  studyMode?: InputMaybe<Sorting_Order>;
};

export type OfferEmailCheck = {
  __typename?: 'OfferEmailCheck';
  checked: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
};

export type OfferEmailCheckInput = {
  checked?: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
};

export type OfferFilter = {
  applicantName?: InputMaybe<StringFilter>;
  applicantNationality?: InputMaybe<StringFilter>;
  applicationId?: InputMaybe<StringFilter>;
  applicationNo?: InputMaybe<StringFilter>;
  conditionFulfilled?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  entryYear?: InputMaybe<StringFilter>;
  identityDocumentNumber?: InputMaybe<StringFilter>;
  isFirmOffer?: InputMaybe<Scalars['Boolean']['input']>;
  isLocal?: InputMaybe<Scalars['Boolean']['input']>;
  needStudentVisa?: InputMaybe<Scalars['Boolean']['input']>;
  offeredDate?: InputMaybe<Scalars['DateTime']['input']>;
  programme?: InputMaybe<ProgrammeFilter>;
  programmeType?: InputMaybe<ProgrammeTypeFilter>;
  status?: InputMaybe<StringFilter>;
};

/** This is for offer letter display usage. */
export type OfferLetterPayload = {
  __typename?: 'OfferLetterPayload';
  acceptDeadline: Scalars['DateTime']['output'];
  applicantChineseName?: Maybe<Scalars['String']['output']>;
  applicantName: Scalars['String']['output'];
  applicantNationality: Scalars['String']['output'];
  applicationId: Scalars['ID']['output'];
  applicationNo: Scalars['String']['output'];
  commencementDate: Scalars['DateTime']['output'];
  conditionFulfilled?: Maybe<Scalars['Boolean']['output']>;
  conditionFulfillingDeadline?: Maybe<Scalars['DateTime']['output']>;
  conditions: Array<OfferCondition>;
  contactDepartmentPersonEmail?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonName?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creditRequirement: Scalars['Float']['output'];
  deferOffer?: Maybe<DeferOfferType>;
  deferredOfferInformation?: Maybe<Scalars['String']['output']>;
  department: Scalars['String']['output'];
  /** @deprecated Use normalPeriodOfStudy instead. */
  duration?: Maybe<Scalars['Float']['output']>;
  entryYear: Scalars['String']['output'];
  entryYearDisplayName: Scalars['String']['output'];
  fundingLetter: FileType;
  fundingSource?: Maybe<Funding_Source>;
  fundingStatus?: Maybe<Funding_Status>;
  hasAssistantship?: Maybe<Scalars['Boolean']['output']>;
  hasStipend?: Maybe<Scalars['Boolean']['output']>;
  isFirmOffer: Scalars['Boolean']['output'];
  /** Use the information from applicant. This is a readonly copy. */
  isLocal: Scalars['Boolean']['output'];
  isPolyUHome?: Maybe<Scalars['Boolean']['output']>;
  meetConditionNotified?: Maybe<Scalars['Boolean']['output']>;
  normalPeriodOfStudy: Scalars['Float']['output'];
  offerDate: Scalars['DateTime']['output'];
  partnerUniversity?: Maybe<Scalars['String']['output']>;
  partnerUniversitySupervisor?: Maybe<Scalars['String']['output']>;
  programme: Programme;
  programmeCode: Scalars['String']['output'];
  programmeSubcode: Scalars['String']['output'];
  programmeType: Programme_Type;
  /** NetId of the proposed chief supervisor. Do not use for display usage. */
  proposedChiefSupervisor?: Maybe<Scalars['String']['output']>;
  refNo: Scalars['String']['output'];
  reportingDutyDate: Scalars['DateTime']['output'];
  researchArea: Scalars['String']['output'];
  scheduledRegistrationDate?: Maybe<Scalars['DateTime']['output']>;
  status: OfferStatus;
  studyMode: Studu_Mode;
  /** Name of the supervisor, fetched from nomination stage. */
  supervisor: Scalars['String']['output'];
  tuitionAssistantshipType?: Maybe<TuitionAssistantship>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type OfferModel = {
  __typename?: 'OfferModel';
  acceptDeadline: Scalars['DateTime']['output'];
  applicantChineseName?: Maybe<Scalars['String']['output']>;
  applicantName: Scalars['String']['output'];
  applicantNationality: Scalars['String']['output'];
  applicationId: Scalars['ID']['output'];
  applicationNo: Scalars['String']['output'];
  conditionFulfilled?: Maybe<Scalars['Boolean']['output']>;
  conditionFulfillingDeadline?: Maybe<Scalars['DateTime']['output']>;
  conditions: Array<OfferCondition>;
  contactDepartmentPersonEmail?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonName?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deferOffer?: Maybe<DeferOfferType>;
  deferredOfferInformation?: Maybe<Scalars['String']['output']>;
  department: Scalars['String']['output'];
  /** @deprecated Use normalPeriodOfStudy instead. */
  duration?: Maybe<Scalars['Float']['output']>;
  entryYear: Scalars['String']['output'];
  fundingSource?: Maybe<Funding_Source>;
  fundingStatus?: Maybe<Funding_Status>;
  hasAssistantship?: Maybe<Scalars['Boolean']['output']>;
  hasStipend?: Maybe<Scalars['Boolean']['output']>;
  isFirmOffer: Scalars['Boolean']['output'];
  /** Use the information from applicant. This is a readonly copy. */
  isLocal: Scalars['Boolean']['output'];
  isPolyUHome?: Maybe<Scalars['Boolean']['output']>;
  meetConditionNotified?: Maybe<Scalars['Boolean']['output']>;
  offerDate: Scalars['DateTime']['output'];
  partnerUniversity?: Maybe<Scalars['String']['output']>;
  partnerUniversitySupervisor?: Maybe<Scalars['String']['output']>;
  programme: Programme;
  programmeCode: Scalars['String']['output'];
  programmeSubcode: Scalars['String']['output'];
  programmeType: Programme_Type;
  /** NetId of the proposed chief supervisor. Do not use for display usage. */
  proposedChiefSupervisor?: Maybe<Scalars['String']['output']>;
  refNo: Scalars['String']['output'];
  researchArea: Scalars['String']['output'];
  scheduledRegistrationDate?: Maybe<Scalars['DateTime']['output']>;
  status: OfferStatus;
  studyMode: Studu_Mode;
  /** Name of the supervisor, fetched from nomination stage. */
  supervisor: Scalars['String']['output'];
  tuitionAssistantshipType?: Maybe<TuitionAssistantship>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type OfferModelDoc = {
  __typename?: 'OfferModelDoc';
  _id: Scalars['String']['output'];
  acceptDeadline: Scalars['DateTime']['output'];
  applicantChineseName?: Maybe<Scalars['String']['output']>;
  applicantName: Scalars['String']['output'];
  applicantNationality: Scalars['String']['output'];
  applicationId: Scalars['ID']['output'];
  applicationNo: Scalars['String']['output'];
  conditionFulfilled?: Maybe<Scalars['Boolean']['output']>;
  conditionFulfillingDeadline?: Maybe<Scalars['DateTime']['output']>;
  conditions: Array<OfferCondition>;
  contactDepartmentPersonEmail?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonName?: Maybe<Scalars['String']['output']>;
  contactDepartmentPersonPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deferOffer?: Maybe<DeferOfferType>;
  deferredOfferInformation?: Maybe<Scalars['String']['output']>;
  department: Scalars['String']['output'];
  /** @deprecated Use normalPeriodOfStudy instead. */
  duration?: Maybe<Scalars['Float']['output']>;
  entryYear: Scalars['String']['output'];
  fundingSource?: Maybe<Funding_Source>;
  fundingStatus?: Maybe<Funding_Status>;
  hasAssistantship?: Maybe<Scalars['Boolean']['output']>;
  hasStipend?: Maybe<Scalars['Boolean']['output']>;
  isFirmOffer: Scalars['Boolean']['output'];
  /** Use the information from applicant. This is a readonly copy. */
  isLocal: Scalars['Boolean']['output'];
  isPolyUHome?: Maybe<Scalars['Boolean']['output']>;
  meetConditionNotified?: Maybe<Scalars['Boolean']['output']>;
  offerDate: Scalars['DateTime']['output'];
  partnerUniversity?: Maybe<Scalars['String']['output']>;
  partnerUniversitySupervisor?: Maybe<Scalars['String']['output']>;
  programme: Programme;
  programmeCode: Scalars['String']['output'];
  programmeSubcode: Scalars['String']['output'];
  programmeType: Programme_Type;
  /** NetId of the proposed chief supervisor. Do not use for display usage. */
  proposedChiefSupervisor?: Maybe<Scalars['String']['output']>;
  refNo: Scalars['String']['output'];
  researchArea: Scalars['String']['output'];
  scheduledRegistrationDate?: Maybe<Scalars['DateTime']['output']>;
  status: OfferStatus;
  studyMode: Studu_Mode;
  /** Name of the supervisor, fetched from nomination stage. */
  supervisor: Scalars['String']['output'];
  tuitionAssistantshipType?: Maybe<TuitionAssistantship>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum OfferStatus {
  ApplicantAccepted = 'APPLICANT_ACCEPTED',
  ApplicantRejected = 'APPLICANT_REJECTED',
  Created = 'CREATED',
  FailedReadyToRelease = 'FAILED_READY_TO_RELEASE',
  FailedReleased = 'FAILED_RELEASED',
  FailedReleasing = 'FAILED_RELEASING',
  Invalid = 'INVALID',
  MeetConditionLapsed = 'MEET_CONDITION_LAPSED',
  Overdue = 'OVERDUE',
  ProvisioningPendingRsf = 'PROVISIONING_PENDING_RSF',
  ReadyToRelease = 'READY_TO_RELEASE',
  Released = 'RELEASED',
  Releasing = 'RELEASING',
  Revoked = 'REVOKED'
}

export enum OfferSuggestion {
  Conditional = 'CONDITIONAL',
  Firm = 'FIRM',
  NotRecommended = 'NOT_RECOMMENDED',
  Reject = 'REJECT'
}

export type OfferedApplicationFilter = {
  _id?: InputMaybe<StringFilter>;
  applicantName?: InputMaybe<StringFilter>;
  applicationId?: InputMaybe<StringFilter>;
  applicationNo?: InputMaybe<StringFilter>;
  /** Application Status. ADD Jul 5 */
  applicationStatus?: InputMaybe<ApplicationStatusFilter>;
  conditionFulFilled?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  department?: InputMaybe<StringFilter>;
  /** Entry Year. ADD Jul 5 */
  entryYear?: InputMaybe<StringFilter>;
  isFirmOffer?: InputMaybe<Scalars['Boolean']['input']>;
  isLocal?: InputMaybe<Scalars['Boolean']['input']>;
  meetConditionStatus?: InputMaybe<StringFilter>;
  offerStatus?: InputMaybe<StringFilter>;
  programme?: InputMaybe<ProgrammeFilter>;
  qualificationCheckDisplayStatus?: InputMaybe<StringFilter>;
  qualificationCheckStatus?: InputMaybe<StringFilter>;
  releaseDate?: InputMaybe<DateFilter>;
  studyMode?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
  visaStatus?: InputMaybe<StringFilter>;
};

export type OfferedApplicationListPayload = {
  __typename?: 'OfferedApplicationListPayload';
  applicantName: Scalars['String']['output'];
  applicantNationality: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  applicationNo: Scalars['String']['output'];
  department: Scalars['String']['output'];
  entryYear: Scalars['String']['output'];
  isFirmOffer: Scalars['Boolean']['output'];
  programme: Programme;
  programmeType: Programme_Type;
  qualificationCheckStatus?: Maybe<QualificationCheckStatus>;
  studyMode: Programme_Choice_Study_Mode;
  visaStatus?: Maybe<VisaStatus>;
};

export type OnlineRegistrationModel = {
  __typename?: 'OnlineRegistrationModel';
  applicationId: Scalars['String']['output'];
  commencementDate?: Maybe<Scalars['DateTime']['output']>;
  confirmCommencement?: Maybe<Scalars['Boolean']['output']>;
  particularChecked: Scalars['Boolean']['output'];
  photoFile?: Maybe<FileType>;
  qrCodeBase64?: Maybe<Scalars['String']['output']>;
  qrCodeRequestId?: Maybe<Scalars['String']['output']>;
  /** @deprecated We do not maintain the status anymore. */
  questionnaireSubmitted: Scalars['Boolean']['output'];
  studentCardCollected?: Maybe<Scalars['Boolean']['output']>;
  studentCardCollectionSlotId?: Maybe<Scalars['String']['output']>;
  studentNumber?: Maybe<Scalars['String']['output']>;
};

export type OnlineRegistrationModelDoc = {
  __typename?: 'OnlineRegistrationModelDoc';
  _id: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  commencementDate?: Maybe<Scalars['DateTime']['output']>;
  confirmCommencement?: Maybe<Scalars['Boolean']['output']>;
  particularChecked: Scalars['Boolean']['output'];
  photoFile?: Maybe<FileType>;
  qrCodeBase64?: Maybe<Scalars['String']['output']>;
  qrCodeRequestId?: Maybe<Scalars['String']['output']>;
  /** @deprecated We do not maintain the status anymore. */
  questionnaireSubmitted: Scalars['Boolean']['output'];
  studentCardCollected?: Maybe<Scalars['Boolean']['output']>;
  studentCardCollectionSlotId?: Maybe<Scalars['String']['output']>;
  studentNumber?: Maybe<Scalars['String']['output']>;
};

export type OtherTest = {
  __typename?: 'OtherTest';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  expectedResultUpdateDate?: Maybe<Scalars['DateTime']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  result: OtherTestResult;
  resultAnnouncedIndicator: Scalars['Boolean']['output'];
  supportingDocuments?: Maybe<Array<FileType>>;
  testDate?: Maybe<Scalars['DateTime']['output']>;
  testType: Other_Test_Test_Type;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type OtherTestPayload = {
  __typename?: 'OtherTestPayload';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  expectedResultUpdateDate?: Maybe<Scalars['DateTime']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  result: OtherTestResult;
  resultAnnouncedIndicator: Scalars['Boolean']['output'];
  supportingDocuments?: Maybe<Array<FileType>>;
  testDate?: Maybe<Scalars['DateTime']['output']>;
  testType: Other_Test_Test_Type;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type OtherTestRequirement = {
  __typename?: 'OtherTestRequirement';
  fulfilled?: Maybe<Scalars['Boolean']['output']>;
  justification?: Maybe<Scalars['String']['output']>;
  requirements: Scalars['String']['output'];
};

export type OtherTestRequirementInput = {
  fulfilled?: InputMaybe<Scalars['Boolean']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  requirements: Scalars['String']['input'];
};

export type OtherTestResult = {
  __typename?: 'OtherTestResult';
  analyticalWritingPercentile?: Maybe<Scalars['Float']['output']>;
  analyticalWritingScore?: Maybe<Scalars['Float']['output']>;
  dataInsightsPercentile?: Maybe<Scalars['Float']['output']>;
  dataInsightsScore?: Maybe<Scalars['Float']['output']>;
  integratedReasoningPercentile?: Maybe<Scalars['Float']['output']>;
  integratedReasoningScore?: Maybe<Scalars['Float']['output']>;
  quantitativePercentile?: Maybe<Scalars['Float']['output']>;
  quantitativeScore?: Maybe<Scalars['Float']['output']>;
  resultReceiptDate?: Maybe<Scalars['DateTime']['output']>;
  totalPercentile?: Maybe<Scalars['Float']['output']>;
  totalScore?: Maybe<Scalars['Float']['output']>;
  verbalPercentile?: Maybe<Scalars['Float']['output']>;
  verbalScore?: Maybe<Scalars['Float']['output']>;
};

export type OtherTestResultInput = {
  analyticalWritingPercentile?: InputMaybe<Scalars['Float']['input']>;
  analyticalWritingScore?: InputMaybe<Scalars['Float']['input']>;
  dataInsightsPercentile?: InputMaybe<Scalars['Float']['input']>;
  dataInsightsScore?: InputMaybe<Scalars['Float']['input']>;
  integratedReasoningPercentile?: InputMaybe<Scalars['Float']['input']>;
  integratedReasoningScore?: InputMaybe<Scalars['Float']['input']>;
  quantitativePercentile?: InputMaybe<Scalars['Float']['input']>;
  quantitativeScore?: InputMaybe<Scalars['Float']['input']>;
  resultReceiptDate?: InputMaybe<Scalars['DateTime']['input']>;
  totalPercentile?: InputMaybe<Scalars['Float']['input']>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
  verbalPercentile?: InputMaybe<Scalars['Float']['input']>;
  verbalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type OtherTestResultSort = {
  analyticalWritingPercentile?: InputMaybe<Sorting_Order>;
  analyticalWritingScore?: InputMaybe<Sorting_Order>;
  integratedReasoningPercentile?: InputMaybe<Sorting_Order>;
  integratedReasoningScore?: InputMaybe<Sorting_Order>;
  quantitativePercentile?: InputMaybe<Sorting_Order>;
  quantitativeScore?: InputMaybe<Sorting_Order>;
  totalPercentile?: InputMaybe<Sorting_Order>;
  totalScore?: InputMaybe<Sorting_Order>;
  verbalPercentile?: InputMaybe<Sorting_Order>;
  verbalScore?: InputMaybe<Sorting_Order>;
};

export type OtherTestResultV1Input = {
  analyticalWritingPercentile?: InputMaybe<Scalars['Float']['input']>;
  analyticalWritingScore?: InputMaybe<Scalars['Float']['input']>;
  dataInsightsPercentile?: InputMaybe<Scalars['Float']['input']>;
  dataInsightsScore?: InputMaybe<Scalars['Float']['input']>;
  integratedReasoningPercentile?: InputMaybe<Scalars['Float']['input']>;
  integratedReasoningScore?: InputMaybe<Scalars['Float']['input']>;
  quantitativePercentile?: InputMaybe<Scalars['Float']['input']>;
  quantitativeScore?: InputMaybe<Scalars['Float']['input']>;
  resultReceiptDate?: InputMaybe<Scalars['DateTime']['input']>;
  totalPercentile?: InputMaybe<Scalars['Float']['input']>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
  verbalPercentile?: InputMaybe<Scalars['Float']['input']>;
  verbalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type OtherTestSort = {
  _id?: InputMaybe<Sorting_Order>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  expectedResultUpdateDate?: InputMaybe<Sorting_Order>;
  referenceNo?: InputMaybe<Sorting_Order>;
  result?: InputMaybe<OtherTestResultSort>;
  resultAnnouncedIndicator?: InputMaybe<Sorting_Order>;
  testDate?: InputMaybe<Sorting_Order>;
  testType?: InputMaybe<Sorting_Order>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
};

export type OutCreateApplicationFee = {
  __typename?: 'OutCreateApplicationFee';
  applnNo?: Maybe<Scalars['String']['output']>;
  resultCode: Scalars['String']['output'];
};

export type OutMaintainRegistrationAndTuitionFee = {
  __typename?: 'OutMaintainRegistrationAndTuitionFee';
  applnNo?: Maybe<Scalars['String']['output']>;
  progCode?: Maybe<Scalars['String']['output']>;
  progSubCode?: Maybe<Scalars['String']['output']>;
  resultCode: Scalars['String']['output'];
  resultList?: Maybe<Scalars['String']['output']>;
};

export type OutRetrieveApplnFeePayment = {
  __typename?: 'OutRetrieveApplnFeePayment';
  applnNo: Scalars['String']['output'];
  resultCode: Scalars['String']['output'];
  resultValue?: Maybe<PaymentStatus>;
};

export type OverrideOfferDetailInput = {
  admissionSemYear1?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['String']['input']>;
  applicationNo?: InputMaybe<Scalars['String']['input']>;
  assisstantShip?: InputMaybe<Scalars['Boolean']['input']>;
  assisstantShipFullOrHalf?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['String']['input']>;
  conferenceGrant?: InputMaybe<Scalars['String']['input']>;
  creditRequirement?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  departmentName?: InputMaybe<Scalars['String']['input']>;
  departmentStaffEmail?: InputMaybe<Scalars['String']['input']>;
  departmentStaffName?: InputMaybe<Scalars['String']['input']>;
  departmentStaffNumber?: InputMaybe<Scalars['String']['input']>;
  fellowshipScheme?: InputMaybe<Scalars['String']['input']>;
  fellowshipSchemeFullname?: InputMaybe<Scalars['String']['input']>;
  firmOffer?: InputMaybe<Scalars['Boolean']['input']>;
  fulltimeLocal?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssisstantship?: InputMaybe<Scalars['Boolean']['input']>;
  hasFellowship?: InputMaybe<Scalars['Boolean']['input']>;
  homeUniversity?: InputMaybe<Scalars['String']['input']>;
  hostUniversity?: InputMaybe<Scalars['String']['input']>;
  meetingConditionDeadline?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  monthlyStipend?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  normalPeriodOfStudy?: InputMaybe<Scalars['String']['input']>;
  partnerCoSupervisorName?: InputMaybe<Scalars['String']['input']>;
  partnerUniversity?: InputMaybe<Scalars['String']['input']>;
  programmeCodeSubcode?: InputMaybe<Scalars['String']['input']>;
  programmeName?: InputMaybe<Scalars['String']['input']>;
  proposedSupervisorName?: InputMaybe<Scalars['String']['input']>;
  reportingDutyDate?: InputMaybe<Scalars['String']['input']>;
  residenceRequirements?: InputMaybe<Scalars['String']['input']>;
  selfFinanced?: InputMaybe<Scalars['Boolean']['input']>;
  stipendMonths?: InputMaybe<Scalars['String']['input']>;
  studyCommencementDate?: InputMaybe<Scalars['String']['input']>;
  studyModeName?: InputMaybe<Scalars['String']['input']>;
  /** Should be D MMMM YYYY format */
  supersedeDate?: InputMaybe<Scalars['String']['input']>;
  /** Should be D MMMM YYYY format. Note there is currently a typo. */
  supersededate?: InputMaybe<Scalars['String']['input']>;
  tuitionFee?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

/** PanelResult of the application decided in the panel meeting */
export enum Panel_Result {
  Failed = 'FAILED',
  NotEligible = 'NOT_ELIGIBLE',
  OneYear = 'ONE_YEAR',
  Pending = 'PENDING',
  ShortListed = 'SHORT_LISTED',
  ShortListedOutstanding = 'SHORT_LISTED_OUTSTANDING',
  Tbd = 'TBD',
  ThreeYears = 'THREE_YEARS',
  TwoYears = 'TWO_YEARS',
  Withdrawn = 'WITHDRAWN'
}

export enum Partner_University_Category {
  ChinaMainland = 'CHINA_MAINLAND',
  Overseas = 'OVERSEAS'
}

/** The type of payment */
export enum Payment_Type {
  ApplicationFee = 'APPLICATION_FEE',
  FoRegistrationFee = 'FO_REGISTRATION_FEE',
  RegistrationFee = 'REGISTRATION_FEE',
  TuitionFee = 'TUITION_FEE'
}

/** Type of personal information collection */
export enum Personal_Info_Type {
  Cn = 'CN',
  Eu = 'EU',
  Others = 'OTHERS'
}

export enum Programme {
  DoctorOfPhilosophy = 'DOCTOR_OF_PHILOSOPHY',
  MasterOfPhilosophy = 'MASTER_OF_PHILOSOPHY'
}

export enum Programme_Choice_Study_Mode {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME'
}

export enum Programme_Type {
  CollaborativePhdDegreeProgramme = 'COLLABORATIVE_PHD_DEGREE_PROGRAMME',
  DualPhdDegreeProgramme = 'DUAL_PHD_DEGREE_PROGRAMME',
  GeneralProgramme = 'GENERAL_PROGRAMME'
}

export enum Project_Declaration_Type {
  ChiefSupervisorNotGrfEcsPtojectPi = 'CHIEF_SUPERVISOR_NOT_GRF_ECS_PTOJECT_PI',
  GrfEcsProjectFundedAfterAndNotReceivedSupportBefore = 'GRF_ECS_PROJECT_FUNDED_AFTER_AND_NOT_RECEIVED_SUPPORT_BEFORE',
  SufficientFundingFromShsStemProject = 'SUFFICIENT_FUNDING_FROM_SHS_STEM_PROJECT'
}

export enum Project_Role {
  Ci = 'CI',
  NonSpecialPi = 'NON_SPECIAL_PI',
  Pi = 'PI',
  SpecialPi = 'SPECIAL_PI'
}

/** Type of proof document */
export enum Proof_Document_Type {
  Internal = 'INTERNAL',
  Public = 'PUBLIC',
  Restricted = 'RESTRICTED'
}

export type PaginatorOptions = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
};

export type PaginatorPayload = {
  __typename?: 'PaginatorPayload';
  count: Scalars['Float']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nextPage?: Maybe<Scalars['Float']['output']>;
  previousPage?: Maybe<Scalars['Float']['output']>;
  total_pages: Scalars['Float']['output'];
};

export type PanelApplication = {
  __typename?: 'PanelApplication';
  applicationId: Scalars['String']['output'];
  /** avg score of reveiewers */
  avgReviewerScore?: Maybe<Scalars['Float']['output']>;
  /** avg score of reveiewers and department */
  avgScore?: Maybe<Scalars['Float']['output']>;
  classification?: Maybe<Funding_Panel>;
  isTop10?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<PanelApplicationItem>>;
  manuallyAdded?: Maybe<Scalars['Boolean']['output']>;
  panelResult: Scalars['String']['output'];
  remarks?: Maybe<Array<PanelUserRemark>>;
  /** Two reviewers of the application in this panel. */
  reviewers?: Maybe<Array<PanelApplicationReviewer>>;
  /** [Application] The index of the panel application */
  serialNo: Scalars['Float']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type PanelApplicationColumnEntry = {
  column?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
};

export type PanelApplicationFilter = {
  applicantName?: InputMaybe<StringFilter>;
  applicationId?: InputMaybe<StringFilter>;
  applicationNo?: InputMaybe<StringFilter>;
  classification?: InputMaybe<StringFilter>;
  department?: InputMaybe<StringFilter>;
  expr?: InputMaybe<Scalars['String']['input']>;
  firstDegree?: InputMaybe<StringFilter>;
  panelResults?: InputMaybe<StringArrayFilter>;
  partnerUniversity?: InputMaybe<Scalars['String']['input']>;
  priorityRange?: InputMaybe<Array<Scalars['Float']['input']>>;
  serialNo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<StringArrayFilter>;
};

export type PanelApplicationItem = {
  __typename?: 'PanelApplicationItem';
  column: Scalars['String']['output'];
  content: Array<Scalars['String']['output']>;
};

export type PanelApplicationPayload = {
  __typename?: 'PanelApplicationPayload';
  /** [Applicant] The name of the applicant. Used the surname and first name of the applicant. */
  applicantName: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  /** [Application] The application number of the panel application */
  applicationNo: Scalars['String']['output'];
  /** avg score of reveiewers */
  avgReviewerScore?: Maybe<Scalars['Float']['output']>;
  /** avg score of reveiewers and department */
  avgScore?: Maybe<Scalars['Float']['output']>;
  classification?: Maybe<Funding_Panel>;
  csRemainStudentshipYears?: Maybe<Scalars['Float']['output']>;
  csStudentshipYears?: Maybe<Scalars['Float']['output']>;
  /** [ProgrammeChoice] The name of the department of the applicant. */
  department: Scalars['String']['output'];
  deptPriorityNumber?: Maybe<Scalars['Float']['output']>;
  /** Fetched first degree data. The converted GPA is from Assessment. (Upd May 28) */
  firstDegree?: Maybe<FirstDegreeAssessmentType>;
  isTop10?: Maybe<Scalars['Boolean']['output']>;
  /** The items of the panel application. */
  items?: Maybe<Array<PanelApplicationItem>>;
  manuallyAdded?: Maybe<Scalars['Boolean']['output']>;
  merits?: Maybe<Array<MeritPayload>>;
  /** [Applicant] The nationality of the applicant. */
  nationality: Scalars['String']['output'];
  nomination?: Maybe<Nomination>;
  panelResult: Scalars['String']['output'];
  partnerPriority?: Maybe<Scalars['Float']['output']>;
  /** [ProgrammeChoice] Partner University */
  partnerUniversity?: Maybe<Scalars['String']['output']>;
  partnerUniversityName?: Maybe<Scalars['String']['output']>;
  publications?: Maybe<Array<PublicationPayload>>;
  remarks?: Maybe<Array<PanelUserRemark>>;
  /** Two reviewers of the application in this panel. */
  reviewers?: Maybe<Array<PanelApplicationReviewer>>;
  /** The scholarship nomination of the applicant. */
  scholarshipNomination?: Maybe<ScholarshipNomination>;
  /** Fetched second degree data. The converted GPA is from Assessment. (Upd May 28) */
  secondDegree?: Maybe<FirstDegreeAssessmentType>;
  /** [Application] The index of the panel application */
  serialNo: Scalars['Float']['output'];
  /** [ProgrammeChoice] The name of the department of the applicant. */
  status: Application_Status;
  /** The items of the panel application. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type PanelApplicationReviewer = {
  __typename?: 'PanelApplicationReviewer';
  comment?: Maybe<Scalars['String']['output']>;
  declaration?: Maybe<Scalars['Boolean']['output']>;
  /** NetID of the reviewer. */
  netId: Scalars['String']['output'];
  /** Scores for this panel only. Must pass all the information to the structure once it is going to be used.Provide 0 or -1 to the fundings that does not require the items. */
  scoresOverride?: Maybe<PanelUserUpafOverride>;
};

export type PanelBaseFilter = {
  _id: StringFilter;
  panelNo?: InputMaybe<StringFilter>;
};

export type PanelFilter = {
  endDate?: InputMaybe<DateFilter>;
  fundingSource?: InputMaybe<StringFilter>;
  panelNo?: InputMaybe<StringFilter>;
  panelRound?: InputMaybe<NumberFilter>;
  panelType?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<StringFilter>;
};

export type PanelMember = {
  __typename?: 'PanelMember';
  classification?: Maybe<Funding_Panel>;
  department: Scalars['String']['output'];
  email: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  institution: Scalars['String']['output'];
  isPanelChair?: Maybe<Scalars['Boolean']['output']>;
  jobTitle: Scalars['String']['output'];
  netId?: Maybe<Scalars['String']['output']>;
  post?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['String']['output']>;
  surname: Scalars['String']['output'];
  telephoneNumber?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type PanelMemberArrayFilter = {
  all?: InputMaybe<Array<PanelMemberArrayFilter>>;
  classification?: InputMaybe<StringFilter>;
  department?: InputMaybe<StringFilter>;
  elemMatch?: InputMaybe<PanelMemberFilter>;
  email?: InputMaybe<StringFilter>;
  givenName?: InputMaybe<StringFilter>;
  institution?: InputMaybe<StringFilter>;
  isPanelChair?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<StringFilter>;
  netId?: InputMaybe<StringFilter>;
  post?: InputMaybe<StringFilter>;
  rank?: InputMaybe<StringFilter>;
  size?: InputMaybe<Scalars['Float']['input']>;
  surname?: InputMaybe<StringFilter>;
  telephoneNumber?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PanelMemberFilter = {
  classification?: InputMaybe<StringFilter>;
  department?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  givenName?: InputMaybe<StringFilter>;
  institution?: InputMaybe<StringFilter>;
  isPanelChair?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<StringFilter>;
  netId?: InputMaybe<StringFilter>;
  post?: InputMaybe<StringFilter>;
  rank?: InputMaybe<StringFilter>;
  surname?: InputMaybe<StringFilter>;
  telephoneNumber?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PanelMemberInput = {
  classification?: InputMaybe<Funding_Panel>;
  department: Scalars['String']['input'];
  email: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  institution: Scalars['String']['input'];
  isPanelChair?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: Scalars['String']['input'];
  netId?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['String']['input']>;
  surname: Scalars['String']['input'];
  telephoneNumber?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type PanelModel = {
  __typename?: 'PanelModel';
  academicYear?: Maybe<Scalars['String']['output']>;
  allocationReleased?: Maybe<Scalars['Boolean']['output']>;
  applications: Array<PanelApplication>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  entryYear?: Maybe<Scalars['String']['output']>;
  fundingRound: Funding_Round;
  fundingSource: Funding_Source;
  gsHelper: Scalars['String']['output'];
  lockFilter?: Maybe<Scalars['String']['output']>;
  /** @deprecated May use the member group. */
  panelChair?: Maybe<PanelMember>;
  panelMembers: Array<PanelMember>;
  panelNo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Do not use this field. */
  panelRound?: Maybe<Scalars['Float']['output']>;
  panelType: Funding_Panel;
  resultOptions?: Maybe<Array<Panel_Result>>;
  startDate: Scalars['DateTime']['output'];
  status: PanelStatus;
  tagOptions?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  /** @deprecated Do not use this field. */
  totalRound?: Maybe<Scalars['Float']['output']>;
  updatedBy: Scalars['String']['output'];
};

export type PanelModelPayload = {
  __typename?: 'PanelModelPayload';
  _id: Scalars['ID']['output'];
  academicYear?: Maybe<Scalars['String']['output']>;
  allocationReleased?: Maybe<Scalars['Boolean']['output']>;
  applications: Array<PanelApplication>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  entryYear?: Maybe<Scalars['String']['output']>;
  fundingRound: Funding_Round;
  fundingSource: Funding_Source;
  gsHelper: Scalars['String']['output'];
  lockFilter?: Maybe<Scalars['String']['output']>;
  /** @deprecated May use the member group. */
  panelChair?: Maybe<PanelMember>;
  panelMembers: Array<PanelMember>;
  panelNo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Do not use this field. */
  panelRound?: Maybe<Scalars['Float']['output']>;
  panelType: Funding_Panel;
  resultOptions?: Maybe<Array<Panel_Result>>;
  startDate: Scalars['DateTime']['output'];
  status: PanelStatus;
  tagOptions?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  /** @deprecated Do not use this field. */
  totalRound?: Maybe<Scalars['Float']['output']>;
  updatedBy: Scalars['String']['output'];
};

export type PanelRemarkInput = {
  applicationId: Scalars['String']['input'];
  declared?: InputMaybe<Scalars['Boolean']['input']>;
  netId?: InputMaybe<Scalars['String']['input']>;
  panelId: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  role: UserRole;
  scoresOverride?: InputMaybe<PanelUserUpafOverrideInput>;
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The panel result for Graduate School decision reference. */
export type PanelResult = {
  __typename?: 'PanelResult';
  /** The reference id of the panel. */
  panelReferenceId: Scalars['String']['output'];
  /** The result of the panel. Since there are multiple results, the result is a string. */
  panelResult: Scalars['String']['output'];
  /** The date the panel result was created. */
  updatedAt: Scalars['DateTime']['output'];
};

export type PanelReviewInput = {
  applicationId: Scalars['String']['input'];
  declared?: InputMaybe<Scalars['Boolean']['input']>;
  netId?: InputMaybe<Scalars['String']['input']>;
  panelId: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  scoresOverride?: InputMaybe<PanelUserUpafOverrideInput>;
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Type of panel */
export enum PanelStatus {
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  InProgress = 'IN_PROGRESS',
  Prepared = 'PREPARED'
}

export type PanelSummaryTableDepartment = {
  __typename?: 'PanelSummaryTableDepartment';
  abbr: Scalars['String']['output'];
  facultyAbbr: Scalars['String']['output'];
  facultyName: Scalars['String']['output'];
  filtered: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  studentshipYears?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PanelSummaryTableFaculty = {
  __typename?: 'PanelSummaryTableFaculty';
  abbr: Scalars['String']['output'];
  departments?: Maybe<Array<PanelSummaryTableDepartment>>;
  facultyAbbr: Scalars['String']['output'];
  facultyName: Scalars['String']['output'];
  filtered: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  studentshipYears?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PanelSummaryTablePartner = {
  __typename?: 'PanelSummaryTablePartner';
  filtered: Scalars['Float']['output'];
  partnerUniversity: Scalars['String']['output'];
  partnerUniversityName: Scalars['String']['output'];
  studentshipYears?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PanelSummaryTablePayload = {
  __typename?: 'PanelSummaryTablePayload';
  faculties?: Maybe<Array<PanelSummaryTableFaculty>>;
  partners?: Maybe<Array<PanelSummaryTablePartner>>;
  totalStudentshipYears?: Maybe<Scalars['Float']['output']>;
};

export type PanelUserRemark = {
  __typename?: 'PanelUserRemark';
  /** The NetID of the editor. */
  netId: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  role: UserRole;
};

export type PanelUserUpafOverride = {
  __typename?: 'PanelUserUPAFOverride';
  AE?: Maybe<Scalars['Float']['output']>;
  AEComment?: Maybe<Scalars['String']['output']>;
  CD?: Maybe<Scalars['Float']['output']>;
  CDComment?: Maybe<Scalars['String']['output']>;
  CI?: Maybe<Scalars['Float']['output']>;
  CIComment?: Maybe<Scalars['String']['output']>;
  LS?: Maybe<Scalars['Float']['output']>;
  LSComment?: Maybe<Scalars['String']['output']>;
  OS?: Maybe<Scalars['Float']['output']>;
  OSComment?: Maybe<Scalars['String']['output']>;
  RE?: Maybe<Scalars['Float']['output']>;
  REComment?: Maybe<Scalars['String']['output']>;
  RP?: Maybe<Scalars['Float']['output']>;
  RPComment?: Maybe<Scalars['String']['output']>;
  US?: Maybe<Scalars['Float']['output']>;
  USComment?: Maybe<Scalars['String']['output']>;
  funding: Funding_Source;
  totalScore?: Maybe<Scalars['Float']['output']>;
};

export type PanelUserUpafOverrideInput = {
  AE?: InputMaybe<Scalars['Float']['input']>;
  AEComment?: InputMaybe<Scalars['String']['input']>;
  CD?: InputMaybe<Scalars['Float']['input']>;
  CDComment?: InputMaybe<Scalars['String']['input']>;
  CI?: InputMaybe<Scalars['Float']['input']>;
  CIComment?: InputMaybe<Scalars['String']['input']>;
  LS?: InputMaybe<Scalars['Float']['input']>;
  LSComment?: InputMaybe<Scalars['String']['input']>;
  OS?: InputMaybe<Scalars['Float']['input']>;
  OSComment?: InputMaybe<Scalars['String']['input']>;
  RE?: InputMaybe<Scalars['Float']['input']>;
  REComment?: InputMaybe<Scalars['String']['input']>;
  RP?: InputMaybe<Scalars['Float']['input']>;
  RPComment?: InputMaybe<Scalars['String']['input']>;
  US?: InputMaybe<Scalars['Float']['input']>;
  USComment?: InputMaybe<Scalars['String']['input']>;
  funding: Funding_Source;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type Partner = {
  __typename?: 'Partner';
  isPolyUHomeUniversity?: Maybe<Scalars['Boolean']['output']>;
  /** For Dual Programme, this field is used to store the partner university application number. */
  partnerUniversityApplicationNo?: Maybe<Scalars['String']['output']>;
  physicalLocation?: Maybe<Scalars['String']['output']>;
  proposedChiefSupervisor?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use new fields instead. */
  studyPeriodFrom?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used. */
  studyPeriodFromAcademicSemester?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used. */
  studyPeriodFromAcademicYear?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use new fields instead. */
  studyPeriodTo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used. */
  studyPeriodToAcademicSemester?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used. */
  studyPeriodToAcademicYear?: Maybe<Scalars['String']['output']>;
  university?: Maybe<Scalars['String']['output']>;
  universityCategory?: Maybe<Partner_University_Category>;
};

export type PartnerFilter = {
  and?: InputMaybe<Array<PartnerFilter>>;
  isPolyUHomeUniversity: Scalars['Boolean']['input'];
  nor?: InputMaybe<Array<PartnerFilter>>;
  not?: InputMaybe<PartnerFilter>;
  or?: InputMaybe<Array<PartnerFilter>>;
  physicalLocation?: InputMaybe<StringFilter>;
  proposedChiefSupervisor?: InputMaybe<StringFilter>;
  studyPeriodFrom?: InputMaybe<StringFilter>;
  studyPeriodFromAcademicSemester?: InputMaybe<StringFilter>;
  studyPeriodFromAcademicYear?: InputMaybe<StringFilter>;
  studyPeriodTo?: InputMaybe<StringFilter>;
  studyPeriodToAcademicSemester?: InputMaybe<StringFilter>;
  studyPeriodToAcademicYear?: InputMaybe<StringFilter>;
  university?: InputMaybe<StringFilter>;
  universityCategory?: InputMaybe<StringFilter>;
};

export type PartnerInput = {
  isPolyUHomeUniversity?: InputMaybe<Scalars['Boolean']['input']>;
  partnerUniversityApplicationNo?: InputMaybe<Scalars['String']['input']>;
  physicalLocation?: InputMaybe<Scalars['String']['input']>;
  proposedChiefSupervisor?: InputMaybe<Scalars['String']['input']>;
  university: Scalars['String']['input'];
  universityCategory?: InputMaybe<Partner_University_Category>;
};

export type PartnerSort = {
  isPolyUHomeUniversity?: InputMaybe<Scalars['Float']['input']>;
  physicalLocation?: InputMaybe<Scalars['Float']['input']>;
  proposedChiefSupervisor?: InputMaybe<Sorting_Order>;
  university?: InputMaybe<Sorting_Order>;
  universityCategory?: InputMaybe<Scalars['Float']['input']>;
};

export type PaymentRecord = {
  __typename?: 'PaymentRecord';
  applicationId: Scalars['String']['output'];
  applicationNo: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  paymentAmount?: Maybe<Scalars['Float']['output']>;
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  paymentDeadline: Scalars['DateTime']['output'];
  paymentReference?: Maybe<Scalars['String']['output']>;
  paymentRemarks?: Maybe<Scalars['String']['output']>;
  paymentStatus: PaymentStatus;
  paymentType: Scalars['String']['output'];
  remarks?: Maybe<Array<Scalars['String']['output']>>;
  remindedAfterCreation: Scalars['Boolean']['output'];
  remindedBeforeDeadline: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type PaymentRecordFilter = {
  _id?: InputMaybe<Scalars['String']['input']>;
  applicationNo?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Payment_Type>;
};

export type PaymentRedirectPayload = {
  __typename?: 'PaymentRedirectPayload';
  hashKey: Scalars['String']['output'];
  refNo: Scalars['String']['output'];
};

/** The status of payment */
export enum PaymentStatus {
  Cancelled = 'CANCELLED',
  NotPaid = 'NOT_PAID',
  Paid = 'PAID',
  PastDue = 'PAST_DUE',
  Refunded = 'REFUNDED',
  Suspended = 'SUSPENDED',
  Waived = 'WAIVED',
  Withdrawn = 'WITHDRAWN'
}

export type Period = {
  __typename?: 'Period';
  from?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type PeriodFilter = {
  and?: InputMaybe<PeriodFilter>;
  from?: InputMaybe<DateFilter>;
  nor?: InputMaybe<PeriodFilter>;
  not?: InputMaybe<PeriodFilter>;
  or?: InputMaybe<PeriodFilter>;
  to?: InputMaybe<DateFilter>;
};

export type PeriodInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum PreliminaryCheckItem {
  DegreeBachelor = 'DEGREE_BACHELOR',
  DegreeMaster = 'DEGREE_MASTER',
  EnglishRequirement = 'ENGLISH_REQUIREMENT',
  HonourFirstOrAbove = 'HONOUR_FIRST_OR_ABOVE',
  HonourSecondOrAbove = 'HONOUR_SECOND_OR_ABOVE',
  RequirementMphil = 'REQUIREMENT_MPHIL',
  RequirementPhdFourOrEight = 'REQUIREMENT_PHD_FOUR_OR_EIGHT',
  RequirementPhdThreeOrSix = 'REQUIREMENT_PHD_THREE_OR_SIX',
  ResearchDegree = 'RESEARCH_DEGREE'
}

export type PreliminaryCheckModel = {
  __typename?: 'PreliminaryCheckModel';
  applicationId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  rules: Array<PreliminaryCheckRule>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum PreliminaryCheckResult {
  Fail = 'FAIL',
  Pass = 'PASS',
  Pending = 'PENDING'
}

export type PreliminaryCheckRule = {
  __typename?: 'PreliminaryCheckRule';
  checkRule?: Maybe<Array<CheckDetail>>;
  duration?: Maybe<Scalars['Int']['output']>;
  programmeLevel: Programme;
  result?: Maybe<OfferSuggestion>;
  version: Scalars['Int']['output'];
};

export type PreviewOfferLetterPayload = {
  __typename?: 'PreviewOfferLetterPayload';
  admissionSemYear1?: Maybe<Scalars['String']['output']>;
  applicationId?: Maybe<Scalars['String']['output']>;
  applicationNo?: Maybe<Scalars['String']['output']>;
  assisstantShip?: Maybe<Scalars['Boolean']['output']>;
  assisstantShipFullOrHalf?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Scalars['String']['output']>;
  conferenceGrant?: Maybe<Scalars['String']['output']>;
  creditRequirement?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
  departmentStaffEmail?: Maybe<Scalars['String']['output']>;
  departmentStaffName?: Maybe<Scalars['String']['output']>;
  departmentStaffNumber?: Maybe<Scalars['String']['output']>;
  fellowshipScheme?: Maybe<Scalars['String']['output']>;
  fellowshipSchemeFullname?: Maybe<Scalars['String']['output']>;
  firmOffer?: Maybe<Scalars['Boolean']['output']>;
  fulltimeLocal?: Maybe<Scalars['Boolean']['output']>;
  hasAssisstantship?: Maybe<Scalars['Boolean']['output']>;
  hasFellowship?: Maybe<Scalars['Boolean']['output']>;
  homeUniversity?: Maybe<Scalars['String']['output']>;
  hostUniversity?: Maybe<Scalars['String']['output']>;
  meetingConditionDeadline?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  monthlyStipend?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  normalPeriodOfStudy?: Maybe<Scalars['String']['output']>;
  partnerCoSupervisorName?: Maybe<Scalars['String']['output']>;
  partnerUniversity?: Maybe<Scalars['String']['output']>;
  programmeCodeSubcode?: Maybe<Scalars['String']['output']>;
  programmeName?: Maybe<Scalars['String']['output']>;
  proposedSupervisorName?: Maybe<Scalars['String']['output']>;
  reportingDutyDate?: Maybe<Scalars['String']['output']>;
  residenceRequirements?: Maybe<Scalars['String']['output']>;
  selfFinanced?: Maybe<Scalars['Boolean']['output']>;
  stipendMonths?: Maybe<Scalars['String']['output']>;
  studyCommencementDate?: Maybe<Scalars['String']['output']>;
  studyModeName?: Maybe<Scalars['String']['output']>;
  /** Should be D MMMM YYYY format */
  supersedeDate?: Maybe<Scalars['String']['output']>;
  /** Should be D MMMM YYYY format. Note there is currently a typo. */
  supersededate?: Maybe<Scalars['String']['output']>;
  tuitionFee?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type ProfessionalQualification = {
  __typename?: 'ProfessionalQualification';
  attainmentMeans?: Maybe<Scalars['String']['output']>;
  awardBodyName?: Maybe<Scalars['String']['output']>;
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  awardName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  otherAwardBodyName?: Maybe<Scalars['String']['output']>;
  professionField?: Maybe<Scalars['String']['output']>;
  professionalQualification?: Maybe<Scalars['String']['output']>;
  supportingDocuments?: Maybe<Array<FileType>>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProfessionalQualificationPayload = {
  __typename?: 'ProfessionalQualificationPayload';
  _id: Scalars['ID']['output'];
  attainmentMeans?: Maybe<Scalars['String']['output']>;
  awardBodyName?: Maybe<Scalars['String']['output']>;
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  awardName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  otherAwardBodyName?: Maybe<Scalars['String']['output']>;
  professionField?: Maybe<Scalars['String']['output']>;
  professionalQualification?: Maybe<Scalars['String']['output']>;
  supportingDocuments?: Maybe<Array<FileType>>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProfessionalQualificationSort = {
  attainmentMeans?: InputMaybe<Sorting_Order>;
  awardBodyName?: InputMaybe<Sorting_Order>;
  awardDate?: InputMaybe<Sorting_Order>;
  awardName?: InputMaybe<Sorting_Order>;
  country?: InputMaybe<Sorting_Order>;
  otherAwardBodyName?: InputMaybe<Sorting_Order>;
  professionField?: InputMaybe<Sorting_Order>;
  professionalQualification?: InputMaybe<Sorting_Order>;
};

export type ProgrammeChoice = {
  __typename?: 'ProgrammeChoice';
  acceptNoResearchIndicator?: Maybe<Scalars['Boolean']['output']>;
  /** For non-proposed or both rejected applications, store the new choice when it is accepted. */
  acceptedInvitation?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  department?: Maybe<Scalars['String']['output']>;
  entryYear?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  programme?: Maybe<Programme>;
  programmeType?: Maybe<Programme_Type>;
  proposedChiefSupervisor?: Maybe<Scalars['String']['output']>;
  /** For second choice of supervisor. */
  proposedChiefSupervisorBackup?: Maybe<Scalars['String']['output']>;
  /** For first choice of supervisor, to mark this invitation goes to the second choice. */
  rejectedByFirstChoice?: Maybe<Scalars['Boolean']['output']>;
  remarks?: Maybe<Array<Scalars['String']['output']>>;
  researchArea?: Maybe<Scalars['String']['output']>;
  /** For second choice of research area. */
  researchAreaBackup?: Maybe<Scalars['String']['output']>;
  studyMode?: Maybe<Programme_Choice_Study_Mode>;
  /** Store the supervisor invitations. */
  supervisorInvitations?: Maybe<Array<KvPair>>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProgrammeChoiceFilter = {
  _id?: InputMaybe<StringFilter>;
  acceptNoResearchIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<ProgrammeChoiceFilter>>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  department?: InputMaybe<DepartmentFilter>;
  entryYear?: InputMaybe<StringFilter>;
  nor?: InputMaybe<Array<ProgrammeChoiceFilter>>;
  not?: InputMaybe<ProgrammeChoiceFilter>;
  or?: InputMaybe<Array<ProgrammeChoiceFilter>>;
  partner?: InputMaybe<PartnerFilter>;
  programme?: InputMaybe<ProgrammeFilter>;
  programmeType?: InputMaybe<ProgrammeTypeFilter>;
  proposedChiefSupervisor?: InputMaybe<StringFilter>;
  proposedChiefSupervisorBackup?: InputMaybe<StringFilter>;
  rejectedByFirstChoice?: InputMaybe<Scalars['Boolean']['input']>;
  researchArea?: InputMaybe<StringFilter>;
  researchAreaBackup?: InputMaybe<StringFilter>;
  studyMode?: InputMaybe<ProgrammeChoiceStudyModeFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

export type ProgrammeChoiceMetadataPayload = {
  __typename?: 'ProgrammeChoiceMetadataPayload';
  countryList?: Maybe<Array<ValueLabelPair>>;
  /** New field for department list. */
  departmentList?: Maybe<Array<ValueLabelPair>>;
  departments: Array<DepartmentType>;
  disabilityTypeList?: Maybe<Array<ValueLabelPair>>;
  /** New field for programme list. */
  entryYearList?: Maybe<Array<ValueLabelPair>>;
  entryYears: Array<Scalars['String']['output']>;
  prgCollabPhdPartnerList?: Maybe<Array<ValueLabelPair>>;
  provinceList?: Maybe<Array<ValueLabelPair>>;
  residenceTypeList?: Maybe<Array<ValueLabelPair>>;
  rpgJoinPhdPartnerList?: Maybe<Array<ValueLabelPair>>;
  /** New field for programme list. */
  universityList?: Maybe<Array<ValueLabelPair>>;
};

export type ProgrammeChoicePayload = {
  __typename?: 'ProgrammeChoicePayload';
  _id?: Maybe<Scalars['ID']['output']>;
  acceptNoResearchIndicator?: Maybe<Scalars['Boolean']['output']>;
  /** For non-proposed or both rejected applications, store the new choice when it is accepted. */
  acceptedInvitation?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  department?: Maybe<Scalars['String']['output']>;
  entryYear?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  programme?: Maybe<Programme>;
  programmeType?: Maybe<Programme_Type>;
  proposedChiefSupervisor?: Maybe<Scalars['String']['output']>;
  /** For second choice of supervisor. */
  proposedChiefSupervisorBackup?: Maybe<Scalars['String']['output']>;
  /** For first choice of supervisor, to mark this invitation goes to the second choice. */
  rejectedByFirstChoice?: Maybe<Scalars['Boolean']['output']>;
  remarks?: Maybe<Array<Scalars['String']['output']>>;
  researchArea?: Maybe<Scalars['String']['output']>;
  /** For second choice of research area. */
  researchAreaBackup?: Maybe<Scalars['String']['output']>;
  studyMode?: Maybe<Programme_Choice_Study_Mode>;
  /** Store the supervisor invitations. */
  supervisorInvitations?: Maybe<Array<KvPair>>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProgrammeChoiceSort = {
  _id?: InputMaybe<Sorting_Order>;
  acceptNoResearchIndicator?: InputMaybe<Sorting_Order>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  department?: InputMaybe<Sorting_Order>;
  entryYear?: InputMaybe<Sorting_Order>;
  partner?: InputMaybe<PartnerSort>;
  programme?: InputMaybe<Sorting_Order>;
  programmeType?: InputMaybe<Sorting_Order>;
  proposedChiefSupervisor?: InputMaybe<Sorting_Order>;
  proposedChiefSupervisorBackup?: InputMaybe<Sorting_Order>;
  researchArea?: InputMaybe<Sorting_Order>;
  researchAreaBackup?: InputMaybe<Sorting_Order>;
  studyMode?: InputMaybe<Sorting_Order>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
};

export type ProgrammeChoiceStudyModeFilter = {
  eq?: InputMaybe<Programme_Choice_Study_Mode>;
  in?: InputMaybe<Array<Programme_Choice_Study_Mode>>;
  ne?: InputMaybe<Programme_Choice_Study_Mode>;
  nin?: InputMaybe<Array<Programme_Choice_Study_Mode>>;
};

export type ProgrammeCodeFilter = {
  department: Scalars['String']['input'];
  length?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Programme>;
  mode?: InputMaybe<Programme_Choice_Study_Mode>;
  programmeName?: InputMaybe<Scalars['String']['input']>;
};

export type ProgrammeCodePayload = {
  __typename?: 'ProgrammeCodePayload';
  programmeCode: Scalars['String']['output'];
  programmeSubCode?: Maybe<Scalars['String']['output']>;
};

export type ProgrammeFilter = {
  eq?: InputMaybe<Programme>;
  in?: InputMaybe<Array<Programme>>;
  ne?: InputMaybe<Programme>;
  nin?: InputMaybe<Array<Programme>>;
};

export type ProgrammeInfo = {
  __typename?: 'ProgrammeInfo';
  progLevel: Scalars['String']['output'];
  progMode: Array<Scalars['String']['output']>;
};

export type ProgrammePlan = {
  __typename?: 'ProgrammePlan';
  applicationDeadline: Scalars['DateTime']['output'];
  applicationStart?: Maybe<Scalars['DateTime']['output']>;
  entryYear: Scalars['String']['output'];
  programmes: Array<ProgrammeInfo>;
  status: ProgrammePlanStatus;
};

export enum ProgrammePlanStatus {
  Closed = 'Closed',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted'
}

export type ProgrammeTypeFilter = {
  eq?: InputMaybe<Programme_Type>;
  in?: InputMaybe<Array<Programme_Type>>;
  ne?: InputMaybe<Programme_Type>;
  nin?: InputMaybe<Array<Programme_Type>>;
};

export type ProjectDeclaration = {
  __typename?: 'ProjectDeclaration';
  /** @deprecated This account code will not be displayed anymore. */
  accountCode?: Maybe<Scalars['String']['output']>;
  confirmed: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
};

export type ProjectDeclarationInput = {
  accountCode?: InputMaybe<Scalars['String']['input']>;
  confirmed: Scalars['Boolean']['input'];
  content: Project_Declaration_Type;
};

export type ProjectInformation = {
  __typename?: 'ProjectInformation';
  PIDepartment?: Maybe<Scalars['String']['output']>;
  PIName?: Maybe<Scalars['String']['output']>;
  declarations?: Maybe<Array<ProjectDeclaration>>;
  justification?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type ProjectInformationInput = {
  PIDepartment?: InputMaybe<Scalars['String']['input']>;
  PIName?: InputMaybe<Scalars['String']['input']>;
  declarations?: InputMaybe<Array<ProjectDeclarationInput>>;
  justification?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Project_Role>;
};

export type ProposedSupervisorPayload = {
  __typename?: 'ProposedSupervisorPayload';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Publication = {
  __typename?: 'Publication';
  applicantRole?: Maybe<Applicant_Role>;
  citationInfo?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  issuePageArticelNo?: Maybe<Scalars['String']['output']>;
  peerReviewedIndicator?: Maybe<Scalars['Boolean']['output']>;
  publicationAuthors?: Maybe<Scalars['String']['output']>;
  publicationDate?: Maybe<Scalars['DateTime']['output']>;
  publicationName?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<PublicationStatus>;
  publicationTitle?: Maybe<Scalars['String']['output']>;
  publicationType?: Maybe<Scalars['String']['output']>;
  publicationUrl?: Maybe<Scalars['String']['output']>;
  specificRole?: Maybe<Scalars['String']['output']>;
  supportingDocuments?: Maybe<Array<FileType>>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type PublicationAssessmentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  publicationReferenceId: Scalars['String']['input'];
  publicationType?: InputMaybe<PublicationType>;
  type?: InputMaybe<PublicationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PublicationAssessmentType = {
  __typename?: 'PublicationAssessmentType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  publicationReferenceId: Scalars['String']['output'];
  publicationType?: Maybe<PublicationType>;
  type?: Maybe<PublicationType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type PublicationPayload = {
  __typename?: 'PublicationPayload';
  _id: Scalars['ID']['output'];
  applicantRole?: Maybe<Applicant_Role>;
  citationInfo?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  issuePageArticelNo?: Maybe<Scalars['String']['output']>;
  peerReviewedIndicator?: Maybe<Scalars['Boolean']['output']>;
  publicationAuthors?: Maybe<Scalars['String']['output']>;
  publicationDate?: Maybe<Scalars['DateTime']['output']>;
  publicationName?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<PublicationStatus>;
  publicationTitle?: Maybe<Scalars['String']['output']>;
  publicationType?: Maybe<Scalars['String']['output']>;
  publicationUrl?: Maybe<Scalars['String']['output']>;
  specificRole?: Maybe<Scalars['String']['output']>;
  supportingDocuments?: Maybe<Array<FileType>>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type PublicationSort = {
  _id?: InputMaybe<Sorting_Order>;
  applicantRole?: InputMaybe<Sorting_Order>;
  citationInfo?: InputMaybe<Sorting_Order>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  issuePageArticelNo?: InputMaybe<Sorting_Order>;
  peerReviewedIndicator?: InputMaybe<Sorting_Order>;
  publicationAuthors?: InputMaybe<Sorting_Order>;
  publicationDate?: InputMaybe<Sorting_Order>;
  publicationName?: InputMaybe<Sorting_Order>;
  publicationStatus?: InputMaybe<Sorting_Order>;
  publicationTitle?: InputMaybe<Sorting_Order>;
  publicationType?: InputMaybe<Sorting_Order>;
  publicationUrl?: InputMaybe<Sorting_Order>;
  specificRole?: InputMaybe<Sorting_Order>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
};

export enum PublicationStatus {
  InPress = 'IN_PRESS',
  Published = 'PUBLISHED',
  UnderReview = 'UNDER_REVIEW',
  WritingInProgress = 'WRITING_IN_PROGRESS'
}

export enum PublicationType {
  JcrQ1 = 'JCR_Q1',
  JcrQ1Equivalent = 'JCR_Q1_EQUIVALENT',
  JcrQ2 = 'JCR_Q2',
  JcrQ2Equivalent = 'JCR_Q2_EQUIVALENT',
  Na = 'NA'
}

export enum Qualification_Means {
  Coursework = 'COURSEWORK',
  CourseworkResearch = 'COURSEWORK_RESEARCH',
  Research = 'RESEARCH'
}

export enum Qualification_Status {
  CompletedWithoutAward = 'COMPLETED_WITHOUT_AWARD',
  Graduated = 'GRADUATED',
  WillCompleteStudyBefore = 'WILL_COMPLETE_STUDY_BEFORE',
  WillGraduateInAfter = 'WILL_GRADUATE_IN_AFTER',
  Withdraw = 'WITHDRAW'
}

export type QualificationCheckEnglishTest = {
  __typename?: 'QualificationCheckEnglishTest';
  /** @deprecated No not use this. */
  checkItems?: Maybe<Array<QualificationCheckResultItem>>;
  /** @deprecated No not use this. */
  languageQualificationResult?: Maybe<LanguageQualificationResult>;
  /** @deprecated No not use this. */
  otherTestResult?: Maybe<OtherTestResult>;
  qualificationId: Scalars['String']['output'];
  /** Added on Apr 30. */
  status: QualificationCheckStatus;
  /** @deprecated No not use this. */
  testDate?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated No not use this. */
  testName?: Maybe<Scalars['String']['output']>;
};

export type QualificationCheckEnglishTestInput = {
  checkItems?: InputMaybe<Array<QualificationCheckResultItemInput>>;
  languageQualificationResult?: InputMaybe<LanguageQualificationResultV1Input>;
  otherTestResult?: InputMaybe<OtherTestResultV1Input>;
  qualificationId: Scalars['String']['input'];
  /** Added on Apr 30. */
  status?: QualificationCheckStatus;
  testDate?: InputMaybe<Scalars['DateTime']['input']>;
  testName?: InputMaybe<Scalars['String']['input']>;
};

export type QualificationCheckModel = {
  __typename?: 'QualificationCheckModel';
  academicQualification?: Maybe<Array<QualificationCheckVerificationCode>>;
  applicationId: Scalars['ID']['output'];
  /** When this flag is explicitly true, do not enable the qualification check for AQs. */
  blockAcademicQualification?: Maybe<Scalars['Boolean']['output']>;
  /** When this flag is explicitly true, do not enable the language check for AQs. */
  blockEnglishAndOtherTest?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  displayStatus?: Maybe<QualificationCheckStatus>;
  /** @deprecated Do not use this anymore. */
  englishAndOtherTest?: Maybe<Array<QualificationCheckEnglishTest>>;
  languageQualification?: Maybe<Array<QualificationCheckEnglishTest>>;
  otherTestQualification?: Maybe<Array<QualificationCheckEnglishTest>>;
  remark?: Maybe<QualificationCheckRemark>;
  /** @deprecated [July 11] Use remark. */
  remarks?: Maybe<Array<QualificationCheckRemark>>;
  status?: Maybe<QualificationCheckStatus>;
  supportingDocuments?: Maybe<Array<FileType>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type QualificationCheckModelDoc = {
  __typename?: 'QualificationCheckModelDoc';
  _id: Scalars['String']['output'];
  academicQualification?: Maybe<Array<QualificationCheckVerificationCode>>;
  applicationId: Scalars['ID']['output'];
  /** When this flag is explicitly true, do not enable the qualification check for AQs. */
  blockAcademicQualification?: Maybe<Scalars['Boolean']['output']>;
  /** When this flag is explicitly true, do not enable the language check for AQs. */
  blockEnglishAndOtherTest?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  displayStatus?: Maybe<QualificationCheckStatus>;
  /** @deprecated Do not use this anymore. */
  englishAndOtherTest?: Maybe<Array<QualificationCheckEnglishTest>>;
  languageQualification?: Maybe<Array<QualificationCheckEnglishTest>>;
  otherTestQualification?: Maybe<Array<QualificationCheckEnglishTest>>;
  remark?: Maybe<QualificationCheckRemark>;
  /** @deprecated [July 11] Use remark. */
  remarks?: Maybe<Array<QualificationCheckRemark>>;
  status?: Maybe<QualificationCheckStatus>;
  supportingDocuments?: Maybe<Array<FileType>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type QualificationCheckRemark = {
  __typename?: 'QualificationCheckRemark';
  at?: Maybe<Scalars['DateTime']['output']>;
  by?: Maybe<Scalars['String']['output']>;
  remark: Scalars['String']['output'];
  /** @deprecated Removed internally. */
  supportingDocuments?: Maybe<Array<FileType>>;
  /** @deprecated Removed internally. */
  visibleToApplicant?: Maybe<Scalars['Boolean']['output']>;
};

export type QualificationCheckRemarkInput = {
  at?: InputMaybe<Scalars['DateTime']['input']>;
  by?: InputMaybe<Scalars['String']['input']>;
  remark: Scalars['String']['input'];
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
  visibleToApplicant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QualificationCheckResultItem = {
  __typename?: 'QualificationCheckResultItem';
  checkedAt?: Maybe<Scalars['DateTime']['output']>;
  checkedBy?: Maybe<Scalars['String']['output']>;
  /**
   * File for the qualification check result. This data should be prefetched from the application stages.
   * @deprecated DO NOT USE since the edit should be done in the application stages.
   */
  file?: Maybe<FileType>;
  item?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use status instead. */
  passed?: Maybe<Scalars['Boolean']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  status?: Maybe<QualificationCheckStatus>;
};

export type QualificationCheckResultItemInput = {
  checkedAt?: InputMaybe<Scalars['DateTime']['input']>;
  checkedBy?: InputMaybe<Scalars['String']['input']>;
  /** File for the qualification check result. This data should be prefetched from the application stages. */
  file?: InputMaybe<FileTypeInput>;
  item?: InputMaybe<Scalars['String']['input']>;
  passed?: InputMaybe<Scalars['Boolean']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<QualificationCheckStatus>;
};

export enum QualificationCheckStatus {
  Checking = 'CHECKING',
  Created = 'CREATED',
  Failed = 'FAILED',
  ModificationRequired = 'MODIFICATION_REQUIRED',
  Passed = 'PASSED',
  Waived = 'WAIVED'
}

export type QualificationCheckVerificationCode = {
  __typename?: 'QualificationCheckVerificationCode';
  /** Added on Apr 30. */
  academicCredentialCheckPassed?: Maybe<QualificationCheckStatus>;
  academicOnlineVerificationCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated No not use this. */
  awardClassification?: Maybe<Award_Classification>;
  /** @deprecated Do not check each item for now. */
  checkItems?: Maybe<Array<QualificationCheckResultItem>>;
  /** @deprecated No not use this. */
  country?: Maybe<Scalars['String']['output']>;
  /** Added on Apr 30. */
  degreeCertificationCheckPassed?: Maybe<QualificationCheckStatus>;
  /** @deprecated No not use this. */
  degreeLevel?: Maybe<Degree_Level>;
  degreeOnlineVerificationCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated No not use this. */
  from?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated No not use this. */
  institutionName?: Maybe<Scalars['String']['output']>;
  /** @deprecated No not use this. */
  isChineseMainlandExperience?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated This is a field to store the average mark. */
  markConversion?: Maybe<MarkConversion>;
  /** @deprecated No not use this. */
  officialClassRanking?: Maybe<Scalars['Float']['output']>;
  /** @deprecated No not use this. */
  officialMark?: Maybe<Scalars['String']['output']>;
  /** @deprecated No not use this. */
  outOfGpa?: Maybe<Scalars['Float']['output']>;
  /** @deprecated No not use this. */
  outOfRank?: Maybe<Scalars['Float']['output']>;
  /** @deprecated No not use this. */
  qualification?: Maybe<Scalars['String']['output']>;
  qualificationId: Scalars['String']['output'];
  /** Added on Apr 30. */
  status?: Maybe<QualificationCheckStatus>;
  /** @deprecated No not use this. */
  to?: Maybe<Scalars['DateTime']['output']>;
};

/** The data is fetched from backend for the first time. Afterwards, the frontend updates and override the data. */
export type QualificationCheckVerificationCodeInput = {
  /** Added on Apr 30. */
  academicCredentialCheckPassed?: InputMaybe<QualificationCheckStatus>;
  academicOnlineVerificationCode?: InputMaybe<Scalars['String']['input']>;
  awardClassification?: InputMaybe<Award_Classification>;
  checkItems?: InputMaybe<Array<QualificationCheckResultItemInput>>;
  country?: InputMaybe<Scalars['String']['input']>;
  /** Added on Apr 30. */
  degreeCertificationCheckPassed?: InputMaybe<QualificationCheckStatus>;
  degreeLevel?: InputMaybe<Degree_Level>;
  degreeOnlineVerificationCode?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  institutionName?: InputMaybe<Scalars['String']['input']>;
  isChineseMainlandExperience?: InputMaybe<Scalars['Boolean']['input']>;
  markConversion?: InputMaybe<MarkConversionV1Input>;
  officialClassRanking?: InputMaybe<Scalars['Float']['input']>;
  officialMark?: InputMaybe<Scalars['String']['input']>;
  outOfGpa?: InputMaybe<Scalars['Float']['input']>;
  outOfRank?: InputMaybe<Scalars['Float']['input']>;
  qualification?: InputMaybe<Scalars['String']['input']>;
  qualificationId: Scalars['String']['input'];
  /** Added on Apr 30. */
  status?: InputMaybe<QualificationCheckStatus>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QualificationMeansFilter = {
  eq?: InputMaybe<Qualification_Means>;
  in?: InputMaybe<Array<Qualification_Means>>;
  ne?: InputMaybe<Qualification_Means>;
  nin?: InputMaybe<Array<Qualification_Means>>;
};

export type QualificationStatusFilter = {
  eq?: InputMaybe<Qualification_Status>;
  in?: InputMaybe<Array<Qualification_Status>>;
  ne?: InputMaybe<Qualification_Status>;
  nin?: InputMaybe<Array<Qualification_Status>>;
};

export type Query = {
  __typename?: 'Query';
  HKPFSEmailDryRun: Scalars['JSONObject']['output'];
  _service: _Service;
  academicQualification: AcademicQualificationPayload;
  academicQualificationAssessment?: Maybe<Array<AcademicAssessmentType>>;
  academicReferee: AcademicRefereePayload;
  activity: ActivityPayload;
  additionalDocument: AdditionalDocumentPayload;
  adminQueryRefereeReports: Array<AdminQueryAcademicRefereeDto>;
  adminViewUPAFComments: Scalars['JSONObject']['output'];
  /** For AR, get all slots with all applications. */
  allSlotsApplications: Array<SlotsApplicationsListWithDatePayload>;
  applicant: ApplicantPayload;
  /** @deprecated Not recommended to use this endpoint for frontend. If there are list query requirement, use explicit internal endpoints. */
  applicants: Array<ApplicantPayload>;
  /** Get Application information by ID. When the user is an applicant, the user can only retrieve their own application. */
  application: ApplicationPayload;
  applicationDuplicateLog?: Maybe<ApplicationDuplicateLogPayload>;
  applicationLog: Array<ApplicationLogPayload>;
  applicationToDoList: ApplicationTodoListPayload;
  applicationViewsPaginated: ApplicationPartialViewPaginatorPayload;
  /** Get all applications. When the user is an applicant, the user can only retrieve their own application.When the user is an internal staff, the query is limited to the _id and email as well. */
  applications?: Maybe<Array<ApplicationPayload>>;
  applicationsPaginated: ApplicationPaginatorPayload;
  assessmentDetail?: Maybe<AssessmentPayload>;
  bonusAssessment?: Maybe<Array<BonusAssessmentType>>;
  /** Check the OVTS completion status for an application. */
  checkOVTSCompletion: Ovts_Completion_Status;
  /** For applicants, get all the time slot information for student card collection. */
  collectionTimeslots: StudentCardCollectionInfoPayload;
  configurationKeys: Array<Scalars['String']['output']>;
  /** Get the deferred offer for the given application. If no deferred offer is found, return null. */
  deferOffer?: Maybe<DeferOfferType>;
  /** Get all deferred offers with pagination options. */
  deferOffersPaginated: ApplicantPaginatorPayload;
  departmentInput?: Maybe<DepartmentInputAssessmentType>;
  departments: Array<DepartmentInfo>;
  /** [Dev only] This method will use front-end input. */
  devTuneLLMWithLocalInput: Scalars['JSONObject']['output'];
  drillRunNotificationConfiguration: Scalars['JSONObject']['output'];
  dsrcAdmission?: Maybe<DsrcAdmissionPayload>;
  dsrcDeclaration?: Maybe<DsrcDeclarationType>;
  dsrcInterestConflictApproval?: Maybe<DsrcInterestConflictApprovalPayload>;
  employment: EmploymentPayload;
  /** For applicants, get the entry year information like notification, welcome letter info according to the entry year */
  entryYearInformation?: Maybe<EntryYearPayload>;
  failedApplicationPaginated: FailedApplicationPaginatedPayload;
  /** Return the first degree name and rankings information. */
  firstDegreeAssessment: FirstDegreeAssessmentType;
  frcsbAssessment?: Maybe<FrcsbAssessmentPayload>;
  getApplicationLogStatusChangesJSONDiff: Array<Scalars['JSONObject']['output']>;
  getAssessmentOneOffProfileHtml: Scalars['JSONObject']['output'];
  /** Used for a user to query the list of applications that are assigned to the user. */
  getAssignedPanelApplications: Array<PanelApplicationPayload>;
  getBillingInformation: ApplicationFeeBillingInformation;
  getCoSupervisorInformation: CoSupervisorFormPayload;
  getConfig: ConfigurationPayload;
  getContactInformation: Scalars['JSONObject']['output'];
  getEmailTemplates: Array<EmailTemplateType>;
  getFundingSourceConfiguration: FundingSchemePayload;
  getGSAssigneeList: GsAssigneePayload;
  /** Bring system level notification to the user. */
  getNotifications: Array<NotificationInboxPayload>;
  getOVTSRedirectUrl: Scalars['String']['output'];
  getOneOffProfile: Scalars['JSONObject']['output'];
  getOneOffProfileHtml: Scalars['JSONObject']['output'];
  getPanelApplications: Array<PanelApplicationPayload>;
  getPaymentRedirect: PaymentRedirectPayload;
  getRefereeFormInfo: RefereeFormBasicInformationType;
  getRefereeFormStatus: AcademicRefereeFormStatus;
  getRefereeFormToken: Scalars['String']['output'];
  /** See the ordering of scholarship funding sources. */
  getScholarshipOrdering: Array<FundingOrderEntry>;
  getScholarshipOrderingStatus?: Maybe<Array<SubmitFundingOrder>>;
  groupScoresAndCalculate: Scalars['JSONObject']['output'];
  gsDecision?: Maybe<GsDecision>;
  gsDecisionPaginated: OfferDetailPaginatedPayload;
  hasConflictApplication?: Maybe<Scalars['String']['output']>;
  healthCheck: HealthCheckPayload;
  healthCheckWithAuth: HealthCheckPayload;
  hodDosAssessment?: Maybe<HodDosAssessment>;
  interviewPanelApplicationList: Array<ApplicationView>;
  languageQualification: LanguageQualificationPayload;
  lapsedList: LapsedApplicationPaginatedPayload;
  meetCondition?: Maybe<MeetConditionPayload>;
  meetConditionList: DrcApplicationPaginatedPayload;
  merit: MeritPayload;
  meritAssessment?: Maybe<Array<MeritAssessmentType>>;
  needStudentVisa: Scalars['Boolean']['output'];
  nomination: NominationPayload;
  nominations?: Maybe<Array<NominationPayload>>;
  nominationsPaginated: NominationPaginatorPayload;
  offer: OfferLetterPayload;
  offerList: OfferDetailPaginatedPayload;
  offers: Array<OfferModel>;
  /** Query the registration record. */
  onlineRegistration: OnlineRegistrationModel;
  panel?: Maybe<PanelModel>;
  panelSummaryTable: PanelSummaryTablePayload;
  panels: Array<PanelModelPayload>;
  paymentRecord: PaymentRecord;
  /** Get preliminary check result by applicationId, will return null when there is no previous generated result. */
  preliminaryCheck?: Maybe<PreliminaryCheckModel>;
  previewOfferFiles?: Maybe<PreviewOfferLetterPayload>;
  professionalQualification: ProfessionalQualificationPayload;
  programmeChoice: ProgrammeChoicePayload;
  programmeChoiceEntryYears: Array<EntryYearInfoPayload>;
  programmeChoiceMetadata: ProgrammeChoiceMetadataPayload;
  programmeCode: ProgrammeCodePayload;
  publication: PublicationPayload;
  publicationAssessment?: Maybe<Array<PublicationAssessmentType>>;
  qualificationApplicationList: ArQualificationPaginatedPayload;
  qualificationCheck?: Maybe<QualificationCheckModel>;
  /** Get the D/SRC scores after recomputed.  */
  queryDSRCGrading?: Maybe<DsrcGrading>;
  queryFORegistrationFeePayment: RegistrationFeePaymentPayload;
  queryFOResponseForApplicationFee: Scalars['JSONObject']['output'];
  /** Get the assign panel result upon initialization. Return will be in the form of [applicationId]: [assignee1 netId, assignee2 netId]. */
  queryPanelApplicationInitialAllocation: Scalars['JSON']['output'];
  queryRefereeForm: AcademicRefereeReportStatusPayload;
  /** Use applicationId to query the score information. */
  queryScholarshipNomination: ScholarshipNomination;
  registrationParticular: Array<RegistrationPayload>;
  releasedResults: Array<ReleaseResult>;
  researchAreas: Array<Scalars['String']['output']>;
  researchAreasAndSupervisors: ResearchAreasAndSupervisorsPayload;
  /** Return the publication assessment information. Will refresh new entries directly. */
  researchAssessment: Array<ResearchAssessmentType>;
  researchExperience: ResearchExperiencePayload;
  retrieveApplnFeePayment: Array<OutRetrieveApplnFeePayment>;
  retrieveRegistrationFeePayment: RegistrationFeePaymentPayload;
  retrieveSupersedeOfferParameters?: Maybe<Scalars['JSON']['output']>;
  /** This method will return the list of interview questions with authorization settings. */
  scholarshipNominationMetadata: ScholarshipNominationMetadataPayload;
  scholarshipPriority: FundingPriorityOutput;
  /** For applicants, get the selected time slot for student card collection. */
  selectedCollectionSlot?: Maybe<SelectedSlotPayload>;
  /** Query student particulars. All the information is about to send to SRS, and fetched from Applicant instantly. */
  studentParticular: StudentParticularPayload;
  training: TrainingPayload;
  transferStudentNoMapping: Scalars['String']['output'];
  visa?: Maybe<VisaModel>;
  visaApplicationList: ArVisaPaginatedPayload;
};


export type QueryHkpfsEmailDryRunArgs = {
  applicationNos: Array<Scalars['String']['input']>;
};


export type QueryAcademicQualificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAcademicQualificationAssessmentArgs = {
  filter: AssessmentFilter;
};


export type QueryAcademicRefereeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdditionalDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminQueryRefereeReportsArgs = {
  applicationNo: Scalars['String']['input'];
};


export type QueryAdminViewUpafCommentsArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryApplicantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApplicantsArgs = {
  filter?: InputMaybe<ApplicantFilter>;
  sort?: InputMaybe<ApplicantSort>;
};


export type QueryApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApplicationDuplicateLogArgs = {
  afterApplicationNo?: InputMaybe<Scalars['String']['input']>;
  beforeApplicationNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryApplicationLogArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryApplicationToDoListArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryApplicationViewsPaginatedArgs = {
  filter?: InputMaybe<ApplicationViewFilter>;
  paginator?: PaginatorOptions;
  sort?: InputMaybe<ApplicationViewSort>;
};


export type QueryApplicationsArgs = {
  filter?: InputMaybe<ApplicationFilter>;
  sort?: InputMaybe<ApplicationSort>;
};


export type QueryApplicationsPaginatedArgs = {
  filter?: InputMaybe<ApplicationFilter>;
  paginator?: PaginatorOptions;
  sort?: InputMaybe<ApplicationSort>;
};


export type QueryAssessmentDetailArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryBonusAssessmentArgs = {
  filter: AssessmentFilter;
};


export type QueryCheckOvtsCompletionArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryCollectionTimeslotsArgs = {
  entryYear?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDeferOfferArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryDeferOffersPaginatedArgs = {
  filter?: InputMaybe<OfferFilter>;
  paginator: PaginatorOptions;
  sort?: InputMaybe<OfferDetailSorter>;
};


export type QueryDepartmentInputArgs = {
  filter: AssessmentFilter;
};


export type QueryDepartmentsArgs = {
  entryYear: Scalars['String']['input'];
};


export type QueryDevTuneLlmWithLocalInputArgs = {
  comment: Scalars['String']['input'];
  questionNumber: Scalars['String']['input'];
};


export type QueryDrillRunNotificationConfigurationArgs = {
  department: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


export type QueryDsrcAdmissionArgs = {
  filter: AssessmentFilter;
};


export type QueryDsrcDeclarationArgs = {
  filter: AssessmentFilter;
};


export type QueryDsrcInterestConflictApprovalArgs = {
  input: AssessmentFilter;
};


export type QueryEmploymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEntryYearInformationArgs = {
  entryYear: Scalars['String']['input'];
};


export type QueryFailedApplicationPaginatedArgs = {
  filter?: InputMaybe<FailedApplicationListFilter>;
  paginator: PaginatorOptions;
  sort?: InputMaybe<ApplicationSort>;
};


export type QueryFirstDegreeAssessmentArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryFrcsbAssessmentArgs = {
  input: AssessmentFilter;
};


export type QueryGetApplicationLogStatusChangesJsonDiffArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryGetAssessmentOneOffProfileHtmlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAssignedPanelApplicationsArgs = {
  panelId: Scalars['ID']['input'];
};


export type QueryGetBillingInformationArgs = {
  id: Scalars['ID']['input'];
  type?: InputMaybe<Payment_Type>;
};


export type QueryGetCoSupervisorInformationArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetConfigArgs = {
  key: Scalars['String']['input'];
};


export type QueryGetContactInformationArgs = {
  departments: Array<Scalars['String']['input']>;
};


export type QueryGetFundingSourceConfigurationArgs = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOvtsRedirectUrlArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryGetOneOffProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOneOffProfileHtmlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPanelApplicationsArgs = {
  filter?: InputMaybe<PanelApplicationFilter>;
  panelId: Scalars['ID']['input'];
};


export type QueryGetPaymentRedirectArgs = {
  input: InDisplayPaymentInfo;
};


export type QueryGetRefereeFormInfoArgs = {
  formId: Scalars['ID']['input'];
};


export type QueryGetRefereeFormStatusArgs = {
  formId: Scalars['ID']['input'];
};


export type QueryGetRefereeFormTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetScholarshipOrderingArgs = {
  classification?: InputMaybe<Funding_Panel>;
  department?: InputMaybe<Scalars['String']['input']>;
  funding: Funding_Source;
  level?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGroupScoresAndCalculateArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryGsDecisionArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryGsDecisionPaginatedArgs = {
  filter?: InputMaybe<GsDecisionFilter>;
  paginator: PaginatorOptions;
  sort?: InputMaybe<OfferDetailSorter>;
};


export type QueryHasConflictApplicationArgs = {
  department: Scalars['String']['input'];
  entryYear: Scalars['String']['input'];
  programme: Programme;
};


export type QueryHodDosAssessmentArgs = {
  input: AssessmentFilter;
};


export type QueryInterviewPanelApplicationListArgs = {
  filter?: InputMaybe<InterviewPanelFilter>;
};


export type QueryLanguageQualificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLapsedListArgs = {
  filter: LapsedApplicationFilter;
  paginator?: InputMaybe<PaginatorOptions>;
  sort?: InputMaybe<OfferDetailSorter>;
};


export type QueryMeetConditionArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryMeetConditionListArgs = {
  filter: OfferedApplicationFilter;
  paginator?: InputMaybe<PaginatorOptions>;
  sort?: InputMaybe<OfferDetailSorter>;
};


export type QueryMeritArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMeritAssessmentArgs = {
  filter: AssessmentFilter;
};


export type QueryNeedStudentVisaArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryNominationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNominationsArgs = {
  filter?: InputMaybe<NominationFilter>;
  sort?: InputMaybe<NominationSort>;
};


export type QueryNominationsPaginatedArgs = {
  filter?: InputMaybe<NominationFilter>;
  paginator?: PaginatorOptions;
  sort?: InputMaybe<NominationSort>;
};


export type QueryOfferArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryOfferListArgs = {
  filter: OfferedApplicationFilter;
  paginator?: InputMaybe<PaginatorOptions>;
  sort?: InputMaybe<OfferDetailSorter>;
};


export type QueryOffersArgs = {
  filter: OfferFilter;
};


export type QueryOnlineRegistrationArgs = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPanelArgs = {
  filter?: InputMaybe<PanelBaseFilter>;
};


export type QueryPanelSummaryTableArgs = {
  filter?: InputMaybe<PanelApplicationFilter>;
  panelId: Scalars['ID']['input'];
};


export type QueryPanelsArgs = {
  filter?: InputMaybe<PanelFilter>;
};


export type QueryPaymentRecordArgs = {
  filter: PaymentRecordFilter;
};


export type QueryPreliminaryCheckArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryPreviewOfferFilesArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryProfessionalQualificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgrammeChoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgrammeCodeArgs = {
  input: ProgrammeCodeFilter;
};


export type QueryPublicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicationAssessmentArgs = {
  filter: AssessmentFilter;
};


export type QueryQualificationApplicationListArgs = {
  filter: OfferedApplicationFilter;
  paginator?: InputMaybe<PaginatorOptions>;
  sort?: InputMaybe<OfferDetailSorter>;
};


export type QueryQualificationCheckArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryQueryDsrcGradingArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryQueryFoRegistrationFeePaymentArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryQueryFoResponseForApplicationFeeArgs = {
  input: Array<InRetrieveApplnFeePayment>;
};


export type QueryQueryPanelApplicationInitialAllocationArgs = {
  input: AssignPanelInput;
};


export type QueryQueryRefereeFormArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryQueryScholarshipNominationArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryRegistrationParticularArgs = {
  filter?: InputMaybe<RegistrationParticularFilter>;
};


export type QueryReleasedResultsArgs = {
  filter: ReleaseResultFilter;
};


export type QueryResearchAreasArgs = {
  input: ResearchAreaFilter;
};


export type QueryResearchAreasAndSupervisorsArgs = {
  input: ResearchAreaFilter;
};


export type QueryResearchAssessmentArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryResearchExperienceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRetrieveApplnFeePaymentArgs = {
  input: Array<InRetrieveApplnFeePayment>;
};


export type QueryRetrieveRegistrationFeePaymentArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryScholarshipPriorityArgs = {
  input: FundingOrderUniqueKey;
};


export type QuerySelectedCollectionSlotArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryStudentParticularArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryTrainingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransferStudentNoMappingArgs = {
  entryYear?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVisaArgs = {
  filter: VisaBaseFilter;
};


export type QueryVisaApplicationListArgs = {
  filter: OfferedApplicationFilter;
  paginator?: InputMaybe<PaginatorOptions>;
  sort?: InputMaybe<OfferDetailSorter>;
};

export type RsfConfirmInput = {
  applicationIds: Array<Scalars['String']['input']>;
};

export type RsfConfirmationPayload = {
  __typename?: 'RSFConfirmationPayload';
  failedList: Array<Scalars['String']['output']>;
  needAlert: Scalars['Boolean']['output'];
};

export type RefereeCheckInput = {
  academicRefereeId: Scalars['String']['input'];
  selectedToHkpfs?: InputMaybe<Scalars['Boolean']['input']>;
  valid: Scalars['Boolean']['input'];
};

export type RefereeFormBasicInformationType = {
  __typename?: 'RefereeFormBasicInformationType';
  address?: Maybe<Scalars['String']['output']>;
  applicantFamilyName: Scalars['String']['output'];
  applicantGivenName: Scalars['String']['output'];
  department: Scalars['String']['output'];
  departmentForPDF: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  institution?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `applicantFamilyName` and `applicantGivenName` instead. */
  nameOfApplicant: Scalars['String']['output'];
  nameOfReferee?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  programme: Scalars['String']['output'];
  programmeForPDF: Scalars['String']['output'];
  refereeId: Scalars['String']['output'];
  researchArea: Scalars['String']['output'];
  telephoneNumber?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RefereeName = {
  __typename?: 'RefereeName';
  givenName?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type RefereeNameFilter = {
  and?: InputMaybe<Array<RefereeNameFilter>>;
  givenName?: InputMaybe<StringFilter>;
  nor?: InputMaybe<Array<RefereeNameFilter>>;
  not?: InputMaybe<RefereeNameFilter>;
  or?: InputMaybe<Array<RefereeNameFilter>>;
  surname?: InputMaybe<StringFilter>;
};

export type RefereeNameSort = {
  givenName?: InputMaybe<Sorting_Order>;
  surname?: InputMaybe<Sorting_Order>;
};

export type RefereeReportStatusPayload = {
  __typename?: 'RefereeReportStatusPayload';
  academicRefereeId: Scalars['String']['output'];
  canResendEmail: Scalars['Boolean']['output'];
  canUpdateEmail: Scalars['Boolean']['output'];
  deadline: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  lastSentDate?: Maybe<Scalars['DateTime']['output']>;
  nameOfReferee: Scalars['String']['output'];
  repliedAt?: Maybe<Scalars['DateTime']['output']>;
  status: AcademicRefereeFormStatus;
  title: Scalars['String']['output'];
};

export type RegistrationFeePaymentPayload = {
  __typename?: 'RegistrationFeePaymentPayload';
  resultCode: Scalars['String']['output'];
  resultName: Scalars['String']['output'];
  resultValue?: Maybe<Scalars['String']['output']>;
};

export type RegistrationParticularFilter = {
  applicationId?: InputMaybe<StringFilter>;
  department?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type RegistrationPayload = {
  __typename?: 'RegistrationPayload';
  _id: Scalars['ID']['output'];
  academicQualifications?: Maybe<Array<Scalars['ID']['output']>>;
  academicReferees?: Maybe<Array<Scalars['ID']['output']>>;
  activities?: Maybe<Array<Scalars['ID']['output']>>;
  additionalDocuments?: Maybe<Array<Scalars['ID']['output']>>;
  applicant: ApplicantPayload;
  applicantName: Scalars['String']['output'];
  applicationId: Scalars['ID']['output'];
  applicationNo: Scalars['String']['output'];
  /** For applicationNos that not fit the entry year, this field will store the original applicationNo before migration. */
  applicationNoPreMigration?: Maybe<Scalars['String']['output']>;
  applicationStatus: Application_Status;
  backTo?: Maybe<Array<Application_Status>>;
  /** @deprecated Use the one in programmeChoice */
  chiefSupervisor?: Maybe<Scalars['String']['output']>;
  commencementDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  currentMPhilStudentToPhD?: Maybe<Scalars['Boolean']['output']>;
  declaration?: Maybe<ApplicationDeclarationType>;
  /** @deprecated Use the one in programmeChoice */
  department?: Maybe<Scalars['String']['output']>;
  distinctiveScholarships?: Maybe<Array<DistinctiveScholarshipType>>;
  employments?: Maybe<Array<Scalars['ID']['output']>>;
  hkpfsInformation?: Maybe<HkpfsInformation>;
  /** @deprecated Use the one in programmeChoice instead. */
  invitingSupervisorList?: Maybe<Array<Scalars['String']['output']>>;
  languageQualifications?: Maybe<Array<Scalars['ID']['output']>>;
  merits?: Maybe<Array<Scalars['ID']['output']>>;
  otherTests?: Maybe<Array<Scalars['ID']['output']>>;
  professionalQualifications?: Maybe<Array<Scalars['ID']['output']>>;
  programmeChoice: ProgrammeChoicePayload;
  proofDocuments?: Maybe<Array<ApplicationProofFileType>>;
  publications?: Maybe<Array<Scalars['ID']['output']>>;
  /** @deprecated Use the one in programmeChoice instead. */
  rejectedBySupervisorFirstChoice?: Maybe<Scalars['Boolean']['output']>;
  remarks?: Maybe<Array<ApplicationRemarkType>>;
  researchExperiences?: Maybe<Array<Scalars['ID']['output']>>;
  status: Application_Status;
  studentNumber: Scalars['String']['output'];
  trainings?: Maybe<Array<Scalars['ID']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  virtualApplicationType?: Maybe<Scalars['String']['output']>;
};

export type ReleaseResult = {
  __typename?: 'ReleaseResult';
  applicationId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  releaseDate: Scalars['DateTime']['output'];
  released: Scalars['Boolean']['output'];
  releasedAt?: Maybe<Scalars['DateTime']['output']>;
  revoked?: Maybe<Scalars['Boolean']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  type: ReleaseResultType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ReleaseResultFilter = {
  applicationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  createdBy?: InputMaybe<StringFilter>;
  releaseDate?: InputMaybe<DateFilter>;
  released?: InputMaybe<Scalars['Boolean']['input']>;
  releasedAt?: InputMaybe<DateFilter>;
  revoked?: InputMaybe<Scalars['Boolean']['input']>;
  revokedAt?: InputMaybe<DateFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  updatedBy?: InputMaybe<StringFilter>;
};

export type ReleaseResultInput = {
  applicationIds: Array<Scalars['String']['input']>;
  releaseDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The result of the release */
export enum ReleaseResultType {
  Lapsed = 'LAPSED',
  Offered = 'OFFERED',
  Unsuccessful = 'UNSUCCESSFUL'
}

export type ReleaseSupersedeOfferInput = {
  applicationId: Scalars['String']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  updateNotes?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveApplicationItemInput = {
  academicQualificationId?: InputMaybe<Scalars['String']['input']>;
  academicRefereeId?: InputMaybe<Scalars['String']['input']>;
  activityId?: InputMaybe<Scalars['String']['input']>;
  additionalDocumentId?: InputMaybe<Scalars['String']['input']>;
  employmentId?: InputMaybe<Scalars['String']['input']>;
  languageQualificationId?: InputMaybe<Scalars['String']['input']>;
  meritId?: InputMaybe<Scalars['String']['input']>;
  otherTestId?: InputMaybe<Scalars['String']['input']>;
  professionalQualificationId?: InputMaybe<Scalars['String']['input']>;
  programmeChoiceId?: InputMaybe<Scalars['String']['input']>;
  proofDocumentId?: InputMaybe<Scalars['String']['input']>;
  publicationId?: InputMaybe<Scalars['String']['input']>;
  researchExperienceId?: InputMaybe<Scalars['String']['input']>;
  trainingId?: InputMaybe<Scalars['String']['input']>;
};

export type Requirements = {
  __typename?: 'Requirements';
  englishLanguageRequirements?: Maybe<Array<Maybe<EnglishLanguageRequirement>>>;
  generalEntranceRequirements: Array<GeneralEntranceRequirement>;
  justification?: Maybe<Scalars['String']['output']>;
  otherTestRequirements?: Maybe<Array<Maybe<OtherTestRequirement>>>;
};

export type RequirementsFilter = {
  and?: InputMaybe<Array<RequirementsFilter>>;
  englishLanguageRequirements?: InputMaybe<EnglishLanguageRequirementArrayFilter>;
  generalEntranceRequirements?: InputMaybe<GeneralEntranceRequirementArrayFilter>;
  nor?: InputMaybe<Array<RequirementsFilter>>;
  not?: InputMaybe<RequirementsFilter>;
  or?: InputMaybe<Array<RequirementsFilter>>;
};

export type RequirementsInput = {
  englishLanguageRequirements?: InputMaybe<Array<InputMaybe<EnglishLanguageRequirementInput>>>;
  generalEntranceRequirements?: InputMaybe<Array<InputMaybe<GeneralEntranceRequirementInput>>>;
  justification?: InputMaybe<Scalars['String']['input']>;
  otherTestRequirements?: InputMaybe<Array<InputMaybe<OtherTestRequirementInput>>>;
};

export type ResearchAreaFilter = {
  department: Scalars['String']['input'];
  entryYear: Scalars['String']['input'];
};

export type ResearchAreasAndSupervisorsPayload = {
  __typename?: 'ResearchAreasAndSupervisorsPayload';
  proposedSupervisors: Array<ProposedSupervisorPayload>;
  researchAreas: Array<Scalars['String']['output']>;
};

export type ResearchAssessmentType = {
  __typename?: 'ResearchAssessmentType';
  _id: Scalars['ID']['output'];
  applicantRole?: Maybe<Applicant_Role>;
  citationInfo?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  issuePageArticelNo?: Maybe<Scalars['String']['output']>;
  peerReviewedIndicator?: Maybe<Scalars['Boolean']['output']>;
  publicationAuthors?: Maybe<Scalars['String']['output']>;
  publicationDate?: Maybe<Scalars['DateTime']['output']>;
  publicationName?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<PublicationStatus>;
  publicationTitle?: Maybe<Scalars['String']['output']>;
  publicationType?: Maybe<Scalars['String']['output']>;
  publicationUrl?: Maybe<Scalars['String']['output']>;
  specificRole?: Maybe<Scalars['String']['output']>;
  supportingDocuments?: Maybe<Array<FileType>>;
  type?: Maybe<PublicationType>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ResearchExperience = {
  __typename?: 'ResearchExperience';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  expectedContribution?: Maybe<Scalars['String']['output']>;
  longTermCareerPlan?: Maybe<Scalars['String']['output']>;
  others?: Maybe<Scalars['String']['output']>;
  pastResearchExperience?: Maybe<Scalars['String']['output']>;
  proposedResearchPlan?: Maybe<Scalars['String']['output']>;
  proposedResearchTopic?: Maybe<Scalars['String']['output']>;
  reasons?: Maybe<Scalars['String']['output']>;
  researchProposal?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ResearchExperiencePayload = {
  __typename?: 'ResearchExperiencePayload';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  expectedContribution?: Maybe<Scalars['String']['output']>;
  longTermCareerPlan?: Maybe<Scalars['String']['output']>;
  others?: Maybe<Scalars['String']['output']>;
  pastResearchExperience?: Maybe<Scalars['String']['output']>;
  proposedResearchPlan?: Maybe<Scalars['String']['output']>;
  proposedResearchTopic?: Maybe<Scalars['String']['output']>;
  reasons?: Maybe<Scalars['String']['output']>;
  researchProposal?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ResearchExperienceSort = {
  _id?: InputMaybe<Sorting_Order>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  expectedContribution?: InputMaybe<Sorting_Order>;
  longTermCareerPlan?: InputMaybe<Sorting_Order>;
  others?: InputMaybe<Sorting_Order>;
  pastResearchExperience?: InputMaybe<Sorting_Order>;
  proposedResearchPlan?: InputMaybe<Sorting_Order>;
  proposedResearchTopic?: InputMaybe<Sorting_Order>;
  reasons?: InputMaybe<Sorting_Order>;
  researchProposal?: InputMaybe<Sorting_Order>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
};

export type RevokeResultInput = {
  applicationIds: Array<Scalars['String']['input']>;
};

export enum Sorting_Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Studu_Mode {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME'
}

export enum Supervisor_Type {
  ChiefSupervisor = 'CHIEF_SUPERVISOR',
  CoSupervisor = 'CO_SUPERVISOR',
  ExternalChiefDual = 'EXTERNAL_CHIEF_DUAL',
  ExternalChiefJoint = 'EXTERNAL_CHIEF_JOINT',
  /** @deprecated Use the programme type related ones instead. */
  ExternalChiefSupervisor = 'EXTERNAL_CHIEF_SUPERVISOR',
  ExternalCoSupervisor = 'EXTERNAL_CO_SUPERVISOR'
}

export type ScholarshipDimension = {
  __typename?: 'ScholarshipDimension';
  abbv: Scalars['String']['output'];
  dimensionName: Scalars['String']['output'];
  editableRoles: Array<UserRole>;
  group?: Maybe<Scalars['String']['output']>;
  scoringSystems?: Maybe<Array<Maybe<ScholarshipNominationScoringSystem>>>;
  totalScore: Scalars['Float']['output'];
};

export type ScholarshipDimensionalScore = {
  __typename?: 'ScholarshipDimensionalScore';
  dimension: Scalars['String']['output'];
  /** Possible flag for different scores in different scoring systems. */
  funding?: Maybe<Funding_Source>;
  hasOverrideReferenceScore?: Maybe<Scalars['Boolean']['output']>;
  hasOverrideScore?: Maybe<Scalars['Boolean']['output']>;
  history: Array<ScholarshipInterviewQuestionHistory>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  overrideScore?: Maybe<Scalars['Float']['output']>;
  referenceOverrideScore?: Maybe<Scalars['Float']['output']>;
  referenceRemark?: Maybe<Scalars['String']['output']>;
  referenceScore?: Maybe<Scalars['Float']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  scoringSystem: ScholarshipNominationScoringSystem;
  systemScore: Scalars['Float']['output'];
};

export type ScholarshipDimensionalScoreInput = {
  dimension: Scalars['String']['input'];
  /** Possible flag for different scores in different scoring systems. */
  funding?: InputMaybe<Funding_Source>;
  hasOverrideReferenceScore?: InputMaybe<Scalars['Boolean']['input']>;
  hasOverrideScore?: InputMaybe<Scalars['Boolean']['input']>;
  history?: Array<ScholarshipInterviewQuestionHistoryInput>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  overrideScore?: InputMaybe<Scalars['Float']['input']>;
  referenceOverrideScore?: InputMaybe<Scalars['Float']['input']>;
  referenceRemark?: InputMaybe<Scalars['String']['input']>;
  referenceScore?: InputMaybe<Scalars['Float']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  scoringSystem: ScholarshipNominationScoringSystem;
  systemScore?: Scalars['Float']['input'];
};

export type ScholarshipInterviewFundingScore = {
  __typename?: 'ScholarshipInterviewFundingScore';
  funding: Funding_Source;
  fundingAbbv?: Maybe<Scalars['String']['output']>;
  fundingName?: Maybe<Scalars['String']['output']>;
  outOfScore?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  systemScore?: Maybe<Scalars['Float']['output']>;
};

export type ScholarshipInterviewQuestion = {
  __typename?: 'ScholarshipInterviewQuestion';
  comment?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Array<ScholarshipInterviewQuestionHistory>>;
  questionNumber: Scalars['String']['output'];
};

export type ScholarshipInterviewQuestionHistory = {
  __typename?: 'ScholarshipInterviewQuestionHistory';
  candidate?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  justification?: Maybe<Scalars['String']['output']>;
  /** Only for overwrite history use. */
  prev?: Maybe<Scalars['String']['output']>;
  /** The previous snapshot of the question before the change. */
  snapshot: Scalars['String']['output'];
  userRole?: Maybe<UserRole>;
};

export type ScholarshipInterviewQuestionHistoryInput = {
  candidate?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  /** Only for overwrite history use. */
  prev?: InputMaybe<Scalars['String']['input']>;
  /** The previous snapshot of the question before the change. */
  snapshot: Scalars['String']['input'];
  userRole?: InputMaybe<UserRole>;
};

export type ScholarshipNomination = {
  __typename?: 'ScholarshipNomination';
  academicProgramme?: Maybe<Scalars['String']['output']>;
  /** The number of competitive studentships given. */
  competitiveStudentship?: Maybe<Scalars['Float']['output']>;
  /** Stores the aggregated result for each of the dimensions under scoring systems. */
  dimensionalScores?: Maybe<Array<ScholarshipDimensionalScore>>;
  eligibilityCheck?: Maybe<Array<Eligibility>>;
  endorsement?: Maybe<Scalars['Boolean']['output']>;
  firstDegreeAssessment?: Maybe<FirstDegreeAssessmentType>;
  justification?: Maybe<Scalars['String']['output']>;
  polishStatus?: Maybe<Scalars['String']['output']>;
  /** Stores the questions with the current comment, historical snapshots, and user information. */
  questions: Array<ScholarshipInterviewQuestion>;
  recommendation?: Maybe<Scalars['Boolean']['output']>;
  refereeReportChecked?: Maybe<Scalars['Boolean']['output']>;
  researchAssessments?: Maybe<Array<ResearchAssessmentType>>;
  /** Stores the aggregated result for each of the fundings. */
  scores?: Maybe<Array<ScholarshipInterviewFundingScore>>;
  /** Stores the aggregated result for each of the section (namely Strength and Distinctive Qualities ) under scoring systems. */
  sectionalScores?: Maybe<Array<ScholarshipDimensionalScore>>;
  /** Store the information of the Panel Type of the application. Namely Science and Humanity, which will lead to different criteria in computing AE marks. */
  subjectClassification?: Maybe<Funding_Panel>;
};

export type ScholarshipNominationFilter = {
  eligibilityCheck?: InputMaybe<EligibilityCheckArrayFilter>;
  polishStatus?: InputMaybe<StringFilter>;
};

export type ScholarshipNominationMetadataPayload = {
  __typename?: 'ScholarshipNominationMetadataPayload';
  academicExcellence: Array<ScholarshipQuestionSetting>;
  dimensions: Array<ScholarshipDimension>;
  distinctiveQuality: Array<ScholarshipQuestionSetting>;
  researchPotential: Array<ScholarshipQuestionSetting>;
  strengths: Array<ScholarshipQuestionSetting>;
};

export enum ScholarshipNominationScoringSystem {
  Hkpfs = 'HKPFS',
  Upaf = 'UPAF',
  UpafWithoutDistinctive = 'UPAF_WITHOUT_DISTINCTIVE'
}

export type ScholarshipQuestionSetting = {
  __typename?: 'ScholarshipQuestionSetting';
  criteria: Scalars['String']['output'];
  lengthLimit?: Maybe<Scalars['Float']['output']>;
  /** Use this number to update question comment. */
  mappedNumber: Scalars['String']['output'];
  questionExample?: Maybe<Scalars['String']['output']>;
  questionNumber: Scalars['String']['output'];
  questionTitle: Scalars['String']['output'];
  validUserRoles?: Maybe<Array<Maybe<UserRole>>>;
};

export type SelectedSlotPayload = {
  __typename?: 'SelectedSlotPayload';
  date: Scalars['String']['output'];
  /** AM or PM */
  meridiem: Scalars['String']['output'];
  slotId: Scalars['String']['output'];
  slotName: Scalars['String']['output'];
};

export type SelectionQuestionType = {
  __typename?: 'SelectionQuestionType';
  number: Scalars['Float']['output'];
  option: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type SelectionQuestionTypeInput = {
  number: Scalars['Float']['input'];
  option: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

/** The payload containing required applicant related information */
export type SlotApplicationsPayload = {
  __typename?: 'SlotApplicationsPayload';
  applicationId: Scalars['String']['output'];
  applicationNo: Scalars['String']['output'];
  studentName: ApplicantName;
  studentNumber: Scalars['String']['output'];
};

/** The payload containing all slots and all applications */
export type SlotsApplicationsListPayload = {
  __typename?: 'SlotsApplicationsListPayload';
  applications: Array<SlotApplicationsPayload>;
  /** AM or PM */
  meridiem: Scalars['String']['output'];
  quotaLimit: Scalars['Float']['output'];
  slotId: Scalars['String']['output'];
  slotName: Scalars['String']['output'];
};

/** The payload containing all slots and all applications with dates */
export type SlotsApplicationsListWithDatePayload = {
  __typename?: 'SlotsApplicationsListWithDatePayload';
  date: Scalars['String']['output'];
  slots: Array<SlotsApplicationsListPayload>;
};

export type StringArrayFilter = {
  all?: InputMaybe<Array<Scalars['String']['input']>>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

export type StringFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  options?: InputMaybe<Scalars['String']['input']>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type StudentCardCollectionEntry = {
  __typename?: 'StudentCardCollectionEntry';
  applicationIds: Array<Scalars['String']['output']>;
  /** The ID of the timeslot, in format of YYYY-MM-DD#number, e.g., 2022-01-01#1 */
  slotId: Scalars['String']['output'];
};

export type StudentCardCollectionInfoPayload = {
  __typename?: 'StudentCardCollectionInfoPayload';
  closedNotes?: Maybe<Scalars['String']['output']>;
  days?: Maybe<Array<StudentCardCollectionSlotsPayload>>;
};

export type StudentCardCollectionSlotPayload = {
  __typename?: 'StudentCardCollectionSlotPayload';
  /** Indicate if the slot is available for booking. */
  isAvailable: Scalars['Boolean']['output'];
  /** Indicate if the slot is expired for booking. When current time exceeds the slot's ending time, this flag will be true. */
  isExpired: Scalars['Boolean']['output'];
  /** The meridiem of the timeslot, either AM or PM. */
  meridiem: Scalars['String']['output'];
  /** The ID of the timeslot, in format of YYYY-MM-DD#number. For example, 2022-01-01#1 */
  slotId: Scalars['String']['output'];
  /** The name of the timeslot, in format of HH:mm-HH:mm. For example, 09:00-09:30 */
  slotName: Scalars['String']['output'];
};

export type StudentCardCollectionSlotsPayload = {
  __typename?: 'StudentCardCollectionSlotsPayload';
  /** Indicate if all slots are expired for booking. */
  allExpired: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  slots: Array<StudentCardCollectionSlotPayload>;
};

export type StudentParticularPayload = {
  __typename?: 'StudentParticularPayload';
  /** Use Application.HKPFSInformation to determine the value. */
  HKPFSInd?: Maybe<Scalars['String']['output']>;
  addressCountryRegion: Scalars['String']['output'];
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  applicationId: Scalars['ID']['output'];
  applicationNumber: Scalars['String']['output'];
  /** Use SRS information to determine the value. */
  collabPhDProgPartnerInstitution?: Maybe<Scalars['String']['output']>;
  contactPhoneAreaCode?: Maybe<Scalars['String']['output']>;
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  dateOfBirth: Scalars['DateTime']['output'];
  disabilityDetail?: Maybe<Scalars['String']['output']>;
  disabilityType?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  identityNumber: Scalars['String']['output'];
  identityType: Scalars['String']['output'];
  /** Use SRS information to determine the value. */
  jointPhDProgPartnerInstitution?: Maybe<Scalars['String']['output']>;
  localIndicator: Scalars['String']['output'];
  mobileAreaCode?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  nameInChinese?: Maybe<Scalars['String']['output']>;
  nameInEnglishGivenName: Scalars['String']['output'];
  nameInEnglishSurname: Scalars['String']['output'];
  nationalityCountryRegion: Scalars['String']['output'];
  nationalityProvince?: Maybe<Scalars['String']['output']>;
  offeredToSemester: Scalars['String']['output'];
  offeredToYear: Scalars['String']['output'];
  photoFile?: Maybe<FileType>;
  programmeCode: Scalars['String']['output'];
  programmeSubcode: Scalars['String']['output'];
  residenceType: Scalars['String']['output'];
  /** When this field presents, the applicant has finished the process and should be disabled from calling. */
  studentNumber?: Maybe<Scalars['String']['output']>;
};

export type StudyModeFilter = {
  eq?: InputMaybe<Studu_Mode>;
  in?: InputMaybe<Array<Studu_Mode>>;
  ne?: InputMaybe<Studu_Mode>;
  nin?: InputMaybe<Array<Studu_Mode>>;
};

export type Submission = {
  __typename?: 'Submission';
  /** The status should be redirected to HoD/DoS assessment if needed */
  backTo?: Maybe<Application_Status>;
  lastSubmissionTime?: Maybe<Scalars['DateTime']['output']>;
  submissionCount: Scalars['Float']['output'];
  submitted: Scalars['Boolean']['output'];
  upafSubmissionIndicator?: Maybe<Upaf_Submission_Indicator>;
};

export type SubmissionFilter = {
  and?: InputMaybe<Array<SubmissionFilter>>;
  lastSubmissionTime?: InputMaybe<DateFilter>;
  nor?: InputMaybe<Array<SubmissionFilter>>;
  not?: InputMaybe<SubmissionFilter>;
  or?: InputMaybe<Array<SubmissionFilter>>;
  submissionCount?: InputMaybe<NumberFilter>;
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmissionInput = {
  lastSubmissionTime: Scalars['DateTime']['input'];
  submissionCount: Scalars['Float']['input'];
  submitted: Scalars['Boolean']['input'];
};

export type SubmissionToGs = {
  __typename?: 'SubmissionToGS';
  at: Scalars['DateTime']['output'];
  from: Scalars['String']['output'];
};

export type SubmitFundingOrder = {
  __typename?: 'SubmitFundingOrder';
  academicYear?: Maybe<Scalars['String']['output']>;
  /** @deprecated Do not use this field as requirement change on Dec 5. */
  classification?: Maybe<Funding_Panel>;
  funding: Funding_Source;
  fundingOrderLevel?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Funding_Round>;
  submitted: Scalars['Boolean']['output'];
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  unitName?: Maybe<Scalars['String']['output']>;
};

export type SubmitFundingOrderInput = {
  academicYear?: InputMaybe<Scalars['String']['input']>;
  classification?: InputMaybe<Funding_Panel>;
  funding: Funding_Source;
  fundingOrderLevel?: InputMaybe<Scalars['Float']['input']>;
  round?: InputMaybe<Funding_Round>;
  submitted?: Scalars['Boolean']['input'];
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  unitName?: InputMaybe<Scalars['String']['input']>;
};

export type SupersedeOfferInput = {
  applicationId: Scalars['String']['input'];
  /** For conditional offers, a new meet condition deadline. */
  meetConditionDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  /** For superseded offer in terms of deferring, the supersede date should be manually provided. */
  supersedeOfferDate?: InputMaybe<Scalars['String']['input']>;
  targetEntryYear?: InputMaybe<Scalars['String']['input']>;
};

export type SupervisorInput = {
  coSupervisorDeclarationRemark?: InputMaybe<Scalars['String']['input']>;
  confirmedAsCoSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  department: Scalars['String']['input'];
  email: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  institution: Scalars['String']['input'];
  isDoRPgS?: InputMaybe<Scalars['Boolean']['input']>;
  isDrcChair?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: Scalars['String']['input'];
  netId?: InputMaybe<Scalars['String']['input']>;
  previousSuccessfulSupervision: Scalars['Boolean']['input'];
  surname: Scalars['String']['input'];
  telephoneNumber?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: Supervisor_Type;
};

export type SupervisorTypeFilter = {
  eq?: InputMaybe<Supervisor_Type>;
  in?: InputMaybe<Array<Supervisor_Type>>;
  ne?: InputMaybe<Supervisor_Type>;
  nin?: InputMaybe<Array<Supervisor_Type>>;
};

export type Supervisors = {
  __typename?: 'Supervisors';
  coSupervisorDeclarationRemark?: Maybe<Scalars['String']['output']>;
  confirmedAsCoSupervisor?: Maybe<Scalars['Boolean']['output']>;
  department: Scalars['String']['output'];
  email: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  institution: Scalars['String']['output'];
  isDoRPgS?: Maybe<Scalars['Boolean']['output']>;
  isDrcChair?: Maybe<Scalars['Boolean']['output']>;
  jobTitle: Scalars['String']['output'];
  netId?: Maybe<Scalars['String']['output']>;
  previousSuccessfulSupervision: Scalars['Boolean']['output'];
  surname: Scalars['String']['output'];
  telephoneNumber?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Supervisor_Type;
};

export type SupervisorsArrayFilter = {
  all?: InputMaybe<Array<SupervisorsArrayFilter>>;
  elemMatch?: InputMaybe<SupervisorsFilter>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

export type SupervisorsFilter = {
  and?: InputMaybe<Array<SupervisorsFilter>>;
  confirmedAsCoSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  givenName?: InputMaybe<StringFilter>;
  institution?: InputMaybe<StringFilter>;
  isDrcChair?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<StringFilter>;
  netId?: InputMaybe<StringFilter>;
  nor?: InputMaybe<Array<SupervisorsFilter>>;
  not?: InputMaybe<SupervisorsFilter>;
  or?: InputMaybe<Array<SupervisorsFilter>>;
  previousSuccessfulSupervison?: InputMaybe<Scalars['Boolean']['input']>;
  surname?: InputMaybe<StringFilter>;
  telephoneNumber?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<SupervisorTypeFilter>;
};

export type SupervisorsInput = {
  department: Scalars['String']['input'];
  email: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  institution: Scalars['String']['input'];
  isDoRPgS?: InputMaybe<Scalars['Boolean']['input']>;
  isDrcChair?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: Scalars['String']['input'];
  netId?: InputMaybe<Scalars['String']['input']>;
  previousSuccessfulSupervision: Scalars['Boolean']['input'];
  surname: Scalars['String']['input'];
  telephoneNumber?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: Supervisor_Type;
};

export type SupervisorsSort = {
  department?: InputMaybe<Sorting_Order>;
  email?: InputMaybe<Sorting_Order>;
  givenName?: InputMaybe<Sorting_Order>;
  institution?: InputMaybe<Sorting_Order>;
  isDrcChair?: InputMaybe<Sorting_Order>;
  jobTitle?: InputMaybe<Sorting_Order>;
  netId?: InputMaybe<Sorting_Order>;
  previousSuccessfulSupervision?: InputMaybe<Sorting_Order>;
  surname?: InputMaybe<Sorting_Order>;
  telephoneNumber?: InputMaybe<Sorting_Order>;
  title?: InputMaybe<Sorting_Order>;
  type?: InputMaybe<Sorting_Order>;
};

export enum Todo_List {
  AcademicReferee = 'ACADEMIC_REFEREE',
  ApplicationFee = 'APPLICATION_FEE',
  MeetCondition = 'MEET_CONDITION',
  OfferAcceptance = 'OFFER_ACCEPTANCE',
  QualificationCheck = 'QUALIFICATION_CHECK',
  Registration = 'REGISTRATION',
  RegistrationFee = 'REGISTRATION_FEE',
  RejectionInformation = 'REJECTION_INFORMATION',
  ReturnRemarks = 'RETURN_REMARKS',
  SupervisorInvitation = 'SUPERVISOR_INVITATION',
  TuitionFee = 'TUITION_FEE',
  VisaApplication = 'VISA_APPLICATION'
}

export type Training = {
  __typename?: 'Training';
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  from: Scalars['DateTime']['output'];
  organisationName: Scalars['String']['output'];
  presentTrainingIndicator: Scalars['Boolean']['output'];
  programmeName: Scalars['String']['output'];
  supportingDocuments?: Maybe<Array<FileType>>;
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type TrainingPayload = {
  __typename?: 'TrainingPayload';
  _id: Scalars['ID']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  from: Scalars['DateTime']['output'];
  organisationName: Scalars['String']['output'];
  presentTrainingIndicator: Scalars['Boolean']['output'];
  programmeName: Scalars['String']['output'];
  supportingDocuments?: Maybe<Array<FileType>>;
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type TrainingSort = {
  _id?: InputMaybe<Sorting_Order>;
  country?: InputMaybe<Sorting_Order>;
  createdAt?: InputMaybe<Sorting_Order>;
  createdBy?: InputMaybe<Sorting_Order>;
  from?: InputMaybe<Sorting_Order>;
  organisationName?: InputMaybe<Sorting_Order>;
  presentTrainingIndicator?: InputMaybe<Sorting_Order>;
  programmeName?: InputMaybe<Sorting_Order>;
  to?: InputMaybe<Sorting_Order>;
  updatedAt?: InputMaybe<Sorting_Order>;
  updatedBy?: InputMaybe<Sorting_Order>;
};

/** The type of tuition assistantship */
export enum TuitionAssistantship {
  Full = 'FULL',
  Half = 'HALF',
  Na = 'NA'
}

export enum Upaf_Submission_Indicator {
  CompetitiveRound_1 = 'COMPETITIVE_ROUND_1',
  CompetitiveRound_2 = 'COMPETITIVE_ROUND_2',
  NonCompetitive = 'NON_COMPETITIVE',
  Other = 'OTHER'
}

export type UniversityRanking = {
  __typename?: 'UniversityRanking';
  originalRanking?: Maybe<Scalars['String']['output']>;
  rankingSystem: UniversityRankingSystemType;
  universityLevel?: Maybe<Scalars['Float']['output']>;
};

export enum UniversityRankingSystemType {
  Arwu = 'ARWU',
  Qs = 'QS',
  The = 'THE'
}

export type UpdateAcademicQualificationAssessmentInput = {
  academicQualificationAssessmentInputs?: InputMaybe<Array<AcademicAssessmentTypeInput>>;
  applicationId?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAcademicQualificationInput = {
  academicCredentialIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  academicOnlineVerificationCode?: InputMaybe<Scalars['String']['input']>;
  awardClassification?: InputMaybe<Award_Classification>;
  awardDate?: InputMaybe<Scalars['DateTime']['input']>;
  certificates?: InputMaybe<Array<FileTypeInput>>;
  classRankProofs?: InputMaybe<Array<FileTypeInput>>;
  convertGPARuleId?: InputMaybe<Scalars['String']['input']>;
  currentStudyYear?: InputMaybe<Scalars['Float']['input']>;
  degreeCertIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  degreeLevel?: InputMaybe<Degree_Level>;
  degreeOnlineVerificationCode?: InputMaybe<Scalars['String']['input']>;
  expectUpdateDate?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  gpaIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  institution?: InputMaybe<UpdateInstitutionInput>;
  instructionMedium?: InputMaybe<Scalars['String']['input']>;
  markConversion?: InputMaybe<UpdateMarkConversionInput>;
  markExplanations?: InputMaybe<Array<FileTypeInput>>;
  marks?: InputMaybe<Array<UpdateMarkInput>>;
  officialClassRanking?: InputMaybe<Scalars['Float']['input']>;
  officialMark?: InputMaybe<Scalars['String']['input']>;
  otherDocuments?: InputMaybe<Array<FileTypeInput>>;
  otherInstructionMedium?: InputMaybe<Scalars['String']['input']>;
  outOfGpa?: InputMaybe<Scalars['Float']['input']>;
  outOfRank?: InputMaybe<Scalars['Float']['input']>;
  presentIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  programmeName?: InputMaybe<Scalars['String']['input']>;
  qualificationMeans?: InputMaybe<Qualification_Means>;
  qualificationStatus?: InputMaybe<Qualification_Status>;
  rankIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  studyField?: InputMaybe<Scalars['String']['input']>;
  studyMode?: InputMaybe<Studu_Mode>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  transcripts?: InputMaybe<Array<FileTypeInput>>;
  withdrawDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateAcademicRefereeForReportInput = {
  applicationId: Scalars['String']['input'];
  applicationRefereeId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type UpdateAcademicRefereeInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  institution?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<UpdateNameInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberAreaCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumberCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumberNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateActivityInput = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  majorResponsibilities?: InputMaybe<Scalars['String']['input']>;
  organisationName?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  presentActivityIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  volunteerMode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdditionalDocumentInput = {
  documentType?: InputMaybe<Scalars['String']['input']>;
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
};

export type UpdateApplicantInput = {
  PIDeclaration?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  /** The city of the address. Required. ADD Jun 4. */
  addressCountryRegion?: InputMaybe<Scalars['String']['input']>;
  /** The first line of the address. Required. ADD Jun 4. */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the address. Optional. ADD Jun 4. */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The third line of the address. Optional. ADD Jun 4. */
  addressLine3?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  disabilitySpecial?: InputMaybe<UpdateDisabilitySpecialInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  identity?: InputMaybe<UpdateIdentityInput>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<UpdateApplicantNameInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  telephoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateApplicantNameInput = {
  chineseName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateApplicationDeclarationInput = {
  applicationId: Scalars['ID']['input'];
  confirmation?: InputMaybe<Scalars['Boolean']['input']>;
  engagement?: InputMaybe<Scalars['Boolean']['input']>;
  informationAccuracy?: InputMaybe<Scalars['Boolean']['input']>;
  personalType?: InputMaybe<Personal_Info_Type>;
};

export type UpdateApplicationItemInput = {
  academicQualification?: InputMaybe<UpdateAcademicQualificationInput>;
  academicReferee?: InputMaybe<UpdateAcademicRefereeInput>;
  activity?: InputMaybe<UpdateActivityInput>;
  additionalDocument?: InputMaybe<UpdateAdditionalDocumentInput>;
  declaration?: InputMaybe<UpdateApplicationDeclarationInput>;
  distinctiveScholarships?: InputMaybe<UpdateDistinctiveScholarshipInput>;
  employment?: InputMaybe<UpdateEmploymentInput>;
  hkpfsInformation?: InputMaybe<UpdateHkpfsInformationInput>;
  languageQualification?: InputMaybe<UpdateLanguageQualificationInput>;
  merit?: InputMaybe<UpdateMeritInput>;
  otherTest?: InputMaybe<UpdateOtherTestInput>;
  professionalQualification?: InputMaybe<UpdateProfessionalQualificationInput>;
  programmeChoice?: InputMaybe<UpdateProgrammeChoiceInput>;
  proofDocuments?: InputMaybe<UpdateApplicationProofInput>;
  publication?: InputMaybe<UpdatePublicationInput>;
  researchExperience?: InputMaybe<UpdateResearchExperienceInput>;
  training?: InputMaybe<UpdateTrainingInput>;
};

export type UpdateApplicationProofInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentType: Proof_Document_Type;
  remark?: InputMaybe<Scalars['String']['input']>;
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
};

export type UpdateBonusAssessmentInput = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  bonusAssessments?: InputMaybe<Array<BonusAssessmentInput>>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDsrcAdmissionInput = {
  applicationId?: InputMaybe<Scalars['ID']['input']>;
  conditionDetails?: InputMaybe<Array<ConditionDetailInput>>;
  conditionFulfillingDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  conditions?: InputMaybe<Array<EntranceRequirement>>;
  confirmationChairInTeam?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationDoRPgSInTeam?: InputMaybe<Scalars['Boolean']['input']>;
  contactDepartmentPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactDepartmentPersonName?: InputMaybe<Scalars['String']['input']>;
  contactDepartmentPersonPhone?: InputMaybe<Scalars['String']['input']>;
  departmentAccountCode?: InputMaybe<Scalars['String']['input']>;
  dsrcDecision?: InputMaybe<Dsrc_Decision_Type>;
  entranceRequirement?: InputMaybe<EntranceRequirement>;
  entranceRequirementOthers?: InputMaybe<Scalars['String']['input']>;
  entranceRequirementWaive?: InputMaybe<Scalars['Boolean']['input']>;
  isFirmOffer?: InputMaybe<Scalars['Boolean']['input']>;
  monthsToProvide?: InputMaybe<Scalars['Int']['input']>;
  offerApproval?: InputMaybe<Scalars['Boolean']['input']>;
  plagiarismCheck?: InputMaybe<Scalars['Boolean']['input']>;
  plagiarismFound?: InputMaybe<Scalars['Boolean']['input']>;
  rejectionRemarks?: InputMaybe<Scalars['String']['input']>;
  /** Use remarks instead. */
  remarkUponReturn?: InputMaybe<Scalars['String']['input']>;
  /** The reason for the decision. */
  remarks?: InputMaybe<Scalars['String']['input']>;
  stipendApproval?: InputMaybe<Scalars['Boolean']['input']>;
  tuitionAssistantship?: InputMaybe<Scalars['Boolean']['input']>;
  tuitionAssistantshipType?: InputMaybe<TuitionAssistantship>;
  tuitionFeeAccountCode?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDepartmentInputInput = {
  applicationId: Scalars['ID']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  departmentInputs?: InputMaybe<DepartmentInputAssessmentInput>;
};

export type UpdateDisabilitySpecialInput = {
  disabilitySpecialDetail?: InputMaybe<Scalars['String']['input']>;
  /** The type of disability special educational needs. Removed the enum. MOD Jun 4. */
  disabilitySpecialType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDistinctiveScholarshipInput = {
  applicationId: Scalars['String']['input'];
  distinctiveScholarships?: InputMaybe<Array<DistinctiveScholarshipTypeInput>>;
};

export type UpdateDsrcDeclarationInput = {
  PIofGRF?: InputMaybe<Scalars['Boolean']['input']>;
  PIofStem?: InputMaybe<Scalars['Boolean']['input']>;
  accuracy?: InputMaybe<Scalars['Boolean']['input']>;
  applicationId?: InputMaybe<Scalars['String']['input']>;
  departmentStipend?: InputMaybe<Scalars['Boolean']['input']>;
  proof?: InputMaybe<Scalars['Boolean']['input']>;
  recommendThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  stipendBudgetReserved?: InputMaybe<Scalars['Boolean']['input']>;
  support?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDsrcInterestConflictApprovalInput = {
  applicationId: Scalars['String']['input'];
  approveDoRPgSInTeam?: InputMaybe<Dsrc_Interest_Conflict_Decision>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmploymentInput = {
  employmentField?: InputMaybe<Scalars['String']['input']>;
  employmentMode?: InputMaybe<EmploymentMode>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  majorResponsibilities?: InputMaybe<Scalars['String']['input']>;
  organisationName?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  presentEmploymentIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateFrcsbAssessmentInput = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  approveDsrcChairInTeam?: InputMaybe<FrcsbDecision>;
  approveWaivingEntranceRequirements?: InputMaybe<FrcsbDecision>;
  remarkToDSRC?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFundingOrderEntryInput = {
  academicYear?: InputMaybe<Scalars['String']['input']>;
  classification?: InputMaybe<Funding_Panel>;
  entries: Array<FundingOrderEntryInput>;
  funding: Funding_Source;
  fundingOrderLevel?: InputMaybe<Scalars['Float']['input']>;
  round?: InputMaybe<Funding_Round>;
  unitName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGsDecisionInput = {
  allItemChecked?: InputMaybe<Scalars['Boolean']['input']>;
  applicationId: Scalars['String']['input'];
  decision?: InputMaybe<GsDecisionResult>;
  emailCheck?: InputMaybe<OfferEmailCheckInput>;
  fileChecks?: InputMaybe<Array<FileCheckInput>>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  remarksToSupervisor?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHkpfsInformationInput = {
  HKPFSReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  applicationId: Scalars['String']['input'];
  isHKPFSApplicant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateHodDosAssessmentInput = {
  applicationId: Scalars['String']['input'];
  competitiveFund?: InputMaybe<BaseHoDApprovalInput>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  decision?: InputMaybe<Hod_Dos_Decision>;
  dualPhD?: InputMaybe<BaseHoDApprovalInput>;
  externalGrantOrDEA?: InputMaybe<BaseHoDApprovalInput>;
  nonSTEMOrNonSHS?: InputMaybe<NonStemOrNonShsInput>;
  rejectRemark?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  returnRemark?: InputMaybe<Scalars['String']['input']>;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  valid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateIdentityInput = {
  identityDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  identityDocumentType?: InputMaybe<Identity_Document_Type>;
  identityType?: InputMaybe<Scalars['String']['input']>;
  isLocal?: InputMaybe<Scalars['Boolean']['input']>;
  needStudentVisa?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateInstitutionInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInterviewPanelInput = {
  applicationId: Scalars['String']['input'];
  externalInterviewPanel?: InputMaybe<Array<Scalars['String']['input']>>;
  interviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  interviewLanguage?: InputMaybe<Interview_Panel_Language>;
  interviewMode?: InputMaybe<Interview_Panel_Mode>;
  /** The panel has agreed that the panel chair submit the form. */
  panelAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  panelMembers?: InputMaybe<Array<PanelMemberInput>>;
};

export type UpdateLanguageQualificationInput = {
  expectedResultUpdateDate?: InputMaybe<Scalars['DateTime']['input']>;
  needEnglishTest?: InputMaybe<Scalars['Boolean']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<UpdateLanguageQualificationResultInput>;
  resultAnnouncedIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
  testDate?: InputMaybe<Scalars['DateTime']['input']>;
  testType?: InputMaybe<Language_Qualification_Test_Type>;
};

export type UpdateLanguageQualificationResultInput = {
  listening?: InputMaybe<Scalars['Float']['input']>;
  overall?: InputMaybe<Scalars['Float']['input']>;
  reading?: InputMaybe<Scalars['Float']['input']>;
  resultReceiptDate?: InputMaybe<Scalars['DateTime']['input']>;
  speaking?: InputMaybe<Scalars['Float']['input']>;
  writing?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateMarkConversionInput = {
  convertedMark?: InputMaybe<Scalars['String']['input']>;
  digitToLetterRule?: InputMaybe<MarkStubInput>;
  letterToGPARule?: InputMaybe<MarkStubInput>;
};

export type UpdateMarkInput = {
  course?: InputMaybe<Scalars['String']['input']>;
  credit?: InputMaybe<Scalars['Float']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMeritAssessmentInput = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  meritAssessments?: InputMaybe<Array<MeritAssessmentInput>>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMeritInput = {
  attainmentMeans?: InputMaybe<Scalars['String']['input']>;
  awardBodyName?: InputMaybe<Scalars['String']['input']>;
  awardDate?: InputMaybe<Scalars['DateTime']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  meritName?: InputMaybe<Scalars['String']['input']>;
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
};

export type UpdateNameInput = {
  givenName?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNominationInput = {
  admission?: InputMaybe<AdmissionInput>;
  applicant?: InputMaybe<Scalars['ID']['input']>;
  declarations?: InputMaybe<Array<DeclarationInput>>;
  funding?: InputMaybe<FundingInput>;
  fundings?: InputMaybe<Array<FundingInput>>;
  remarks?: InputMaybe<Array<Scalars['String']['input']>>;
  supervisors?: InputMaybe<Array<SupervisorsInput>>;
};

export type UpdateNominationSubmissionStatusInput = {
  rejected?: InputMaybe<Scalars['Boolean']['input']>;
  submitted: Scalars['Boolean']['input'];
};

export type UpdateOtherTestInput = {
  expectedResultUpdateDate?: InputMaybe<Scalars['DateTime']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<UpdateOtherTestResultInput>;
  resultAnnouncedIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
  testDate?: InputMaybe<Scalars['DateTime']['input']>;
  testType?: InputMaybe<Other_Test_Test_Type>;
};

export type UpdateOtherTestResultInput = {
  analyticalWritingPercentile?: InputMaybe<Scalars['Float']['input']>;
  analyticalWritingScore?: InputMaybe<Scalars['Float']['input']>;
  dataInsightsPercentile?: InputMaybe<Scalars['Float']['input']>;
  dataInsightsScore?: InputMaybe<Scalars['Float']['input']>;
  integratedReasoningPercentile?: InputMaybe<Scalars['Float']['input']>;
  integratedReasoningScore?: InputMaybe<Scalars['Float']['input']>;
  quantitativePercentile?: InputMaybe<Scalars['Float']['input']>;
  quantitativeScore?: InputMaybe<Scalars['Float']['input']>;
  resultReceiptDate?: InputMaybe<Scalars['DateTime']['input']>;
  totalPercentile?: InputMaybe<Scalars['Float']['input']>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
  verbalPercentile?: InputMaybe<Scalars['Float']['input']>;
  verbalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePanelApplicationItemInput = {
  applicationId: Scalars['String']['input'];
  entries?: InputMaybe<Array<PanelApplicationColumnEntry>>;
  isTop10?: InputMaybe<Scalars['Boolean']['input']>;
  panelId: Scalars['String']['input'];
  panelResult?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdatePanelInput = {
  _id: Scalars['String']['input'];
  applicationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  entryYear?: InputMaybe<Scalars['String']['input']>;
  fundingSource?: InputMaybe<Funding_Source>;
  /** Net ID of the GS Helper */
  gsHelper?: InputMaybe<Scalars['String']['input']>;
  /** Net ID of the Chair */
  panelChair?: InputMaybe<PanelMemberInput>;
  /** Net IDs of the Panel Members */
  panelMembers?: InputMaybe<Array<PanelMemberInput>>;
  panelRound?: InputMaybe<Scalars['Float']['input']>;
  panelType?: InputMaybe<Funding_Panel>;
  resultOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<PanelStatus>;
  tagOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalRound?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePartnerInput = {
  isPolyUHomeUniversity?: InputMaybe<Scalars['Boolean']['input']>;
  partnerUniversityApplicationNo?: InputMaybe<Scalars['String']['input']>;
  physicalLocation?: InputMaybe<Scalars['String']['input']>;
  proposedChiefSupervisor?: InputMaybe<Scalars['String']['input']>;
  university?: InputMaybe<Scalars['String']['input']>;
  universityCategory?: InputMaybe<Partner_University_Category>;
};

export type UpdateProfessionalQualificationInput = {
  attainmentMeans?: InputMaybe<Scalars['String']['input']>;
  awardBodyName?: InputMaybe<Scalars['String']['input']>;
  awardDate?: InputMaybe<Scalars['DateTime']['input']>;
  awardName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  otherAwardBodyName?: InputMaybe<Scalars['String']['input']>;
  professionField?: InputMaybe<Scalars['String']['input']>;
  professionalQualification?: InputMaybe<Scalars['String']['input']>;
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
};

export type UpdateProgrammeChoiceInput = {
  acceptNoResearchIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  entryYear?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<UpdatePartnerInput>;
  programme?: InputMaybe<Programme>;
  programmeType?: InputMaybe<Programme_Type>;
  proposedChiefSupervisor?: InputMaybe<Scalars['String']['input']>;
  proposedChiefSupervisorBackup?: InputMaybe<Scalars['String']['input']>;
  researchArea?: InputMaybe<Scalars['String']['input']>;
  researchAreaBackup?: InputMaybe<Scalars['String']['input']>;
  studyMode?: InputMaybe<Programme_Choice_Study_Mode>;
};

export type UpdatePublicationAssessmentInput = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  publicationAssessments?: InputMaybe<Array<PublicationAssessmentInput>>;
  type?: InputMaybe<PublicationType>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePublicationInput = {
  applicantRole?: InputMaybe<Applicant_Role>;
  citationInfo?: InputMaybe<Scalars['String']['input']>;
  issuePageArticelNo?: InputMaybe<Scalars['String']['input']>;
  peerReviewedIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  publicationAuthors?: InputMaybe<Scalars['String']['input']>;
  publicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  publicationName?: InputMaybe<Scalars['String']['input']>;
  publicationStatus?: InputMaybe<PublicationStatus>;
  publicationTitle?: InputMaybe<Scalars['String']['input']>;
  publicationType?: InputMaybe<Scalars['String']['input']>;
  publicationUrl?: InputMaybe<Scalars['String']['input']>;
  specificRole?: InputMaybe<Scalars['String']['input']>;
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
};

export type UpdateQualificationCheckInput = {
  academicQualification?: InputMaybe<Array<QualificationCheckVerificationCodeInput>>;
  applicationId: Scalars['ID']['input'];
  englishAndOtherTest?: InputMaybe<Array<QualificationCheckEnglishTestInput>>;
  languageQualification?: InputMaybe<Array<QualificationCheckEnglishTestInput>>;
  otherTestQualification?: InputMaybe<Array<QualificationCheckEnglishTestInput>>;
  /** Add new remarks only. This will be appended to the original result. */
  remark?: InputMaybe<QualificationCheckRemarkInput>;
  /** Add new remarks only. This will be appended to the original result. */
  remarks?: InputMaybe<Array<QualificationCheckRemarkInput>>;
  status?: InputMaybe<QualificationCheckStatus>;
  /** Upload internal file. DO NOT upload qualifcation file here. */
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
};

export type UpdateRefFormInput = {
  academicRefereeId: Scalars['ID']['input'];
  applicationId: Scalars['ID']['input'];
  formId: Scalars['ID']['input'];
  formQuestions?: InputMaybe<Array<FormQuestionTypeInput>>;
  recommendation?: InputMaybe<Overall_Recommendation>;
  selectionQuestions?: InputMaybe<Array<SelectionQuestionTypeInput>>;
  submit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRegistrationDeadlineInput = {
  applicationId: Scalars['String']['input'];
  deadline: Scalars['DateTime']['input'];
};

export type UpdateResearchAssessmentInput = {
  applicationId: Scalars['String']['input'];
  researchAssessments?: InputMaybe<Array<UpdateResearchAssessmentItemInput>>;
};

export type UpdateResearchAssessmentItemInput = {
  _id: Scalars['String']['input'];
  type?: InputMaybe<PublicationType>;
};

export type UpdateResearchExperienceInput = {
  expectedContribution?: InputMaybe<Scalars['String']['input']>;
  longTermCareerPlan?: InputMaybe<Scalars['String']['input']>;
  others?: InputMaybe<Scalars['String']['input']>;
  pastResearchExperience?: InputMaybe<Scalars['String']['input']>;
  proposedResearchPlan?: InputMaybe<Scalars['String']['input']>;
  proposedResearchTopic?: InputMaybe<Scalars['String']['input']>;
  reasons?: InputMaybe<Scalars['String']['input']>;
  researchProposal?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScholarshipDimensionInput = {
  applicationId: Scalars['String']['input'];
  candidate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Possible flag for different scores in different scoring systems. */
  funding?: InputMaybe<Funding_Source>;
  justification: Scalars['String']['input'];
  scores: Array<ScholarshipDimensionalScoreInput>;
};

export type UpdateScholarshipQuestionInput = {
  applicationId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  questionNumber: Scalars['String']['input'];
};

export type UpdateTrainingInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  organisationName?: InputMaybe<Scalars['String']['input']>;
  presentTrainingIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  programmeName?: InputMaybe<Scalars['String']['input']>;
  supportingDocuments?: InputMaybe<Array<FileTypeInput>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateVisaApplicationInput = {
  applicationId: Scalars['String']['input'];
  applicationReceivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Entry slip document. Should be updated by the applicant. */
  entrySlipDocument?: InputMaybe<FileTypeInput>;
  immdOfficerInCharge?: InputMaybe<Scalars['String']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  /** Remarks. Should be updated by AR. */
  remarks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Visa application status. Should be updated by AR. */
  status?: InputMaybe<VisaStatus>;
  submissionDateToImmd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Visa document. Should be updated by the applicant. */
  visaDocument?: InputMaybe<FileTypeInput>;
  visaExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  visaLabelApprovalDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum UserRole {
  Applicant = 'APPLICANT',
  Ar = 'AR',
  DoRpgS = 'DO_RPG_S',
  DoRpgSGo = 'DO_RPG_S_GO',
  DoRpgSSec = 'DO_RPG_S_SEC',
  Drc = 'DRC',
  DrcChair = 'DRC_CHAIR',
  DrcGo = 'DRC_GO',
  DrcSec = 'DRC_SEC',
  Frc = 'FRC',
  FrcChair = 'FRC_CHAIR',
  FrcGo = 'FRC_GO',
  FrcSec = 'FRC_SEC',
  Gs = 'GS',
  Gsb = 'GSB',
  GsbChair = 'GSB_CHAIR',
  GsbGo = 'GSB_GO',
  GsbSec = 'GSB_SEC',
  HodDos = 'HOD_DOS',
  HodDosSec = 'HOD_DOS_SEC',
  InterviewPanel = 'INTERVIEW_PANEL',
  Panel = 'PANEL',
  Supervisor = 'SUPERVISOR',
  Vpri = 'VPRI'
}

export type ValueLabelPair = {
  __typename?: 'ValueLabelPair';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** The type of virtual application */
export enum VirtualApplicationType {
  Hkpfs = 'HKPFS'
}

export type VisaBaseFilter = {
  applicationId?: InputMaybe<ObjectIdFilter>;
  referenceId?: InputMaybe<StringFilter>;
};

export type VisaBatchUploadInput = {
  records: Array<VisaFileUploadRecordInput>;
};

export type VisaFileUploadRecord = {
  __typename?: 'VisaFileUploadRecord';
  applicationNo: Scalars['String']['output'];
  applicationReceivedDate?: Maybe<Scalars['DateTime']['output']>;
  immdOfficerInCharge?: Maybe<Scalars['String']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  submissionDateToImmd?: Maybe<Scalars['DateTime']['output']>;
  visaLabelApprovalDate?: Maybe<Scalars['DateTime']['output']>;
};

export type VisaFileUploadRecordInput = {
  applicationNo: Scalars['String']['input'];
  applicationReceivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  immdOfficerInCharge?: InputMaybe<Scalars['String']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  submissionDateToImmd?: InputMaybe<Scalars['DateTime']['input']>;
  visaLabelApprovalDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VisaModel = {
  __typename?: 'VisaModel';
  applicationDate: Scalars['DateTime']['output'];
  applicationId: Scalars['ID']['output'];
  applicationNo: Scalars['String']['output'];
  applicationReceivedDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  entrySlipDocument?: Maybe<FileType>;
  immdOfficerInCharge?: Maybe<Scalars['String']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  remarks: Array<VisaRemark>;
  status: VisaStatus;
  submissionDateToImmd?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  visaDocument?: Maybe<FileType>;
  visaExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  visaLabelApprovalDate?: Maybe<Scalars['DateTime']['output']>;
};

export type VisaModelDoc = {
  __typename?: 'VisaModelDoc';
  _id: Scalars['String']['output'];
  applicationDate: Scalars['DateTime']['output'];
  applicationId: Scalars['ID']['output'];
  applicationNo: Scalars['String']['output'];
  applicationReceivedDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  entrySlipDocument?: Maybe<FileType>;
  immdOfficerInCharge?: Maybe<Scalars['String']['output']>;
  referenceNo?: Maybe<Scalars['String']['output']>;
  remarks: Array<VisaRemark>;
  status: VisaStatus;
  submissionDateToImmd?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  visaDocument?: Maybe<FileType>;
  visaExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  visaLabelApprovalDate?: Maybe<Scalars['DateTime']['output']>;
};

export type VisaRemark = {
  __typename?: 'VisaRemark';
  at?: Maybe<Scalars['DateTime']['output']>;
  by?: Maybe<Scalars['String']['output']>;
  remark: Scalars['String']['output'];
};

export type VisaRemarkInput = {
  at?: InputMaybe<Scalars['DateTime']['input']>;
  by?: InputMaybe<Scalars['String']['input']>;
  remark: Scalars['String']['input'];
};

export enum VisaStatus {
  Activated = 'ACTIVATED',
  ApplicationReceived = 'APPLICATION_RECEIVED',
  Approved = 'APPROVED',
  PendingApplicationSubmission = 'PENDING_APPLICATION_SUBMISSION',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED'
}

export type WorldSubjectRanking = {
  __typename?: 'WorldSubjectRanking';
  range: WorldSubjectRankingRangeType;
  ranking: UniversityRankingSystemType;
  score: Scalars['Int']['output'];
  subjectArea: Scalars['String']['output'];
  universityLevel: Scalars['Int']['output'];
};

export type WorldSubjectRankingInput = {
  range: WorldSubjectRankingRangeType;
  ranking: UniversityRankingSystemType;
  score: Scalars['Int']['input'];
  subjectArea: Scalars['String']['input'];
  universityLevel: Scalars['Int']['input'];
};

export enum WorldSubjectRankingRangeType {
  Top_1To_20 = 'TOP_1_TO_20',
  Top_21To_50 = 'TOP_21_TO_50',
  Top_51To_75 = 'TOP_51_TO_75',
  Top_76To_100 = 'TOP_76_TO_100',
  Top_101To_150 = 'TOP_101_TO_150'
}

export type WorldUniversityRanking = {
  __typename?: 'WorldUniversityRanking';
  notExactNumber: Scalars['Boolean']['output'];
  range: WorldUniversityRankingRangeType;
  rankNumber: Scalars['Int']['output'];
  ranking: UniversityRankingSystemType;
  score: Scalars['Int']['output'];
  universityLevel: Scalars['Int']['output'];
};

export type WorldUniversityRankingInput = {
  notExactNumber: Scalars['Boolean']['input'];
  range: WorldUniversityRankingRangeType;
  rankNumber: Scalars['Int']['input'];
  ranking: UniversityRankingSystemType;
  score: Scalars['Int']['input'];
  universityLevel: Scalars['Int']['input'];
};

export enum WorldUniversityRankingRangeType {
  Top_1To_50 = 'TOP_1_TO_50',
  Top_51To_100 = 'TOP_51_TO_100',
  Top_101To_200 = 'TOP_101_TO_200',
  Top_201To_300 = 'TOP_201_TO_300',
  Top_301To_400 = 'TOP_301_TO_400',
  Top_401To_500 = 'TOP_401_TO_500'
}

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export type DegreeLevelFilter = {
  eq?: InputMaybe<Degree_Level>;
  in?: InputMaybe<Array<Degree_Level>>;
  ne?: InputMaybe<Degree_Level>;
  nin?: InputMaybe<Array<Degree_Level>>;
};

export type IdentityDocumentTypeFilter = {
  eq?: InputMaybe<Identity_Document_Type>;
  in?: InputMaybe<Array<Identity_Document_Type>>;
  ne?: InputMaybe<Identity_Document_Type>;
  nin?: InputMaybe<Array<Identity_Document_Type>>;
};

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}

export type ResultList = {
  __typename?: 'resultList';
  resultName: Scalars['String']['output'];
  resultValue: Scalars['String']['output'];
};

export type CreateDsrcAdmissionMutationVariables = Exact<{
  input: CreateDsrcAdmissionInput;
}>;


export type CreateDsrcAdmissionMutation = { __typename?: 'Mutation', createDSRCAdmission: { __typename?: 'DSRCAdmissionPayload', _id: string } };

export type GetAdmissionStepDataQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  entryYear: Scalars['String']['input'];
  nominationFilter: NominationFilter;
  assessmentFilter: AssessmentFilter;
}>;


export type GetAdmissionStepDataQuery = { __typename?: 'Query', preliminaryCheck?: { __typename?: 'PreliminaryCheckModel', rules: Array<{ __typename?: 'PreliminaryCheckRule', programmeLevel: Programme, duration?: number | null, version: number, result?: OfferSuggestion | null, checkRule?: Array<{ __typename?: 'CheckDetail', item: PreliminaryCheckItem, result: PreliminaryCheckResult }> | null }> } | null, entryYearInformation?: { __typename?: 'EntryYearPayload', registrationDeadline: any } | null, application: { __typename?: 'ApplicationPayload', programmeChoice?: { __typename?: 'ProgrammeChoicePayload', studyMode?: Programme_Choice_Study_Mode | null } | null }, nominations?: Array<{ __typename?: 'NominationPayload', admission?: { __typename?: 'Admission', programme: string, requirements: { __typename?: 'Requirements', generalEntranceRequirements: Array<{ __typename?: 'GeneralEntranceRequirement', requirements: string, fulfilled?: boolean | null }>, englishLanguageRequirements?: Array<{ __typename?: 'EnglishLanguageRequirement', requirements: string, fulfilled?: boolean | null } | null> | null } } | null, fundings?: Array<{ __typename?: 'Funding', schema: Funding_Schema, source?: Funding_Source | null }> | null, supervisors: Array<{ __typename?: 'Supervisors', isDrcChair?: boolean | null, isDoRPgS?: boolean | null }> }> | null, dsrcAdmission?: { __typename?: 'DSRCAdmissionPayload', applicationId?: string | null, dsrcDecision?: Dsrc_Decision_Type | null, remarks?: string | null, isFirmOffer?: boolean | null, conditions?: Array<EntranceRequirement> | null, plagiarismCheck?: boolean | null, plagiarismFound?: boolean | null, entranceRequirementWaive?: boolean | null, stipendApproval?: boolean | null, rejectionRemarks?: string | null, supervisorAccountCodes?: Array<string> | null, tuitionAssistantshipType?: TuitionAssistantship | null, tuitionFeeAccountCode?: string | null, confirmationChairInTeam?: boolean | null, confirmationDoRPgSInTeam?: boolean | null, contactDepartmentPersonName?: string | null, contactDepartmentPersonEmail?: string | null, contactDepartmentPersonPhone?: string | null, conditionFulfillingDeadline?: any | null, conditionDetails?: Array<{ __typename?: 'ConditionDetail', requirement: EntranceRequirement, detail?: string | null }> | null } | null };

export type UpdateDsrcAdmissionMutationVariables = Exact<{
  input: UpdateDsrcAdmissionInput;
}>;


export type UpdateDsrcAdmissionMutation = { __typename?: 'Mutation', updateDSRCAdmission: { __typename?: 'DSRCAdmissionPayload', applicationId?: string | null } };


export const CreateDsrcAdmissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createDSRCAdmission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDSRCAdmissionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDSRCAdmission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<CreateDsrcAdmissionMutation, CreateDsrcAdmissionMutationVariables>;
export const GetAdmissionStepDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdmissionStepData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"applicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entryYear"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nominationFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NominationFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assessmentFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preliminaryCheck"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"applicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"applicationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programmeLevel"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"checkRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entryYearInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entryYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entryYear"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationDeadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"application"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"applicationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programmeChoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studyMode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nominations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nominationFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"admission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programme"}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalEntranceRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirements"}},{"kind":"Field","name":{"kind":"Name","value":"fulfilled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"englishLanguageRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirements"}},{"kind":"Field","name":{"kind":"Name","value":"fulfilled"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schema"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supervisors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDrcChair"}},{"kind":"Field","name":{"kind":"Name","value":"isDoRPgS"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dsrcAdmission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assessmentFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationId"}},{"kind":"Field","name":{"kind":"Name","value":"dsrcDecision"}},{"kind":"Field","name":{"kind":"Name","value":"remarks"}},{"kind":"Field","name":{"kind":"Name","value":"isFirmOffer"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"conditionDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirement"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plagiarismCheck"}},{"kind":"Field","name":{"kind":"Name","value":"plagiarismFound"}},{"kind":"Field","name":{"kind":"Name","value":"entranceRequirementWaive"}},{"kind":"Field","name":{"kind":"Name","value":"stipendApproval"}},{"kind":"Field","name":{"kind":"Name","value":"rejectionRemarks"}},{"kind":"Field","name":{"kind":"Name","value":"supervisorAccountCodes"}},{"kind":"Field","name":{"kind":"Name","value":"tuitionAssistantshipType"}},{"kind":"Field","name":{"kind":"Name","value":"tuitionFeeAccountCode"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationChairInTeam"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationDoRPgSInTeam"}},{"kind":"Field","name":{"kind":"Name","value":"contactDepartmentPersonName"}},{"kind":"Field","name":{"kind":"Name","value":"contactDepartmentPersonEmail"}},{"kind":"Field","name":{"kind":"Name","value":"contactDepartmentPersonPhone"}},{"kind":"Field","name":{"kind":"Name","value":"conditionFulfillingDeadline"}}]}}]}}]} as unknown as DocumentNode<GetAdmissionStepDataQuery, GetAdmissionStepDataQueryVariables>;
export const UpdateDsrcAdmissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDSRCAdmission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDSRCAdmissionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDSRCAdmission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationId"}}]}}]}}]} as unknown as DocumentNode<UpdateDsrcAdmissionMutation, UpdateDsrcAdmissionMutationVariables>;